export const tpaFirmName = {
  type: 'dropdown',
  name: 'tpaFirmName',
  user: {},
  label: 'TPA firm name',
  required: true,
  dirty: false,
  disabled: false,
  value: '',
  hasError: false,
  placeholder: 'Start typing or select..',
  options: [
    {
      id: 1,
      tpaID: '823719843',
      tpaName: 'FUTUREPLAN BY ASCENSUS',
      label: 'FUTUREPLAN BY ASCENSUS',
      value: 'FUTUREPLAN BY ASCENSUS',
      planCount: 1235,
      selected: false,
      assets: '3,159,880,219.00',
    },
    {
      id: 2,
      tpaID: '391816008',
      tpaName: 'THE RETIREMENT ADVANTAGE INC',
      label: 'THE RETIREMENT ADVANTAGE INC',
      value: 'THE RETIREMENT ADVANTAGE INC',
      planCount: 1788,
      selected: false,
      assets: '2,443,043,536.66',
    },
    {
      id: 3,
      tpaID: '201054428',
      tpaName: 'ACTUARIAL BENEFITS CORPORATION',
      label: 'ACTUARIAL BENEFITS CORPORATION',
      value: 'ACTUARIAL BENEFITS CORPORATION',
      planCount: 100,
      selected: false,
      assets: '1,486,476,768.73',
    },
    {
      id: 4,
      tpaID: '364877979',
      tpaName: 'ORENDA RETIREMENT, LLC',
      label: 'ORENDA RETIREMENT, LLC',
      value: 'ORENDA RETIREMENT, LLC',
      planCount: 239,
      selected: false,
      assets: '1,186,515,496.50',
    },
    {
      id: 5,
      tpaID: '134144565',
      tpaName: 'THE BENEFIT PRACTICE',
      label: 'THE BENEFIT PRACTICE',
      value: 'THE BENEFIT PRACTICE',
      planCount: 239,
      selected: false,
      assets: '1,083,149,826.29',
    },
    {
      id: 6,
      tpaID: '042530412',
      tpaName: 'THE ANGELL PENSION GROUP INC',
      label: 'THE ANGELL PENSION GROUP INC',
      value: 'THE ANGELL PENSION GROUP INC',
      planCount: 114,
      selected: false,
      assets: '1,071,434,039.97',
    },
    {
      id: 7,
      tpaID: '201181458',
      tpaName: 'NOVA 401K ASSOCIATES',
      label: 'NOVA 401K ASSOCIATES',
      value: 'NOVA 401K ASSOCIATES',
      planCount: 807,
      selected: false,
      assets: '1,053,581,506.57',
    },
    {
      id: 8,
      tpaID: '272037969',
      tpaName: 'NEWPORT GROUP INC',
      label: 'NEWPORT GROUP INC',
      value: 'NEWPORT GROUP INC',
      planCount: 287,
      selected: false,
      assets: '1,042,593,724.30',
    },
    {
      id: 9,
      tpaID: '410955056',
      tpaName: 'TAX SHELTERED COMPENSATION INC',
      label: 'TAX SHELTERED COMPENSATION INC',
      value: 'TAX SHELTERED COMPENSATION INC',
      planCount: 202,
      selected: false,
      assets: '693,164,361.81',
    },
    {
      id: 10,
      tpaID: '113271022',
      tpaName: 'ASSOCIATED PENSION CONSULTANTS (NY)',
      label: 'ASSOCIATED PENSION CONSULTANTS (NY)',
      value: 'ASSOCIATED PENSION CONSULTANTS (NY)',
      planCount: 349,
      selected: false,
      assets: '683,809,087.79',
    },
    {
      id: 11,
      tpaID: '461224594',
      tpaName: 'PRIME PENSIONS INC',
      label: 'PRIME PENSIONS INC',
      value: 'PRIME PENSIONS INC',
      planCount: 320,
      selected: false,
      assets: '673,146,729.58',
    },
    {
      id: 12,
      tpaID: '204780677',
      tpaName: 'THE MANDMARBLESTONE GROUP LLC',
      label: 'THE MANDMARBLESTONE GROUP LLC',
      value: 'THE MANDMARBLESTONE GROUP LLC',
      planCount: 105,
      selected: false,
      assets: '536,099,737.10',
    },
    {
      id: 13,
      tpaID: '760500416',
      tpaName: 'ALLIANCE BENEFIT GROUP OF HOUSTON',
      label: 'ALLIANCE BENEFIT GROUP OF HOUSTON',
      value: 'ALLIANCE BENEFIT GROUP OF HOUSTON',
      planCount: 153,
      selected: false,
      assets: '524,981,376.73',
    },
    {
      id: 14,
      tpaID: '261570786',
      tpaName: 'PENSION PLAN SPECIALISTS PC',
      label: 'PENSION PLAN SPECIALISTS PC',
      value: 'PENSION PLAN SPECIALISTS PC',
      planCount: 207,
      selected: false,
      assets: '510,017,277.87',
    },
    {
      id: 15,
      tpaID: '741537058',
      tpaName: 'LOREN D STARK COMPANY INC',
      label: 'LOREN D STARK COMPANY INC',
      value: 'LOREN D STARK COMPANY INC',
      planCount: 294,
      selected: false,
      assets: '478,618,883.20',
    },
    {
      id: 16,
      tpaID: '364430093',
      tpaName: 'HUNTER BENEFITS CONSULTING GROUP INC',
      label: 'HUNTER BENEFITS CONSULTING GROUP INC',
      value: 'HUNTER BENEFITS CONSULTING GROUP INC',
      planCount: 51,
      selected: false,
      assets: '456,346,449.70',
    },
    {
      id: 17,
      tpaID: '521053785',
      tpaName: 'COASTAL PENSION SERVICES INC',
      label: 'COASTAL PENSION SERVICES INC',
      value: 'COASTAL PENSION SERVICES INC',
      planCount: 107,
      selected: false,
      assets: '431,391,891.95',
    },
    {
      id: 18,
      tpaID: '233044062',
      tpaName: 'THE PARAGON ALLIANCE GROUP LLC',
      label: 'THE PARAGON ALLIANCE GROUP LLC',
      value: 'THE PARAGON ALLIANCE GROUP LLC',
      planCount: 52,
      selected: false,
      assets: '426,894,587.95',
    },
    {
      id: 19,
      tpaID: '363592542',
      tpaName: 'THE PENSION SPECIALISTS LTD',
      label: 'THE PENSION SPECIALISTS LTD',
      value: 'THE PENSION SPECIALISTS LTD',
      planCount: 264,
      selected: false,
      assets: '420,973,945.89',
    },
    {
      id: 20,
      tpaID: '200223513',
      tpaName: 'QUALIFIED PLAN CONSULTANTS',
      label: 'QUALIFIED PLAN CONSULTANTS',
      value: 'QUALIFIED PLAN CONSULTANTS',
      planCount: 173,
      selected: false,
      assets: '409,530,673.77',
    },
    {
      id: 21,
      tpaID: '203886993',
      tpaName: 'NATIONAL BENEFIT SERVICES LLC (UT)',
      label: 'NATIONAL BENEFIT SERVICES LLC (UT)',
      value: 'NATIONAL BENEFIT SERVICES LLC (UT)',
      planCount: 82,
      selected: false,
      assets: '393,868,983.71',
    },
    {
      id: 22,
      tpaID: '204548831',
      tpaName: 'TRINITY PENSION CONSULTANTS INC',
      label: 'TRINITY PENSION CONSULTANTS INC',
      value: 'TRINITY PENSION CONSULTANTS INC',
      planCount: 195,
      selected: false,
      assets: '388,313,571.16',
    },
    {
      id: 23,
      tpaID: '942158860',
      tpaName: 'CENTRAL ADMINISTRATIVE SERVICES INC. (HICKS PENSION)',
      label: 'CENTRAL ADMINISTRATIVE SERVICES INC. (HICKS PENSION)',
      value: 'CENTRAL ADMINISTRATIVE SERVICES INC. (HICKS PENSION)',
      planCount: 388,
      selected: false,
      assets: '386,832,160.63',
    },
    {
      id: 24,
      tpaID: '470617162',
      tpaName: 'BENEFIT PLANS INC',
      label: 'BENEFIT PLANS INC',
      value: 'BENEFIT PLANS INC',
      planCount: 90,
      selected: false,
      assets: '360,643,612.25',
    },
    {
      id: 25,
      tpaID: '431829594',
      tpaName: 'BENEFIT PLANS PLUS LLC',
      label: 'BENEFIT PLANS PLUS LLC',
      value: 'BENEFIT PLANS PLUS LLC',
      planCount: 102,
      selected: false,
      assets: '343,961,424.37',
    },
    {
      id: 26,
      tpaID: '161186135',
      tpaName: 'ACTUARIAL CONSULTING SERVICES INC',
      label: 'ACTUARIAL CONSULTING SERVICES INC',
      value: 'ACTUARIAL CONSULTING SERVICES INC',
      planCount: 101,
      selected: false,
      assets: '338,835,055.87',
    },
    {
      id: 27,
      tpaID: '510383217',
      tpaName: 'LIMESTONE PENSION ASSOCIATES LLC',
      label: 'LIMESTONE PENSION ASSOCIATES LLC',
      value: 'LIMESTONE PENSION ASSOCIATES LLC',
      planCount: 105,
      selected: false,
      assets: '334,336,014.69',
    },
    {
      id: 28,
      tpaID: '850833363',
      tpaName: 'DEFINITI LLC',
      label: 'DEFINITI LLC',
      value: 'DEFINITI LLC',
      planCount: 150,
      selected: false,
      assets: '314,811,610.43',
    },
    {
      id: 29,
      tpaID: '311582098',
      tpaName: 'CBIZ BENEFITS & INSURANCE SERVICES INC',
      label: 'CBIZ BENEFITS & INSURANCE SERVICES INC',
      value: 'CBIZ BENEFITS & INSURANCE SERVICES INC',
      planCount: 91,
      selected: false,
      assets: '310,857,364.58',
    },
    {
      id: 30,
      tpaID: '133532742',
      tpaName: 'ADVANTAGE BENEFITS CONSULTANTS INC',
      label: 'ADVANTAGE BENEFITS CONSULTANTS INC',
      value: 'ADVANTAGE BENEFITS CONSULTANTS INC',
      planCount: 35,
      selected: false,
      assets: '295,524,409.11',
    },
    {
      id: 31,
      tpaID: '222446239',
      tpaName: 'INTAC ACTUARIAL SERVICES INC',
      label: 'INTAC ACTUARIAL SERVICES INC',
      value: 'INTAC ACTUARIAL SERVICES INC',
      planCount: 107,
      selected: false,
      assets: '295,249,608.33',
    },
    {
      id: 32,
      tpaID: '522204662',
      tpaName: 'PRIME BENEFITS INC.',
      label: 'PRIME BENEFITS INC.',
      value: 'PRIME BENEFITS INC.',
      planCount: 90,
      selected: false,
      assets: '291,092,933.24',
    },
    {
      id: 33,
      tpaID: '272487837',
      tpaName: 'PA RETIREMENT SOLUTIONS INC',
      label: 'PA RETIREMENT SOLUTIONS INC',
      value: 'PA RETIREMENT SOLUTIONS INC',
      planCount: 75,
      selected: false,
      assets: '287,396,125.94',
    },
    {
      id: 34,
      tpaID: '133010201',
      tpaName: 'DANZIGER & MARKHOFF LLP',
      label: 'DANZIGER & MARKHOFF LLP',
      value: 'DANZIGER & MARKHOFF LLP',
      planCount: 42,
      selected: false,
      assets: '272,255,993.53',
    },
    {
      id: 35,
      tpaID: '232376356',
      tpaName: 'R J HALL COMPANY INC',
      label: 'R J HALL COMPANY INC',
      value: 'R J HALL COMPANY INC',
      planCount: 82,
      selected: false,
      assets: '268,762,457.61',
    },
    {
      id: 36,
      tpaID: '931160402',
      tpaName: 'PENSION PLANNERS NORTHWEST',
      label: 'PENSION PLANNERS NORTHWEST',
      value: 'PENSION PLANNERS NORTHWEST',
      planCount: 22,
      selected: false,
      assets: '263,862,093.06',
    },
    {
      id: 37,
      tpaID: '711039549',
      tpaName: 'JANET A. PANEBIANCO, CPA, PLLC',
      label: 'JANET A. PANEBIANCO, CPA, PLLC',
      value: 'JANET A. PANEBIANCO, CPA, PLLC',
      planCount: 142,
      selected: false,
      assets: '247,982,789.91',
    },
    {
      id: 38,
      tpaID: '133180178',
      tpaName: 'ECONOMIC GROUP PENSION SERVICES INC',
      label: 'ECONOMIC GROUP PENSION SERVICES INC',
      value: 'ECONOMIC GROUP PENSION SERVICES INC',
      planCount: 99,
      selected: false,
      assets: '232,624,214.21',
    },
    {
      id: 39,
      tpaID: '850402842',
      tpaName: 'PENSION PLANNING CONSULTANTS INC',
      label: 'PENSION PLANNING CONSULTANTS INC',
      value: 'PENSION PLANNING CONSULTANTS INC',
      planCount: 128,
      selected: false,
      assets: '232,272,564.80',
    },
    {
      id: 40,
      tpaID: '251650062',
      tpaName: 'DUNBAR BENDER & ZAPF INC',
      label: 'DUNBAR BENDER & ZAPF INC',
      value: 'DUNBAR BENDER & ZAPF INC',
      planCount: 90,
      selected: false,
      assets: '222,449,977.66',
    },
    {
      id: 41,
      tpaID: '581485803',
      tpaName: 'PENSION FINANCIAL SERVICES, INC.',
      label: 'PENSION FINANCIAL SERVICES, INC.',
      value: 'PENSION FINANCIAL SERVICES, INC.',
      planCount: 65,
      selected: false,
      assets: '217,455,366.04',
    },
    {
      id: 42,
      tpaID: '222725182',
      tpaName: 'RIMKUS MARCIANO & ASSOCIATES INC',
      label: 'RIMKUS MARCIANO & ASSOCIATES INC',
      value: 'RIMKUS MARCIANO & ASSOCIATES INC',
      planCount: 50,
      selected: false,
      assets: '211,038,566.87',
    },
    {
      id: 43,
      tpaID: '621038805',
      tpaName: 'RETIREMENT PLANNERS AND ADMINISTRATORS INC',
      label: 'RETIREMENT PLANNERS AND ADMINISTRATORS INC',
      value: 'RETIREMENT PLANNERS AND ADMINISTRATORS INC',
      planCount: 90,
      selected: false,
      assets: '193,757,372.51',
    },
    {
      id: 44,
      tpaID: '273853858',
      tpaName: 'LEGACY RETIREMENT SOLUTIONS LLC',
      label: 'LEGACY RETIREMENT SOLUTIONS LLC',
      value: 'LEGACY RETIREMENT SOLUTIONS LLC',
      planCount: 94,
      selected: false,
      assets: '193,740,058.75',
    },
    {
      id: 45,
      tpaID: '150395735',
      tpaName: 'NBT BANK, N.A.',
      label: 'NBT BANK, N.A.',
      value: 'NBT BANK, N.A.',
      planCount: 51,
      selected: false,
      assets: '191,819,653.65',
    },
    {
      id: 46,
      tpaID: '363533281',
      tpaName: 'THE BENEFITS CONSULTING GROUP INC',
      label: 'THE BENEFITS CONSULTING GROUP INC',
      value: 'THE BENEFITS CONSULTING GROUP INC',
      planCount: 41,
      selected: false,
      assets: '183,718,614.93',
    },
    {
      id: 47,
      tpaID: '582365498',
      tpaName: 'RETIREMENT PLAN ADMINISTRATORS',
      label: 'RETIREMENT PLAN ADMINISTRATORS',
      value: 'RETIREMENT PLAN ADMINISTRATORS',
      planCount: 24,
      selected: false,
      assets: '181,969,123.09',
    },
    {
      id: 48,
      tpaID: '942269337',
      tpaName: 'BENETECH INC',
      label: 'BENETECH INC',
      value: 'BENETECH INC',
      planCount: 150,
      selected: false,
      assets: '179,924,935.42',
    },
    {
      id: 49,
      tpaID: '821371994',
      tpaName: 'LATITUDE SERVICE COMPANY, INC.',
      label: 'LATITUDE SERVICE COMPANY, INC.',
      value: 'LATITUDE SERVICE COMPANY, INC.',
      planCount: 35,
      selected: false,
      assets: '178,895,530.44',
    },
    {
      id: 50,
      tpaID: '263723532',
      tpaName: 'RETIREMENT LLC',
      label: 'RETIREMENT LLC',
      value: 'RETIREMENT LLC',
      planCount: 66,
      selected: false,
      assets: '175,363,853.05',
    },
    {
      id: 51,
      tpaID: '061504963',
      tpaName: 'PENSION CONSULTANTS INC (CT)',
      label: 'PENSION CONSULTANTS INC (CT)',
      value: 'PENSION CONSULTANTS INC (CT)',
      planCount: 45,
      selected: false,
      assets: '174,282,560.55',
    },
    {
      id: 52,
      tpaID: '204795685',
      tpaName: 'COMPASS RETIREMENT CONSULTING GROUP',
      label: 'COMPASS RETIREMENT CONSULTING GROUP',
      value: 'COMPASS RETIREMENT CONSULTING GROUP',
      planCount: 97,
      selected: false,
      assets: '169,579,418.73',
    },
    {
      id: 53,
      tpaID: '260228640',
      tpaName: 'WELLS THOMAS, LLC',
      label: 'WELLS THOMAS, LLC',
      value: 'WELLS THOMAS, LLC',
      planCount: 101,
      selected: false,
      assets: '168,985,468.81',
    },
    {
      id: 54,
      tpaID: '953497679',
      tpaName: 'TRUOG-RYDING COMPANY INC',
      label: 'TRUOG-RYDING COMPANY INC',
      value: 'TRUOG-RYDING COMPANY INC',
      planCount: 47,
      selected: false,
      assets: '166,539,200.24',
    },
    {
      id: 55,
      tpaID: '311299207',
      tpaName: 'CREATIVE RETIREMENT SYSTEMS, INC',
      label: 'CREATIVE RETIREMENT SYSTEMS, INC',
      value: 'CREATIVE RETIREMENT SYSTEMS, INC',
      planCount: 87,
      selected: false,
      assets: '165,369,569.40',
    },
    {
      id: 56,
      tpaID: '232942715',
      tpaName: 'ATLANTIC PENSION SERVICES INC',
      label: 'ATLANTIC PENSION SERVICES INC',
      value: 'ATLANTIC PENSION SERVICES INC',
      planCount: 56,
      selected: false,
      assets: '163,928,261.46',
    },
    {
      id: 57,
      tpaID: '232773128',
      tpaName: 'N A FALCONE & ASSOCIATES INC',
      label: 'N A FALCONE & ASSOCIATES INC',
      value: 'N A FALCONE & ASSOCIATES INC',
      planCount: 20,
      selected: false,
      assets: '162,618,238.46',
    },
    {
      id: 58,
      tpaID: '391623968',
      tpaName: 'PENSION INC',
      label: 'PENSION INC',
      value: 'PENSION INC',
      planCount: 36,
      selected: false,
      assets: '162,370,687.04',
    },
    {
      id: 59,
      tpaID: '383254950',
      tpaName: 'THE BENEFIT ADVANTAGE INC',
      label: 'THE BENEFIT ADVANTAGE INC',
      value: 'THE BENEFIT ADVANTAGE INC',
      planCount: 90,
      selected: false,
      assets: '161,428,086.58',
    },
    {
      id: 60,
      tpaID: '350966414',
      tpaName: 'THE NYHART CO INC',
      label: 'THE NYHART CO INC',
      value: 'THE NYHART CO INC',
      planCount: 20,
      selected: false,
      assets: '160,529,552.53',
    },
    {
      id: 61,
      tpaID: '454208939',
      tpaName: 'PLANNED RETIREMENT CONSULTANTS & ADMINISTRATORS, L',
      label: 'PLANNED RETIREMENT CONSULTANTS & ADMINISTRATORS, L',
      value: 'PLANNED RETIREMENT CONSULTANTS & ADMINISTRATORS, L',
      planCount: 79,
      selected: false,
      assets: '159,633,157.03',
    },
    {
      id: 62,
      tpaID: '330785439',
      tpaName: 'ALLIANT INSURANCE SERVICES, INC.',
      label: 'ALLIANT INSURANCE SERVICES, INC.',
      value: 'ALLIANT INSURANCE SERVICES, INC.',
      planCount: 32,
      selected: false,
      assets: '158,562,059.71',
    },
    {
      id: 63,
      tpaID: '364517541',
      tpaName: 'UB PENSIONS',
      label: 'UB PENSIONS',
      value: 'UB PENSIONS',
      planCount: 93,
      selected: false,
      assets: '158,176,779.20',
    },
    {
      id: 64,
      tpaID: '454012897',
      tpaName: 'MAXUS PLAN SOLUTIONS INC',
      label: 'MAXUS PLAN SOLUTIONS INC',
      value: 'MAXUS PLAN SOLUTIONS INC',
      planCount: 130,
      selected: false,
      assets: '157,935,517.47',
    },
    {
      id: 65,
      tpaID: '311560462',
      tpaName: 'RETIREMENT MANAGEMENT SERVICES, LLC',
      label: 'RETIREMENT MANAGEMENT SERVICES, LLC',
      value: 'RETIREMENT MANAGEMENT SERVICES, LLC',
      planCount: 16,
      selected: false,
      assets: '149,983,517.21',
    },
    {
      id: 66,
      tpaID: '382658667',
      tpaName: 'THE OLDENBURG COMPANY INC',
      label: 'THE OLDENBURG COMPANY INC',
      value: 'THE OLDENBURG COMPANY INC',
      planCount: 33,
      selected: false,
      assets: '147,155,756.42',
    },
    {
      id: 67,
      tpaID: '621477251',
      tpaName: 'ACUFF & ASSOCIATES',
      label: 'ACUFF & ASSOCIATES',
      value: 'ACUFF & ASSOCIATES',
      planCount: 40,
      selected: false,
      assets: '144,463,669.38',
    },
    {
      id: 68,
      tpaID: '382438760',
      tpaName: 'GREAT LAKES PENSION ASSOCIATES INC',
      label: 'GREAT LAKES PENSION ASSOCIATES INC',
      value: 'GREAT LAKES PENSION ASSOCIATES INC',
      planCount: 57,
      selected: false,
      assets: '143,378,955.86',
    },
    {
      id: 69,
      tpaID: '261407927',
      tpaName: 'PASI LLC',
      label: 'PASI LLC',
      value: 'PASI LLC',
      planCount: 53,
      selected: false,
      assets: '138,347,196.75',
    },
    {
      id: 70,
      tpaID: '251541083',
      tpaName: 'METRO BENEFITS INC',
      label: 'METRO BENEFITS INC',
      value: 'METRO BENEFITS INC',
      planCount: 48,
      selected: false,
      assets: '138,343,342.07',
    },
    {
      id: 71,
      tpaID: '330499726',
      tpaName: 'PENSION BENEFITS UNLIMITED INC',
      label: 'PENSION BENEFITS UNLIMITED INC',
      value: 'PENSION BENEFITS UNLIMITED INC',
      planCount: 22,
      selected: false,
      assets: '138,292,992.32',
    },
    {
      id: 72,
      tpaID: '943322438',
      tpaName: 'FARMER & BETTS, INC',
      label: 'FARMER & BETTS, INC',
      value: 'FARMER & BETTS, INC',
      planCount: 190,
      selected: false,
      assets: '136,747,519.69',
    },
    {
      id: 73,
      tpaID: '861001235',
      tpaName: 'MATTHEWS, GOLD, KENNEDY & SNOW INC',
      label: 'MATTHEWS, GOLD, KENNEDY & SNOW INC',
      value: 'MATTHEWS, GOLD, KENNEDY & SNOW INC',
      planCount: 42,
      selected: false,
      assets: '135,715,822.41',
    },
    {
      id: 74,
      tpaID: '621200951',
      tpaName: 'ERISA SERVICES INC',
      label: 'ERISA SERVICES INC',
      value: 'ERISA SERVICES INC',
      planCount: 58,
      selected: false,
      assets: '135,217,710.53',
    },
    {
      id: 75,
      tpaID: '770586222',
      tpaName: 'NEXUS ADMINISTRATORS, INC.',
      label: 'NEXUS ADMINISTRATORS, INC.',
      value: 'NEXUS ADMINISTRATORS, INC.',
      planCount: 45,
      selected: false,
      assets: '134,550,800.23',
    },
    {
      id: 76,
      tpaID: '410746749',
      tpaName: 'CLIFTONLARSONALLEN LLP',
      label: 'CLIFTONLARSONALLEN LLP',
      value: 'CLIFTONLARSONALLEN LLP',
      planCount: 23,
      selected: false,
      assets: '133,122,103.24',
    },
    {
      id: 77,
      tpaID: '271575470',
      tpaName: 'RETIREMENT PLAN ASSOCIATES INC',
      label: 'RETIREMENT PLAN ASSOCIATES INC',
      value: 'RETIREMENT PLAN ASSOCIATES INC',
      planCount: 105,
      selected: false,
      assets: '132,043,630.78',
    },
    {
      id: 78,
      tpaID: '222755716',
      tpaName: 'RED BANK PENSION SERVICES INC',
      label: 'RED BANK PENSION SERVICES INC',
      value: 'RED BANK PENSION SERVICES INC',
      planCount: 59,
      selected: false,
      assets: '131,349,697.81',
    },
    {
      id: 79,
      tpaID: '942456320',
      tpaName: 'ASSOCIATED PENSION CONSULTANTS (CA)',
      label: 'ASSOCIATED PENSION CONSULTANTS (CA)',
      value: 'ASSOCIATED PENSION CONSULTANTS (CA)',
      planCount: 78,
      selected: false,
      assets: '130,890,860.63',
    },
    {
      id: 80,
      tpaID: '134096969',
      tpaName: 'NFP CORPORATE SERVICES INC',
      label: 'NFP CORPORATE SERVICES INC',
      value: 'NFP CORPORATE SERVICES INC',
      planCount: 13,
      selected: false,
      assets: '128,769,259.71',
    },
    {
      id: 81,
      tpaID: '540737372',
      tpaName: 'PBMARES, LLP',
      label: 'PBMARES, LLP',
      value: 'PBMARES, LLP',
      planCount: 15,
      selected: false,
      assets: '128,111,234.62',
    },
    {
      id: 82,
      tpaID: '383220894',
      tpaName: 'MICHIGAN BENEFIT CONSULTING INC',
      label: 'MICHIGAN BENEFIT CONSULTING INC',
      value: 'MICHIGAN BENEFIT CONSULTING INC',
      planCount: 15,
      selected: false,
      assets: '127,430,590.68',
    },
    {
      id: 83,
      tpaID: '341310124',
      tpaName: 'REA & ASSOCIATES, INC.',
      label: 'REA & ASSOCIATES, INC.',
      value: 'REA & ASSOCIATES, INC.',
      planCount: 47,
      selected: false,
      assets: '125,114,211.18',
    },
    {
      id: 84,
      tpaID: '581392124',
      tpaName: 'SWERDLIN & COMPANY',
      label: 'SWERDLIN & COMPANY',
      value: 'SWERDLIN & COMPANY',
      planCount: 17,
      selected: false,
      assets: '124,786,535.07',
    },
    {
      id: 85,
      tpaID: '205923747',
      tpaName: 'PAYCHEX INC DBA SOUTHEASTERN EMPLOYEE BENEFIT SERVICES',
      label: 'PAYCHEX INC DBA SOUTHEASTERN EMPLOYEE BENEFIT SERVICES',
      value: 'PAYCHEX INC DBA SOUTHEASTERN EMPLOYEE BENEFIT SERVICES',
      planCount: 51,
      selected: false,
      assets: '121,223,369.51',
    },
    {
      id: 86,
      tpaID: '141624930',
      tpaName: 'TEAL BECKER & CHIARAMONTE CPAS PC',
      label: 'TEAL BECKER & CHIARAMONTE CPAS PC',
      value: 'TEAL BECKER & CHIARAMONTE CPAS PC',
      planCount: 33,
      selected: false,
      assets: '119,041,864.34',
    },
    {
      id: 87,
      tpaID: '382444337',
      tpaName: 'KUSHNER & COMPANY INC',
      label: 'KUSHNER & COMPANY INC',
      value: 'KUSHNER & COMPANY INC',
      planCount: 25,
      selected: false,
      assets: '117,198,711.01',
    },
    {
      id: 88,
      tpaID: '954171622',
      tpaName: 'ALLIED CONSULTANTS INC',
      label: 'ALLIED CONSULTANTS INC',
      value: 'ALLIED CONSULTANTS INC',
      planCount: 101,
      selected: false,
      assets: '111,744,929.55',
    },
    {
      id: 89,
      tpaID: '842276766',
      tpaName: 'CREATIVE RETIREMENT PLAN CONSULTING, LLC',
      label: 'CREATIVE RETIREMENT PLAN CONSULTING, LLC',
      value: 'CREATIVE RETIREMENT PLAN CONSULTING, LLC',
      planCount: 14,
      selected: false,
      assets: '111,609,440.88',
    },
    {
      id: 90,
      tpaID: '050460654',
      tpaName: 'ABACUS BENEFIT CONSULTANTS INC',
      label: 'ABACUS BENEFIT CONSULTANTS INC',
      value: 'ABACUS BENEFIT CONSULTANTS INC',
      planCount: 38,
      selected: false,
      assets: '109,352,586.37',
    },
    {
      id: 91,
      tpaID: '352015845',
      tpaName: 'AMERICAN PENSION ADVISORS LTD',
      label: 'AMERICAN PENSION ADVISORS LTD',
      value: 'AMERICAN PENSION ADVISORS LTD',
      planCount: 66,
      selected: false,
      assets: '108,422,556.78',
    },
    {
      id: 92,
      tpaID: '930998477',
      tpaName: 'PROFESSIONAL BENEFIT SERVICES, INC',
      label: 'PROFESSIONAL BENEFIT SERVICES, INC',
      value: 'PROFESSIONAL BENEFIT SERVICES, INC',
      planCount: 83,
      selected: false,
      assets: '107,438,151.07',
    },
    {
      id: 93,
      tpaID: '134271932',
      tpaName: 'RETIREMENT PLAN CONSULTANTS, INC.',
      label: 'RETIREMENT PLAN CONSULTANTS, INC.',
      value: 'RETIREMENT PLAN CONSULTANTS, INC.',
      planCount: 20,
      selected: false,
      assets: '106,880,450.01',
    },
    {
      id: 94,
      tpaID: '133601506',
      tpaName: 'UNIGLOBAL PENSION PLANNING INC',
      label: 'UNIGLOBAL PENSION PLANNING INC',
      value: 'UNIGLOBAL PENSION PLANNING INC',
      planCount: 37,
      selected: false,
      assets: '105,176,524.09',
    },
    {
      id: 95,
      tpaID: '251802421',
      tpaName: 'CAPITAL RETIREMENT PLAN SERVICES',
      label: 'CAPITAL RETIREMENT PLAN SERVICES',
      value: 'CAPITAL RETIREMENT PLAN SERVICES',
      planCount: 9,
      selected: false,
      assets: '104,971,900.66',
    },
    {
      id: 96,
      tpaID: '911072394',
      tpaName: 'HUNNEX AND SHOEMAKER INC',
      label: 'HUNNEX AND SHOEMAKER INC',
      value: 'HUNNEX AND SHOEMAKER INC',
      planCount: 55,
      selected: false,
      assets: '104,896,789.82',
    },
    {
      id: 97,
      tpaID: '931327877',
      tpaName: 'PREMIER RETIREMENT SERVICES INC',
      label: 'PREMIER RETIREMENT SERVICES INC',
      value: 'PREMIER RETIREMENT SERVICES INC',
      planCount: 23,
      selected: false,
      assets: '101,421,835.28',
    },
    {
      id: 98,
      tpaID: '330461574',
      tpaName: 'PEN FLEX INC',
      label: 'PEN FLEX INC',
      value: 'PEN FLEX INC',
      planCount: 67,
      selected: false,
      assets: '99,559,671.33',
    },
    {
      id: 99,
      tpaID: '813989034',
      tpaName: 'M2B RETIREMENT CONSULTING, LLC',
      label: 'M2B RETIREMENT CONSULTING, LLC',
      value: 'M2B RETIREMENT CONSULTING, LLC',
      planCount: 79,
      selected: false,
      assets: '99,529,513.07',
    },
    {
      id: 100,
      tpaID: '262091417',
      tpaName: 'DWC ERISA CONSULTANTS, LLC',
      label: 'DWC ERISA CONSULTANTS, LLC',
      value: 'DWC ERISA CONSULTANTS, LLC',
      planCount: 25,
      selected: false,
      assets: '99,227,185.60',
    },
    {
      id: 101,
      tpaID: '364212397',
      tpaName: 'ADMINISTRATIVE RETIREMENT SERVICES INC',
      label: 'ADMINISTRATIVE RETIREMENT SERVICES INC',
      value: 'ADMINISTRATIVE RETIREMENT SERVICES INC',
      planCount: 13,
      selected: false,
      assets: '97,830,604.62',
    },
    {
      id: 102,
      tpaID: '383478073',
      tpaName: 'KDP RETIREMENT PLAN SERVICES INC',
      label: 'KDP RETIREMENT PLAN SERVICES INC',
      value: 'KDP RETIREMENT PLAN SERVICES INC',
      planCount: 21,
      selected: false,
      assets: '95,866,696.09',
    },
    {
      id: 103,
      tpaID: '942936206',
      tpaName: 'PLAN DESIGN CONSULTANTS INC',
      label: 'PLAN DESIGN CONSULTANTS INC',
      value: 'PLAN DESIGN CONSULTANTS INC',
      planCount: 79,
      selected: false,
      assets: '95,349,697.54',
    },
    {
      id: 104,
      tpaID: '640936231',
      tpaName: 'DYATECH LLC',
      label: 'DYATECH LLC',
      value: 'DYATECH LLC',
      planCount: 129,
      selected: false,
      assets: '94,309,924.41',
    },
    {
      id: 105,
      tpaID: '221915571',
      tpaName: 'CONSULTING ACTUARIES INC',
      label: 'CONSULTING ACTUARIES INC',
      value: 'CONSULTING ACTUARIES INC',
      planCount: 29,
      selected: false,
      assets: '91,300,524.23',
    },
    {
      id: 106,
      tpaID: '391967492',
      tpaName: 'NATIONAL ADMINISTRATION, INC.',
      label: 'NATIONAL ADMINISTRATION, INC.',
      value: 'NATIONAL ADMINISTRATION, INC.',
      planCount: 111,
      selected: false,
      assets: '90,585,847.55',
    },
    {
      id: 107,
      tpaID: '161316349',
      tpaName: 'ACTUARIAL PENSION ANALYSTS INC',
      label: 'ACTUARIAL PENSION ANALYSTS INC',
      value: 'ACTUARIAL PENSION ANALYSTS INC',
      planCount: 11,
      selected: false,
      assets: '89,884,628.30',
    },
    {
      id: 108,
      tpaID: '680198481',
      tpaName: 'BENEFIT RESOURCES INC (CA)',
      label: 'BENEFIT RESOURCES INC (CA)',
      value: 'BENEFIT RESOURCES INC (CA)',
      planCount: 21,
      selected: false,
      assets: '88,423,965.69',
    },
    {
      id: 109,
      tpaID: '943210526',
      tpaName: 'CARLSON, QUINN & ASSOCIATES, INC.',
      label: 'CARLSON, QUINN & ASSOCIATES, INC.',
      value: 'CARLSON, QUINN & ASSOCIATES, INC.',
      planCount: 3,
      selected: false,
      assets: '88,072,857.33',
    },
    {
      id: 110,
      tpaID: '133745616',
      tpaName: 'PENTEGRA SERVICES INC.',
      label: 'PENTEGRA SERVICES INC.',
      value: 'PENTEGRA SERVICES INC.',
      planCount: 22,
      selected: false,
      assets: '85,945,403.49',
    },
    {
      id: 111,
      tpaID: '223349752',
      tpaName: 'NORTHEAST PROFESSIONAL PLANNING GROUP, INC.',
      label: 'NORTHEAST PROFESSIONAL PLANNING GROUP, INC.',
      value: 'NORTHEAST PROFESSIONAL PLANNING GROUP, INC.',
      planCount: 20,
      selected: false,
      assets: '85,135,615.43',
    },
    {
      id: 112,
      tpaID: '030271340',
      tpaName: 'FUTURE PLANNING ASSOCIATES INC',
      label: 'FUTURE PLANNING ASSOCIATES INC',
      value: 'FUTURE PLANNING ASSOCIATES INC',
      planCount: 10,
      selected: false,
      assets: '84,906,595.03',
    },
    {
      id: 113,
      tpaID: '842409363',
      tpaName: 'ERP RETIREMENT SERVICES',
      label: 'ERP RETIREMENT SERVICES',
      value: 'ERP RETIREMENT SERVICES',
      planCount: 1,
      selected: false,
      assets: '',
    },
    {
      id: 114,
      tpaID: '203916180',
      tpaName: 'PROFIT PLANNERS LLC',
      label: 'PROFIT PLANNERS LLC',
      value: 'PROFIT PLANNERS LLC',
      planCount: 11,
      selected: false,
      assets: '82,429,951.29',
    },
    {
      id: 115,
      tpaID: '752776689',
      tpaName: 'PENTEC PENSION MANAGEMENT',
      label: 'PENTEC PENSION MANAGEMENT',
      value: 'PENTEC PENSION MANAGEMENT',
      planCount: 26,
      selected: false,
      assets: '81,984,921.78',
    },
    {
      id: 116,
      tpaID: '421064080',
      tpaName: 'PACO INC',
      label: 'PACO INC',
      value: 'PACO INC',
      planCount: 50,
      selected: false,
      assets: '80,434,065.64',
    },
    {
      id: 117,
      tpaID: '263253999',
      tpaName: 'CARDINAL PENSION GROUP INC',
      label: 'CARDINAL PENSION GROUP INC',
      value: 'CARDINAL PENSION GROUP INC',
      planCount: 16,
      selected: false,
      assets: '79,088,645.94',
    },
    {
      id: 118,
      tpaID: '620842964',
      tpaName: 'BURLEIGH CONSULTING GROUP INC',
      label: 'BURLEIGH CONSULTING GROUP INC',
      value: 'BURLEIGH CONSULTING GROUP INC',
      planCount: 22,
      selected: false,
      assets: '78,899,307.76',
    },
    {
      id: 119,
      tpaID: '391915811',
      tpaName: 'PPG RETIREMENT PLAN SERVICES, LTD.',
      label: 'PPG RETIREMENT PLAN SERVICES, LTD.',
      value: 'PPG RETIREMENT PLAN SERVICES, LTD.',
      planCount: 13,
      selected: false,
      assets: '78,619,673.08',
    },
    {
      id: 120,
      tpaID: '860710758',
      tpaName: 'ASSOCIATED PENSION ADMINISTRATORS, LTD',
      label: 'ASSOCIATED PENSION ADMINISTRATORS, LTD',
      value: 'ASSOCIATED PENSION ADMINISTRATORS, LTD',
      planCount: 111,
      selected: false,
      assets: '78,162,437.67',
    },
    {
      id: 121,
      tpaID: '640765749',
      tpaName: 'MARTIN MARTIN RANDALL & ASSOCIATES INC',
      label: 'MARTIN MARTIN RANDALL & ASSOCIATES INC',
      value: 'MARTIN MARTIN RANDALL & ASSOCIATES INC',
      planCount: 28,
      selected: false,
      assets: '77,684,606.36',
    },
    {
      id: 122,
      tpaID: '453569850',
      tpaName: 'FRANK PENSION CONSULTANTS LTD',
      label: 'FRANK PENSION CONSULTANTS LTD',
      value: 'FRANK PENSION CONSULTANTS LTD',
      planCount: 9,
      selected: false,
      assets: '77,655,613.38',
    },
    {
      id: 123,
      tpaID: '352091834',
      tpaName: 'RETIREMENT PLAN CONCEPTS & SERVICES INC',
      label: 'RETIREMENT PLAN CONCEPTS & SERVICES INC',
      value: 'RETIREMENT PLAN CONCEPTS & SERVICES INC',
      planCount: 39,
      selected: false,
      assets: '76,365,964.71',
    },
    {
      id: 124,
      tpaID: '680348235',
      tpaName: 'PENSYS INC',
      label: 'PENSYS INC',
      value: 'PENSYS INC',
      planCount: 22,
      selected: false,
      assets: '75,652,370.49',
    },
    {
      id: 125,
      tpaID: '112836994',
      tpaName: 'CHERNOFF DIAMOND & COMPANY LLC',
      label: 'CHERNOFF DIAMOND & COMPANY LLC',
      value: 'CHERNOFF DIAMOND & COMPANY LLC',
      planCount: 2,
      selected: false,
      assets: '75,458,456.74',
    },
    {
      id: 126,
      tpaID: '271186851',
      tpaName: 'NICHOLAS PENSION CONSULTANTS INC',
      label: 'NICHOLAS PENSION CONSULTANTS INC',
      value: 'NICHOLAS PENSION CONSULTANTS INC',
      planCount: 64,
      selected: false,
      assets: '74,482,763.93',
    },
    {
      id: 127,
      tpaID: '331197652',
      tpaName: 'SUPERIORUSA CORPORATION',
      label: 'SUPERIORUSA CORPORATION',
      value: 'SUPERIORUSA CORPORATION',
      planCount: 65,
      selected: false,
      assets: '71,586,046.79',
    },
    {
      id: 128,
      tpaID: '364389114',
      tpaName: 'ALLIANCE PENSION CONSULTANTS LLC',
      label: 'ALLIANCE PENSION CONSULTANTS LLC',
      value: 'ALLIANCE PENSION CONSULTANTS LLC',
      planCount: 12,
      selected: false,
      assets: '70,761,924.97',
    },
    {
      id: 129,
      tpaID: '630813240',
      tpaName: 'PEARCE, BEVILL, LEESBURG, MOORE, PC',
      label: 'PEARCE, BEVILL, LEESBURG, MOORE, PC',
      value: 'PEARCE, BEVILL, LEESBURG, MOORE, PC',
      planCount: 16,
      selected: false,
      assets: '69,221,530.46',
    },
    {
      id: 130,
      tpaID: '363180571',
      tpaName: 'ERISA INC',
      label: 'ERISA INC',
      value: 'ERISA INC',
      planCount: 32,
      selected: false,
      assets: '69,019,142.13',
    },
    {
      id: 131,
      tpaID: '060874395',
      tpaName: 'THE PENSION SERVICE INC',
      label: 'THE PENSION SERVICE INC',
      value: 'THE PENSION SERVICE INC',
      planCount: 26,
      selected: false,
      assets: '68,884,406.10',
    },
    {
      id: 132,
      tpaID: '043222046',
      tpaName: 'SUMMIT FINANCIAL CORPORATION',
      label: 'SUMMIT FINANCIAL CORPORATION',
      value: 'SUMMIT FINANCIAL CORPORATION',
      planCount: 5,
      selected: false,
      assets: '68,199,161.69',
    },
    {
      id: 133,
      tpaID: '132945975',
      tpaName: 'MADISON PENSION SVCS INC',
      label: 'MADISON PENSION SVCS INC',
      value: 'MADISON PENSION SVCS INC',
      planCount: 9,
      selected: false,
      assets: '67,563,628.79',
    },
    {
      id: 134,
      tpaID: '720837456',
      tpaName: 'EMPLOYEE PLAN COMPLIANCE CO OF LOUISIANA INC',
      label: 'EMPLOYEE PLAN COMPLIANCE CO OF LOUISIANA INC',
      value: 'EMPLOYEE PLAN COMPLIANCE CO OF LOUISIANA INC',
      planCount: 4,
      selected: false,
      assets: '67,279,858.38',
    },
    {
      id: 135,
      tpaID: '911661080',
      tpaName: 'RANDALL & HURLEY, INC.',
      label: 'RANDALL & HURLEY, INC.',
      value: 'RANDALL & HURLEY, INC.',
      planCount: 13,
      selected: false,
      assets: '66,882,156.16',
    },
    {
      id: 136,
      tpaID: '232383285',
      tpaName: 'BENEFIT CONSULTANTS GROUP',
      label: 'BENEFIT CONSULTANTS GROUP',
      value: 'BENEFIT CONSULTANTS GROUP',
      planCount: 30,
      selected: false,
      assets: '66,544,705.40',
    },
    {
      id: 137,
      tpaID: '721487108',
      tpaName: 'THE HASLAUER GROUP, INC.',
      label: 'THE HASLAUER GROUP, INC.',
      value: 'THE HASLAUER GROUP, INC.',
      planCount: 34,
      selected: false,
      assets: '66,277,433.08',
    },
    {
      id: 138,
      tpaID: '522025778',
      tpaName: 'AMERICAN RETIREMENT PLAN SERVICES LLC',
      label: 'AMERICAN RETIREMENT PLAN SERVICES LLC',
      value: 'AMERICAN RETIREMENT PLAN SERVICES LLC',
      planCount: 19,
      selected: false,
      assets: '63,046,245.48',
    },
    {
      id: 139,
      tpaID: '141836262',
      tpaName: 'STRATEGIC PENSION SERVICES LLC',
      label: 'STRATEGIC PENSION SERVICES LLC',
      value: 'STRATEGIC PENSION SERVICES LLC',
      planCount: 16,
      selected: false,
      assets: '62,880,749.13',
    },
    {
      id: 140,
      tpaID: '731554797',
      tpaName: 'EMPLOYEE BENEFITS GROUP, LLC',
      label: 'EMPLOYEE BENEFITS GROUP, LLC',
      value: 'EMPLOYEE BENEFITS GROUP, LLC',
      planCount: 11,
      selected: false,
      assets: '61,975,097.87',
    },
    {
      id: 141,
      tpaID: '860738258',
      tpaName: 'EDBERG & PERRY INC',
      label: 'EDBERG & PERRY INC',
      value: 'EDBERG & PERRY INC',
      planCount: 13,
      selected: false,
      assets: '61,657,954.83',
    },
    {
      id: 142,
      tpaID: '260843072',
      tpaName: 'SASI, INC.',
      label: 'SASI, INC.',
      value: 'SASI, INC.',
      planCount: 2,
      selected: false,
      assets: '61,408,727.04',
    },
    {
      id: 143,
      tpaID: '953775762',
      tpaName: 'BENEFIT ASSOCIATES INC',
      label: 'BENEFIT ASSOCIATES INC',
      value: 'BENEFIT ASSOCIATES INC',
      planCount: 13,
      selected: false,
      assets: '60,624,178.46',
    },
    {
      id: 144,
      tpaID: '341944384',
      tpaName: 'PENSION INNOVATIONS & CONSULTING',
      label: 'PENSION INNOVATIONS & CONSULTING',
      value: 'PENSION INNOVATIONS & CONSULTING',
      planCount: 22,
      selected: false,
      assets: '60,514,761.77',
    },
    {
      id: 145,
      tpaID: '521904735',
      tpaName: 'COLUMBIA BENEFITS CONSULTANTS INC',
      label: 'COLUMBIA BENEFITS CONSULTANTS INC',
      value: 'COLUMBIA BENEFITS CONSULTANTS INC',
      planCount: 4,
      selected: false,
      assets: '59,777,400.55',
    },
    {
      id: 146,
      tpaID: '134238973',
      tpaName: 'TRANSITION FINANCE STRATEGIES LLC',
      label: 'TRANSITION FINANCE STRATEGIES LLC',
      value: 'TRANSITION FINANCE STRATEGIES LLC',
      planCount: 6,
      selected: false,
      assets: '59,539,486.78',
    },
    {
      id: 147,
      tpaID: '200235252',
      tpaName: 'TRINITY PENSION GROUP LLC',
      label: 'TRINITY PENSION GROUP LLC',
      value: 'TRINITY PENSION GROUP LLC',
      planCount: 6,
      selected: false,
      assets: '58,090,688.63',
    },
    {
      id: 148,
      tpaID: '363036100',
      tpaName: 'BENEFIT PLANNING CONSULTANTS',
      label: 'BENEFIT PLANNING CONSULTANTS',
      value: 'BENEFIT PLANNING CONSULTANTS',
      planCount: 23,
      selected: false,
      assets: '57,455,503.13',
    },
    {
      id: 149,
      tpaID: '010577649',
      tpaName: 'TROMBINO PENSION ADMINISTRATORS INC',
      label: 'TROMBINO PENSION ADMINISTRATORS INC',
      value: 'TROMBINO PENSION ADMINISTRATORS INC',
      planCount: 12,
      selected: false,
      assets: '56,789,711.18',
    },
    {
      id: 150,
      tpaID: '391894140',
      tpaName: 'PENSION CONSULTANTS CO INC',
      label: 'PENSION CONSULTANTS CO INC',
      value: 'PENSION CONSULTANTS CO INC',
      planCount: 64,
      selected: false,
      assets: '55,808,517.97',
    },
    {
      id: 151,
      tpaID: '391974154',
      tpaName: 'BLUE CHIP RETIREMENT PLANS INC',
      label: 'BLUE CHIP RETIREMENT PLANS INC',
      value: 'BLUE CHIP RETIREMENT PLANS INC',
      planCount: 22,
      selected: false,
      assets: '54,493,572.26',
    },
    {
      id: 152,
      tpaID: '814636200',
      tpaName: 'MORSE DOMEIER BUMGARDNER LLC',
      label: 'MORSE DOMEIER BUMGARDNER LLC',
      value: 'MORSE DOMEIER BUMGARDNER LLC',
      planCount: 7,
      selected: false,
      assets: '53,676,012.57',
    },
    {
      id: 153,
      tpaID: '223200158',
      tpaName: 'PREFERRED PENSION PLANNING CORPORATION',
      label: 'PREFERRED PENSION PLANNING CORPORATION',
      value: 'PREFERRED PENSION PLANNING CORPORATION',
      planCount: 32,
      selected: false,
      assets: '53,295,556.60',
    },
    {
      id: 154,
      tpaID: '480949535',
      tpaName: 'EIP CORP',
      label: 'EIP CORP',
      value: 'EIP CORP',
      planCount: 23,
      selected: false,
      assets: '52,950,512.37',
    },
    {
      id: 155,
      tpaID: '820986372',
      tpaName: 'PREMIER PLAN CONSULTANTS INC',
      label: 'PREMIER PLAN CONSULTANTS INC',
      value: 'PREMIER PLAN CONSULTANTS INC',
      planCount: 57,
      selected: false,
      assets: '52,816,014.45',
    },
    {
      id: 156,
      tpaID: '061053228',
      tpaName: 'USI CONSULTING GROUP INC',
      label: 'USI CONSULTING GROUP INC',
      value: 'USI CONSULTING GROUP INC',
      planCount: 8,
      selected: false,
      assets: '52,396,997.69',
    },
    {
      id: 157,
      tpaID: '953654973',
      tpaName: 'ACTUARIES UNLIMITED INC',
      label: 'ACTUARIES UNLIMITED INC',
      value: 'ACTUARIES UNLIMITED INC',
      planCount: 24,
      selected: false,
      assets: '52,211,276.13',
    },
    {
      id: 158,
      tpaID: '300337628',
      tpaName: 'RETIREMENT PLAN SOLUTIONS LLC (PA)',
      label: 'RETIREMENT PLAN SOLUTIONS LLC (PA)',
      value: 'RETIREMENT PLAN SOLUTIONS LLC (PA)',
      planCount: 12,
      selected: false,
      assets: '52,132,479.76',
    },
    {
      id: 159,
      tpaID: '161616474',
      tpaName: 'BENEFIT PLANS ADMINISTRATIVE SERVICES, INC.',
      label: 'BENEFIT PLANS ADMINISTRATIVE SERVICES, INC.',
      value: 'BENEFIT PLANS ADMINISTRATIVE SERVICES, INC.',
      planCount: 16,
      selected: false,
      assets: '51,752,153.82',
    },
    {
      id: 160,
      tpaID: '841365788',
      tpaName: 'QUALIFIED PENSION SERVICES INC. (CO)',
      label: 'QUALIFIED PENSION SERVICES INC. (CO)',
      value: 'QUALIFIED PENSION SERVICES INC. (CO)',
      planCount: 26,
      selected: false,
      assets: '51,558,547.85',
    },
    {
      id: 161,
      tpaID: '341842059',
      tpaName: 'BREWSTER & BREWSTER',
      label: 'BREWSTER & BREWSTER',
      value: 'BREWSTER & BREWSTER',
      planCount: 38,
      selected: false,
      assets: '50,981,140.19',
    },
    {
      id: 162,
      tpaID: '381337372',
      tpaName: 'BEENE GARTER LLP',
      label: 'BEENE GARTER LLP',
      value: 'BEENE GARTER LLP',
      planCount: 10,
      selected: false,
      assets: '50,866,627.74',
    },
    {
      id: 163,
      tpaID: '593465757',
      tpaName: 'BATES & COMPANY, P.A.',
      label: 'BATES & COMPANY, P.A.',
      value: 'BATES & COMPANY, P.A.',
      planCount: 39,
      selected: false,
      assets: '50,349,608.13',
    },
    {
      id: 164,
      tpaID: '161209645',
      tpaName: 'SECURITY ADMINISTRATORS INC',
      label: 'SECURITY ADMINISTRATORS INC',
      value: 'SECURITY ADMINISTRATORS INC',
      planCount: 21,
      selected: false,
      assets: '50,230,633.13',
    },
    {
      id: 165,
      tpaID: '201258185',
      tpaName: 'ALTIGRO PENSION SERVICES INC',
      label: 'ALTIGRO PENSION SERVICES INC',
      value: 'ALTIGRO PENSION SERVICES INC',
      planCount: 20,
      selected: false,
      assets: '49,267,288.71',
    },
    {
      id: 166,
      tpaID: '381477362',
      tpaName: 'WATKINS ROSS & CO',
      label: 'WATKINS ROSS & CO',
      value: 'WATKINS ROSS & CO',
      planCount: 7,
      selected: false,
      assets: '49,026,873.06',
    },
    {
      id: 167,
      tpaID: '361078850',
      tpaName: 'FIRST AMERICAN BANK',
      label: 'FIRST AMERICAN BANK',
      value: 'FIRST AMERICAN BANK',
      planCount: 6,
      selected: false,
      assets: '48,768,051.59',
    },
    {
      id: 168,
      tpaID: '204536537',
      tpaName: 'CROSSPLANS',
      label: 'CROSSPLANS',
      value: 'CROSSPLANS',
      planCount: 9,
      selected: false,
      assets: '48,514,039.89',
    },
    {
      id: 169,
      tpaID: '453280454',
      tpaName: 'HILLS PENSION ASSOCIATES, LLC',
      label: 'HILLS PENSION ASSOCIATES, LLC',
      value: 'HILLS PENSION ASSOCIATES, LLC',
      planCount: 51,
      selected: false,
      assets: '48,423,993.68',
    },
    {
      id: 170,
      tpaID: '550486667',
      tpaName: 'ARNETT CARBIS TOOTHMAN LLP',
      label: 'ARNETT CARBIS TOOTHMAN LLP',
      value: 'ARNETT CARBIS TOOTHMAN LLP',
      planCount: 16,
      selected: false,
      assets: '48,308,209.91',
    },
    {
      id: 171,
      tpaID: '061086115',
      tpaName: 'FJC & ASSOCIATES INC',
      label: 'FJC & ASSOCIATES INC',
      value: 'FJC & ASSOCIATES INC',
      planCount: 24,
      selected: false,
      assets: '47,701,176.82',
    },
    {
      id: 172,
      tpaID: '461281375',
      tpaName: 'ABAR RETIREMENT PLAN SERVICES LLC',
      label: 'ABAR RETIREMENT PLAN SERVICES LLC',
      value: 'ABAR RETIREMENT PLAN SERVICES LLC',
      planCount: 10,
      selected: false,
      assets: '47,527,492.81',
    },
    {
      id: 173,
      tpaID: '061093852',
      tpaName: 'ACG ASSOCIATES INC',
      label: 'ACG ASSOCIATES INC',
      value: 'ACG ASSOCIATES INC',
      planCount: 16,
      selected: false,
      assets: '46,973,334.15',
    },
    {
      id: 174,
      tpaID: '680082549',
      tpaName: 'ATTEBERRY SEARLE INC',
      label: 'ATTEBERRY SEARLE INC',
      value: 'ATTEBERRY SEARLE INC',
      planCount: 19,
      selected: false,
      assets: '46,773,462.28',
    },
    {
      id: 175,
      tpaID: '274018270',
      tpaName: 'STRATEGIC RETIREMENT ADMINISTRATION, LLC.',
      label: 'STRATEGIC RETIREMENT ADMINISTRATION, LLC.',
      value: 'STRATEGIC RETIREMENT ADMINISTRATION, LLC.',
      planCount: 7,
      selected: false,
      assets: '46,576,520.99',
    },
    {
      id: 176,
      tpaID: '851191330',
      tpaName: 'C-BEN GROUP, LLC',
      label: 'C-BEN GROUP, LLC',
      value: 'C-BEN GROUP, LLC',
      planCount: 6,
      selected: false,
      assets: '45,610,642.04',
    },
    {
      id: 177,
      tpaID: '621700633',
      tpaName: 'ACCESS RETIREMENT SERVICES LLC',
      label: 'ACCESS RETIREMENT SERVICES LLC',
      value: 'ACCESS RETIREMENT SERVICES LLC',
      planCount: 7,
      selected: false,
      assets: '45,595,808.89',
    },
    {
      id: 178,
      tpaID: '351277460',
      tpaName: 'COMPENSATION SYSTEMS INC',
      label: 'COMPENSATION SYSTEMS INC',
      value: 'COMPENSATION SYSTEMS INC',
      planCount: 10,
      selected: false,
      assets: '45,585,913.99',
    },
    {
      id: 179,
      tpaID: '520909772',
      tpaName: 'POLLARD & ASSOCIATES, INC',
      label: 'POLLARD & ASSOCIATES, INC',
      value: 'POLLARD & ASSOCIATES, INC',
      planCount: 16,
      selected: false,
      assets: '45,067,131.90',
    },
    {
      id: 180,
      tpaID: '112632902',
      tpaName: 'WIA CONSULTANTS INC 401 (K) PLAN',
      label: 'WIA CONSULTANTS INC 401 (K) PLAN',
      value: 'WIA CONSULTANTS INC 401 (K) PLAN',
      planCount: 6,
      selected: false,
      assets: '44,916,969.15',
    },
    {
      id: 181,
      tpaID: '510523358',
      tpaName: 'JIM HALLINAN PENSION CONSULTING LLC',
      label: 'JIM HALLINAN PENSION CONSULTING LLC',
      value: 'JIM HALLINAN PENSION CONSULTING LLC',
      planCount: 25,
      selected: false,
      assets: '44,801,293.61',
    },
    {
      id: 182,
      tpaID: '930839718',
      tpaName: 'NORTHWEST RETIREMENT PLANS INC',
      label: 'NORTHWEST RETIREMENT PLANS INC',
      value: 'NORTHWEST RETIREMENT PLANS INC',
      planCount: 27,
      selected: false,
      assets: '44,800,442.77',
    },
    {
      id: 183,
      tpaID: '843317739',
      tpaName: 'BIA CONSULTING, LLC',
      label: 'BIA CONSULTING, LLC',
      value: 'BIA CONSULTING, LLC',
      planCount: 3,
      selected: false,
      assets: '44,624,910.23',
    },
    {
      id: 184,
      tpaID: '752503320',
      tpaName: 'PENSION RESOURCES CORPORATION',
      label: 'PENSION RESOURCES CORPORATION',
      value: 'PENSION RESOURCES CORPORATION',
      planCount: 10,
      selected: false,
      assets: '44,451,092.50',
    },
    {
      id: 185,
      tpaID: '760018527',
      tpaName: 'ACTUARIES & ASSOCIATES',
      label: 'ACTUARIES & ASSOCIATES',
      value: 'ACTUARIES & ASSOCIATES',
      planCount: 53,
      selected: false,
      assets: '44,379,778.96',
    },
    {
      id: 186,
      tpaID: '133384874',
      tpaName: 'PPC INC.',
      label: 'PPC INC.',
      value: 'PPC INC.',
      planCount: 6,
      selected: false,
      assets: '44,250,721.76',
    },
    {
      id: 187,
      tpaID: '410887288',
      tpaName: 'BOULAY PLLP',
      label: 'BOULAY PLLP',
      value: 'BOULAY PLLP',
      planCount: 2,
      selected: false,
      assets: '43,711,647.58',
    },
    {
      id: 188,
      tpaID: '953207191',
      tpaName: 'KRAVITZ INC',
      label: 'KRAVITZ INC',
      value: 'KRAVITZ INC',
      planCount: 7,
      selected: false,
      assets: '42,904,100.67',
    },
    {
      id: 189,
      tpaID: '201657244',
      tpaName: 'PENSION ASSOCIATES',
      label: 'PENSION ASSOCIATES',
      value: 'PENSION ASSOCIATES',
      planCount: 25,
      selected: false,
      assets: '42,869,516.27',
    },
    {
      id: 190,
      tpaID: '731553813',
      tpaName: 'TRISTAR PENSION LTD',
      label: 'TRISTAR PENSION LTD',
      value: 'TRISTAR PENSION LTD',
      planCount: 9,
      selected: false,
      assets: '42,663,380.20',
    },
    {
      id: 191,
      tpaID: '201963865',
      tpaName: 'CAFARO GROUP LLC*THE',
      label: 'CAFARO GROUP LLC*THE',
      value: 'CAFARO GROUP LLC*THE',
      planCount: 2,
      selected: false,
      assets: '42,625,304.72',
    },
    {
      id: 192,
      tpaID: '521875589',
      tpaName: "TIGER'S EYE BENEFITS CONSULTING",
      label: "TIGER'S EYE BENEFITS CONSULTING",
      value: "TIGER'S EYE BENEFITS CONSULTING",
      planCount: 16,
      selected: false,
      assets: '42,396,004.00',
    },
    {
      id: 193,
      tpaID: '391884254',
      tpaName: 'MAP RETIREMENT',
      label: 'MAP RETIREMENT',
      value: 'MAP RETIREMENT',
      planCount: 35,
      selected: false,
      assets: '42,371,101.19',
    },
    {
      id: 194,
      tpaID: '261662097',
      tpaName: 'HERITAGE ADMINISTRATIVE SERVICES LLC',
      label: 'HERITAGE ADMINISTRATIVE SERVICES LLC',
      value: 'HERITAGE ADMINISTRATIVE SERVICES LLC',
      planCount: 13,
      selected: false,
      assets: '42,068,322.40',
    },
    {
      id: 195,
      tpaID: '391444845',
      tpaName: 'NORTHWESTERN WISCONSIN ASSOCIATES INC',
      label: 'NORTHWESTERN WISCONSIN ASSOCIATES INC',
      value: 'NORTHWESTERN WISCONSIN ASSOCIATES INC',
      planCount: 14,
      selected: false,
      assets: '41,703,583.56',
    },
    {
      id: 196,
      tpaID: '010343875',
      tpaName: 'HEALEY & ASSOCIATES INC',
      label: 'HEALEY & ASSOCIATES INC',
      value: 'HEALEY & ASSOCIATES INC',
      planCount: 8,
      selected: false,
      assets: '41,404,959.65',
    },
    {
      id: 197,
      tpaID: '454090227',
      tpaName: 'BROOKE CLINE & ASSOCIATES, LLC',
      label: 'BROOKE CLINE & ASSOCIATES, LLC',
      value: 'BROOKE CLINE & ASSOCIATES, LLC',
      planCount: 18,
      selected: false,
      assets: '41,069,100.45',
    },
    {
      id: 198,
      tpaID: '351278046',
      tpaName: 'FACTS INC',
      label: 'FACTS INC',
      value: 'FACTS INC',
      planCount: 47,
      selected: false,
      assets: '40,930,922.50',
    },
    {
      id: 199,
      tpaID: '202274261',
      tpaName: 'PREMIER PENSION SOLUTIONS, LLC',
      label: 'PREMIER PENSION SOLUTIONS, LLC',
      value: 'PREMIER PENSION SOLUTIONS, LLC',
      planCount: 9,
      selected: false,
      assets: '40,673,716.98',
    },
    {
      id: 200,
      tpaID: '621110839',
      tpaName: 'ALEXANDER THOMPSON ARNOLD PLLC',
      label: 'ALEXANDER THOMPSON ARNOLD PLLC',
      value: 'ALEXANDER THOMPSON ARNOLD PLLC',
      planCount: 6,
      selected: false,
      assets: '40,142,366.12',
    },
    {
      id: 201,
      tpaID: '270017183',
      tpaName: 'RETIREMENT STRATEGIES LLC',
      label: 'RETIREMENT STRATEGIES LLC',
      value: 'RETIREMENT STRATEGIES LLC',
      planCount: 23,
      selected: false,
      assets: '39,411,833.36',
    },
    {
      id: 202,
      tpaID: '720398470',
      tpaName: 'HEARD MCELROY & VESTAL LLC',
      label: 'HEARD MCELROY & VESTAL LLC',
      value: 'HEARD MCELROY & VESTAL LLC',
      planCount: 13,
      selected: false,
      assets: '38,290,997.54',
    },
    {
      id: 203,
      tpaID: '465674799',
      tpaName: 'NORTHWEST RETIREMENT PLAN CONSULTANTS LLC',
      label: 'NORTHWEST RETIREMENT PLAN CONSULTANTS LLC',
      value: 'NORTHWEST RETIREMENT PLAN CONSULTANTS LLC',
      planCount: 33,
      selected: false,
      assets: '37,923,381.03',
    },
    {
      id: 204,
      tpaID: '202872050',
      tpaName: 'PENSERV, INC.',
      label: 'PENSERV, INC.',
      value: 'PENSERV, INC.',
      planCount: 15,
      selected: false,
      assets: '37,715,328.72',
    },
    {
      id: 205,
      tpaID: '270293282',
      tpaName: 'RETIREMENT SOLUTIONS SPECIALISTS LLC',
      label: 'RETIREMENT SOLUTIONS SPECIALISTS LLC',
      value: 'RETIREMENT SOLUTIONS SPECIALISTS LLC',
      planCount: 12,
      selected: false,
      assets: '37,600,985.64',
    },
    {
      id: 206,
      tpaID: '262480211',
      tpaName: 'MAGII PENSION SERVICES LLC',
      label: 'MAGII PENSION SERVICES LLC',
      value: 'MAGII PENSION SERVICES LLC',
      planCount: 39,
      selected: false,
      assets: '37,527,489.25',
    },
    {
      id: 207,
      tpaID: '204043839',
      tpaName: 'PENSION ADMINISTRATORS LLC (NE)',
      label: 'PENSION ADMINISTRATORS LLC (NE)',
      value: 'PENSION ADMINISTRATORS LLC (NE)',
      planCount: 27,
      selected: false,
      assets: '36,136,549.83',
    },
    {
      id: 208,
      tpaID: '363493622',
      tpaName: 'CARNOW & ASSOCIATES LTD',
      label: 'CARNOW & ASSOCIATES LTD',
      value: 'CARNOW & ASSOCIATES LTD',
      planCount: 14,
      selected: false,
      assets: '35,637,652.58',
    },
    {
      id: 209,
      tpaID: '204100804',
      tpaName: 'ERP ACTUARIES AND CONSULTANTS',
      label: 'ERP ACTUARIES AND CONSULTANTS',
      value: 'ERP ACTUARIES AND CONSULTANTS',
      planCount: 20,
      selected: false,
      assets: '34,724,563.07',
    },
    {
      id: 210,
      tpaID: '232986500',
      tpaName: 'VALLEY FORGE PENSION MANAGEMENT, INC.',
      label: 'VALLEY FORGE PENSION MANAGEMENT, INC.',
      value: 'VALLEY FORGE PENSION MANAGEMENT, INC.',
      planCount: 12,
      selected: false,
      assets: '34,645,821.70',
    },
    {
      id: 211,
      tpaID: '561762637',
      tpaName: 'RETIREMENT PLAN SOLUTIONS, INC. (NC)',
      label: 'RETIREMENT PLAN SOLUTIONS, INC. (NC)',
      value: 'RETIREMENT PLAN SOLUTIONS, INC. (NC)',
      planCount: 24,
      selected: false,
      assets: '34,570,621.53',
    },
    {
      id: 212,
      tpaID: '593461974',
      tpaName: 'SOUTHERN PENSION SERVICES',
      label: 'SOUTHERN PENSION SERVICES',
      value: 'SOUTHERN PENSION SERVICES',
      planCount: 9,
      selected: false,
      assets: '34,563,926.79',
    },
    {
      id: 213,
      tpaID: '900792199',
      tpaName: 'THE RIVERGROUP ADMINISTRATION SERVICES',
      label: 'THE RIVERGROUP ADMINISTRATION SERVICES',
      value: 'THE RIVERGROUP ADMINISTRATION SERVICES',
      planCount: 5,
      selected: false,
      assets: '34,140,641.55',
    },
    {
      id: 214,
      tpaID: '383567911',
      tpaName: 'REHMANN FINANCIAL GROUP LLC',
      label: 'REHMANN FINANCIAL GROUP LLC',
      value: 'REHMANN FINANCIAL GROUP LLC',
      planCount: 5,
      selected: false,
      assets: '33,363,342.31',
    },
    {
      id: 215,
      tpaID: '841096179',
      tpaName: 'RETIREMENT PLANNING SERVICES, INC',
      label: 'RETIREMENT PLANNING SERVICES, INC',
      value: 'RETIREMENT PLANNING SERVICES, INC',
      planCount: 13,
      selected: false,
      assets: '32,963,110.19',
    },
    {
      id: 216,
      tpaID: '341723189',
      tpaName: 'NOBLE DAVIS CONSULTING INC',
      label: 'NOBLE DAVIS CONSULTING INC',
      value: 'NOBLE DAVIS CONSULTING INC',
      planCount: 5,
      selected: false,
      assets: '31,992,928.11',
    },
    {
      id: 217,
      tpaID: '860922116',
      tpaName: 'SUNWEST PENSIONS',
      label: 'SUNWEST PENSIONS',
      value: 'SUNWEST PENSIONS',
      planCount: 22,
      selected: false,
      assets: '31,878,637.47',
    },
    {
      id: 218,
      tpaID: '042484178',
      tpaName: 'AFC PENSIONS INC',
      label: 'AFC PENSIONS INC',
      value: 'AFC PENSIONS INC',
      planCount: 20,
      selected: false,
      assets: '31,603,988.00',
    },
    {
      id: 219,
      tpaID: '541953648',
      tpaName: 'RETIREMENT BENEFIT SOLUTIONS LLC',
      label: 'RETIREMENT BENEFIT SOLUTIONS LLC',
      value: 'RETIREMENT BENEFIT SOLUTIONS LLC',
      planCount: 8,
      selected: false,
      assets: '31,514,297.00',
    },
    {
      id: 220,
      tpaID: '541370499',
      tpaName: 'BENEFIT DESIGN & ADMINISTRATION INC',
      label: 'BENEFIT DESIGN & ADMINISTRATION INC',
      value: 'BENEFIT DESIGN & ADMINISTRATION INC',
      planCount: 8,
      selected: false,
      assets: '31,268,691.11',
    },
    {
      id: 221,
      tpaID: '113478864',
      tpaName: 'THE WOLF PENSION GROUP, LLC',
      label: 'THE WOLF PENSION GROUP, LLC',
      value: 'THE WOLF PENSION GROUP, LLC',
      planCount: 4,
      selected: false,
      assets: '31,184,793.52',
    },
    {
      id: 222,
      tpaID: '112869312',
      tpaName: 'MASSA & ASSOCIATES INC',
      label: 'MASSA & ASSOCIATES INC',
      value: 'MASSA & ASSOCIATES INC',
      planCount: 5,
      selected: false,
      assets: '31,147,371.81',
    },
    {
      id: 223,
      tpaID: '043260807',
      tpaName: 'CORBCO INC',
      label: 'CORBCO INC',
      value: 'CORBCO INC',
      planCount: 13,
      selected: false,
      assets: '30,805,176.18',
    },
    {
      id: 224,
      tpaID: '452098380',
      tpaName: 'MY BENEFITS LLC',
      label: 'MY BENEFITS LLC',
      value: 'MY BENEFITS LLC',
      planCount: 19,
      selected: false,
      assets: '30,594,277.28',
    },
    {
      id: 225,
      tpaID: '521910770',
      tpaName: 'JM PENSION ADVISORY INC',
      label: 'JM PENSION ADVISORY INC',
      value: 'JM PENSION ADVISORY INC',
      planCount: 9,
      selected: false,
      assets: '30,365,427.74',
    },
    {
      id: 226,
      tpaID: '232756743',
      tpaName: 'STALKER & ASSOCIATES INC',
      label: 'STALKER & ASSOCIATES INC',
      value: 'STALKER & ASSOCIATES INC',
      planCount: 25,
      selected: false,
      assets: '30,246,623.03',
    },
    {
      id: 227,
      tpaID: '200508334',
      tpaName: 'PENSION CONSULTANTS INC (MN)',
      label: 'PENSION CONSULTANTS INC (MN)',
      value: 'PENSION CONSULTANTS INC (MN)',
      planCount: 3,
      selected: false,
      assets: '30,209,078.57',
    },
    {
      id: 228,
      tpaID: '161215016',
      tpaName: 'OMEGA INC',
      label: 'OMEGA INC',
      value: 'OMEGA INC',
      planCount: 15,
      selected: false,
      assets: '30,030,469.50',
    },
    {
      id: 229,
      tpaID: '520783935',
      tpaName: 'SMITH ELLIOTT KEARNS & COMPANY, LLC',
      label: 'SMITH ELLIOTT KEARNS & COMPANY, LLC',
      value: 'SMITH ELLIOTT KEARNS & COMPANY, LLC',
      planCount: 12,
      selected: false,
      assets: '29,887,781.29',
    },
    {
      id: 230,
      tpaID: '464034505',
      tpaName: 'HELLER PENSION ASSOCIATES INC',
      label: 'HELLER PENSION ASSOCIATES INC',
      value: 'HELLER PENSION ASSOCIATES INC',
      planCount: 11,
      selected: false,
      assets: '29,104,234.34',
    },
    {
      id: 231,
      tpaID: '592265857',
      tpaName: 'EJ REYNOLDS INC',
      label: 'EJ REYNOLDS INC',
      value: 'EJ REYNOLDS INC',
      planCount: 34,
      selected: false,
      assets: '28,877,910.64',
    },
    {
      id: 232,
      tpaID: '770443464',
      tpaName: 'PENSION MANAGEMENT CONSULTANTS INC',
      label: 'PENSION MANAGEMENT CONSULTANTS INC',
      value: 'PENSION MANAGEMENT CONSULTANTS INC',
      planCount: 25,
      selected: false,
      assets: '28,701,172.93',
    },
    {
      id: 233,
      tpaID: '362905126',
      tpaName: 'KAREL-GORDON & ASSOCIATES',
      label: 'KAREL-GORDON & ASSOCIATES',
      value: 'KAREL-GORDON & ASSOCIATES',
      planCount: 20,
      selected: false,
      assets: '28,419,683.84',
    },
    {
      id: 234,
      tpaID: '731412334',
      tpaName: 'BEASLEY & COMPANY',
      label: 'BEASLEY & COMPANY',
      value: 'BEASLEY & COMPANY',
      planCount: 9,
      selected: false,
      assets: '27,992,548.70',
    },
    {
      id: 235,
      tpaID: '261714874',
      tpaName: 'LEBENSON ACTUARIAL SERVICES INC',
      label: 'LEBENSON ACTUARIAL SERVICES INC',
      value: 'LEBENSON ACTUARIAL SERVICES INC',
      planCount: 14,
      selected: false,
      assets: '27,746,786.75',
    },
    {
      id: 236,
      tpaID: '942279761',
      tpaName: 'CETERA RETIREMENT PLAN SPECIALISTS',
      label: 'CETERA RETIREMENT PLAN SPECIALISTS',
      value: 'CETERA RETIREMENT PLAN SPECIALISTS',
      planCount: 35,
      selected: false,
      assets: '27,691,119.86',
    },
    {
      id: 237,
      tpaID: '141759450',
      tpaName: 'CREATIVE PENSION CONSULTANTS INC',
      label: 'CREATIVE PENSION CONSULTANTS INC',
      value: 'CREATIVE PENSION CONSULTANTS INC',
      planCount: 18,
      selected: false,
      assets: '27,540,160.22',
    },
    {
      id: 238,
      tpaID: '043103297',
      tpaName: 'BEACON BENEFITS INC.',
      label: 'BEACON BENEFITS INC.',
      value: 'BEACON BENEFITS INC.',
      planCount: 13,
      selected: false,
      assets: '27,155,700.75',
    },
    {
      id: 239,
      tpaID: '860905871',
      tpaName: 'DESANTIAGO PENSION CONSULTING LLC',
      label: 'DESANTIAGO PENSION CONSULTING LLC',
      value: 'DESANTIAGO PENSION CONSULTING LLC',
      planCount: 5,
      selected: false,
      assets: '27,086,013.48',
    },
    {
      id: 240,
      tpaID: '420955680',
      tpaName: 'REISER JENNINGS & CO PC',
      label: 'REISER JENNINGS & CO PC',
      value: 'REISER JENNINGS & CO PC',
      planCount: 3,
      selected: false,
      assets: '26,939,949.70',
    },
    {
      id: 241,
      tpaID: '592922169',
      tpaName: 'SALTMARSH CLEAVELAND & GUND',
      label: 'SALTMARSH CLEAVELAND & GUND',
      value: 'SALTMARSH CLEAVELAND & GUND',
      planCount: 5,
      selected: false,
      assets: '26,797,532.73',
    },
    {
      id: 242,
      tpaID: '954568183',
      tpaName: 'INTERNATIONAL BENEFIT PLANNERS',
      label: 'INTERNATIONAL BENEFIT PLANNERS',
      value: 'INTERNATIONAL BENEFIT PLANNERS',
      planCount: 25,
      selected: false,
      assets: '26,663,641.14',
    },
    {
      id: 243,
      tpaID: '810831793',
      tpaName: 'PEAK RETIREMENT GROUP',
      label: 'PEAK RETIREMENT GROUP',
      value: 'PEAK RETIREMENT GROUP',
      planCount: 4,
      selected: false,
      assets: '26,574,568.40',
    },
    {
      id: 244,
      tpaID: '621832817',
      tpaName: 'QUALIFIED PLAN ADMINISTRATORS, INC (TN)',
      label: 'QUALIFIED PLAN ADMINISTRATORS, INC (TN)',
      value: 'QUALIFIED PLAN ADMINISTRATORS, INC (TN)',
      planCount: 9,
      selected: false,
      assets: '26,062,948.81',
    },
    {
      id: 245,
      tpaID: '946214841',
      tpaName: 'ARMANINO LLP',
      label: 'ARMANINO LLP',
      value: 'ARMANINO LLP',
      planCount: 9,
      selected: false,
      assets: '26,029,181.24',
    },
    {
      id: 246,
      tpaID: '813026593',
      tpaName: 'PROFESSIONAL BENEFIT ADVISORS, INC.',
      label: 'PROFESSIONAL BENEFIT ADVISORS, INC.',
      value: 'PROFESSIONAL BENEFIT ADVISORS, INC.',
      planCount: 3,
      selected: false,
      assets: '25,769,542.80',
    },
    {
      id: 247,
      tpaID: '351907899',
      tpaName: 'BLUE BENEFITS CONSULTING, INC.',
      label: 'BLUE BENEFITS CONSULTING, INC.',
      value: 'BLUE BENEFITS CONSULTING, INC.',
      planCount: 10,
      selected: false,
      assets: '25,209,364.66',
    },
    {
      id: 248,
      tpaID: '910967757',
      tpaName: 'BBM FINANCIAL SERVICES INC',
      label: 'BBM FINANCIAL SERVICES INC',
      value: 'BBM FINANCIAL SERVICES INC',
      planCount: 2,
      selected: false,
      assets: '25,180,772.61',
    },
    {
      id: 249,
      tpaID: '900451904',
      tpaName: 'INDEPENDENT RETIREMENT CONSULTING LLC',
      label: 'INDEPENDENT RETIREMENT CONSULTING LLC',
      value: 'INDEPENDENT RETIREMENT CONSULTING LLC',
      planCount: 15,
      selected: false,
      assets: '24,851,863.22',
    },
    {
      id: 250,
      tpaID: '650158316',
      tpaName: 'PENSION SERVICES, INC',
      label: 'PENSION SERVICES, INC',
      value: 'PENSION SERVICES, INC',
      planCount: 20,
      selected: false,
      assets: '24,718,621.41',
    },
    {
      id: 251,
      tpaID: '770536619',
      tpaName: 'CAMPBELL ALBRECHT',
      label: 'CAMPBELL ALBRECHT',
      value: 'CAMPBELL ALBRECHT',
      planCount: 6,
      selected: false,
      assets: '24,536,928.30',
    },
    {
      id: 252,
      tpaID: '383466149',
      tpaName: 'BARCLAY PLANNING GROUP LLC',
      label: 'BARCLAY PLANNING GROUP LLC',
      value: 'BARCLAY PLANNING GROUP LLC',
      planCount: 10,
      selected: false,
      assets: '24,247,276.05',
    },
    {
      id: 253,
      tpaID: '311452011',
      tpaName: 'BURKE & SCHINDLER PLL',
      label: 'BURKE & SCHINDLER PLL',
      value: 'BURKE & SCHINDLER PLL',
      planCount: 1,
      selected: false,
      assets: '24,229,368.12',
    },
    {
      id: 254,
      tpaID: '264823657',
      tpaName: 'RELATION INSURANCE SERVICES OF CALIFORNIA INC',
      label: 'RELATION INSURANCE SERVICES OF CALIFORNIA INC',
      value: 'RELATION INSURANCE SERVICES OF CALIFORNIA INC',
      planCount: 13,
      selected: false,
      assets: '24,220,461.64',
    },
    {
      id: 255,
      tpaID: '770535585',
      tpaName: 'PHILIP D PRICE & ASSOCIATES INC',
      label: 'PHILIP D PRICE & ASSOCIATES INC',
      value: 'PHILIP D PRICE & ASSOCIATES INC',
      planCount: 24,
      selected: false,
      assets: '24,219,233.17',
    },
    {
      id: 256,
      tpaID: '371446858',
      tpaName: 'AARON KEYS & ASSOCIATES INC',
      label: 'AARON KEYS & ASSOCIATES INC',
      value: 'AARON KEYS & ASSOCIATES INC',
      planCount: 67,
      selected: false,
      assets: '23,957,601.53',
    },
    {
      id: 257,
      tpaID: '560574444',
      tpaName: 'CHERRY BEKAERT LLP',
      label: 'CHERRY BEKAERT LLP',
      value: 'CHERRY BEKAERT LLP',
      planCount: 11,
      selected: false,
      assets: '23,617,679.63',
    },
    {
      id: 258,
      tpaID: '260682871',
      tpaName: 'TDM RETIREMENT SERVICES, LLC',
      label: 'TDM RETIREMENT SERVICES, LLC',
      value: 'TDM RETIREMENT SERVICES, LLC',
      planCount: 17,
      selected: false,
      assets: '23,300,747.21',
    },
    {
      id: 259,
      tpaID: '742715820',
      tpaName: 'JULY BUSINESS SERVICES INC',
      label: 'JULY BUSINESS SERVICES INC',
      value: 'JULY BUSINESS SERVICES INC',
      planCount: 8,
      selected: false,
      assets: '22,968,141.54',
    },
    {
      id: 260,
      tpaID: '161171765',
      tpaName: 'LIFETIME BENEFIT SOLUTIONS INC',
      label: 'LIFETIME BENEFIT SOLUTIONS INC',
      value: 'LIFETIME BENEFIT SOLUTIONS INC',
      planCount: 19,
      selected: false,
      assets: '22,916,916.09',
    },
    {
      id: 261,
      tpaID: '823571106',
      tpaName: 'SHEAKLEY WORKFORCE MANAGEMENT, LLC',
      label: 'SHEAKLEY WORKFORCE MANAGEMENT, LLC',
      value: 'SHEAKLEY WORKFORCE MANAGEMENT, LLC',
      planCount: 6,
      selected: false,
      assets: '22,642,085.59',
    },
    {
      id: 262,
      tpaID: '621757444',
      tpaName: 'TENNESSEE PENSION ADMINISTRATORS LLC',
      label: 'TENNESSEE PENSION ADMINISTRATORS LLC',
      value: 'TENNESSEE PENSION ADMINISTRATORS LLC',
      planCount: 2,
      selected: false,
      assets: '22,606,113.20',
    },
    {
      id: 263,
      tpaID: '593033722',
      tpaName: 'RJL PENSION SERVICES INC',
      label: 'RJL PENSION SERVICES INC',
      value: 'RJL PENSION SERVICES INC',
      planCount: 15,
      selected: false,
      assets: '22,528,258.47',
    },
    {
      id: 264,
      tpaID: '311140818',
      tpaName: 'SCHNEIDER MALE & STRAKOWSKI CO EA',
      label: 'SCHNEIDER MALE & STRAKOWSKI CO EA',
      value: 'SCHNEIDER MALE & STRAKOWSKI CO EA',
      planCount: 5,
      selected: false,
      assets: '22,272,247.26',
    },
    {
      id: 265,
      tpaID: '264203770',
      tpaName: 'MALCOLM THOMPSON & ASSOCIATES',
      label: 'MALCOLM THOMPSON & ASSOCIATES',
      value: 'MALCOLM THOMPSON & ASSOCIATES',
      planCount: 18,
      selected: false,
      assets: '22,101,030.66',
    },
    {
      id: 266,
      tpaID: '592315108',
      tpaName: 'LURIE, LLP',
      label: 'LURIE, LLP',
      value: 'LURIE, LLP',
      planCount: 11,
      selected: false,
      assets: '22,088,190.06',
    },
    {
      id: 267,
      tpaID: '752408441',
      tpaName: 'INWEST RETIREMENT SOLUTIONS',
      label: 'INWEST RETIREMENT SOLUTIONS',
      value: 'INWEST RETIREMENT SOLUTIONS',
      planCount: 14,
      selected: false,
      assets: '21,595,249.63',
    },
    {
      id: 268,
      tpaID: '203039384',
      tpaName: 'BIDWELL CONSULTING SERVICES INC',
      label: 'BIDWELL CONSULTING SERVICES INC',
      value: 'BIDWELL CONSULTING SERVICES INC',
      planCount: 11,
      selected: false,
      assets: '21,585,306.70',
    },
    {
      id: 269,
      tpaID: '330001862',
      tpaName: 'PENSION PROFESSIONALS, INC (CA)',
      label: 'PENSION PROFESSIONALS, INC (CA)',
      value: 'PENSION PROFESSIONALS, INC (CA)',
      planCount: 8,
      selected: false,
      assets: '21,423,648.40',
    },
    {
      id: 270,
      tpaID: '131639826',
      tpaName: 'EISNERAMPER LLP',
      label: 'EISNERAMPER LLP',
      value: 'EISNERAMPER LLP',
      planCount: 2,
      selected: false,
      assets: '21,206,726.29',
    },
    {
      id: 271,
      tpaID: '561606387',
      tpaName: 'QUALIFIED RETIREMENT PLAN SERVICES INC',
      label: 'QUALIFIED RETIREMENT PLAN SERVICES INC',
      value: 'QUALIFIED RETIREMENT PLAN SERVICES INC',
      planCount: 30,
      selected: false,
      assets: '21,176,213.55',
    },
    {
      id: 272,
      tpaID: '362998347',
      tpaName: 'NATIONAL BENEFIT SERVICES INC (IL)',
      label: 'NATIONAL BENEFIT SERVICES INC (IL)',
      value: 'NATIONAL BENEFIT SERVICES INC (IL)',
      planCount: 9,
      selected: false,
      assets: '20,967,335.33',
    },
    {
      id: 273,
      tpaID: '582526504',
      tpaName: 'HA&W BENEFIT ADVISORS LLC',
      label: 'HA&W BENEFIT ADVISORS LLC',
      value: 'HA&W BENEFIT ADVISORS LLC',
      planCount: 8,
      selected: false,
      assets: '20,911,373.71',
    },
    {
      id: 274,
      tpaID: '850437924',
      tpaName: 'PATTISON PENSION SPECIALISTS',
      label: 'PATTISON PENSION SPECIALISTS',
      value: 'PATTISON PENSION SPECIALISTS',
      planCount: 5,
      selected: false,
      assets: '20,807,932.58',
    },
    {
      id: 275,
      tpaID: '593163228',
      tpaName: 'DGH & ASSOCIATES INC (DBA FLORIDA RETIREMENT CONSULTANTS)',
      label: 'DGH & ASSOCIATES INC (DBA FLORIDA RETIREMENT CONSULTANTS)',
      value: 'DGH & ASSOCIATES INC (DBA FLORIDA RETIREMENT CONSULTANTS)',
      planCount: 13,
      selected: false,
      assets: '20,751,123.66',
    },
    {
      id: 276,
      tpaID: '731051839',
      tpaName: 'MYSOCK CHEVAILLIER& BOLDEN LLP',
      label: 'MYSOCK CHEVAILLIER& BOLDEN LLP',
      value: 'MYSOCK CHEVAILLIER& BOLDEN LLP',
      planCount: 2,
      selected: false,
      assets: '20,644,057.41',
    },
    {
      id: 277,
      tpaID: '390758449',
      tpaName: 'WIPFLI LLP',
      label: 'WIPFLI LLP',
      value: 'WIPFLI LLP',
      planCount: 11,
      selected: false,
      assets: '20,615,632.51',
    },
    {
      id: 278,
      tpaID: '953001179',
      tpaName: 'WINDES INC',
      label: 'WINDES INC',
      value: 'WINDES INC',
      planCount: 3,
      selected: false,
      assets: '20,397,121.99',
    },
    {
      id: 279,
      tpaID: '270475956',
      tpaName: 'M PENSION GROUP LIMITED DBA ESTATE & PENSION ADVISORY BRD',
      label: 'M PENSION GROUP LIMITED DBA ESTATE & PENSION ADVISORY BRD',
      value: 'M PENSION GROUP LIMITED DBA ESTATE & PENSION ADVISORY BRD',
      planCount: 8,
      selected: false,
      assets: '20,261,982.15',
    },
    {
      id: 280,
      tpaID: '561721260',
      tpaName: 'QUALIFIED PLAN ADMINISTRATORS, INC. (NC)',
      label: 'QUALIFIED PLAN ADMINISTRATORS, INC. (NC)',
      value: 'QUALIFIED PLAN ADMINISTRATORS, INC. (NC)',
      planCount: 11,
      selected: false,
      assets: '20,045,719.61',
    },
    {
      id: 281,
      tpaID: '720999988',
      tpaName: 'SENTINEL PENSION, LLC',
      label: 'SENTINEL PENSION, LLC',
      value: 'SENTINEL PENSION, LLC',
      planCount: 6,
      selected: false,
      assets: '19,989,401.49',
    },
    {
      id: 282,
      tpaID: '132530357',
      tpaName: 'THOMPSON PENSION EMPLOYEE PLANS, INC.',
      label: 'THOMPSON PENSION EMPLOYEE PLANS, INC.',
      value: 'THOMPSON PENSION EMPLOYEE PLANS, INC.',
      planCount: 5,
      selected: false,
      assets: '19,955,417.12',
    },
    {
      id: 283,
      tpaID: '270212300',
      tpaName: 'FREEMAN RETIREMENT PLAN CONSULTING LLC',
      label: 'FREEMAN RETIREMENT PLAN CONSULTING LLC',
      value: 'FREEMAN RETIREMENT PLAN CONSULTING LLC',
      planCount: 2,
      selected: false,
      assets: '19,925,928.56',
    },
    {
      id: 284,
      tpaID: '650622023',
      tpaName: 'LEVY & ASSOCIATES',
      label: 'LEVY & ASSOCIATES',
      value: 'LEVY & ASSOCIATES',
      planCount: 3,
      selected: false,
      assets: '19,732,220.87',
    },
    {
      id: 285,
      tpaID: '201676141',
      tpaName: 'NICHOLAS HICKS & FARMERS INC',
      label: 'NICHOLAS HICKS & FARMERS INC',
      value: 'NICHOLAS HICKS & FARMERS INC',
      planCount: 9,
      selected: false,
      assets: '19,558,343.68',
    },
    {
      id: 286,
      tpaID: '931307583',
      tpaName: 'ALDRICH RETIREMENT SOLUTIONS',
      label: 'ALDRICH RETIREMENT SOLUTIONS',
      value: 'ALDRICH RETIREMENT SOLUTIONS',
      planCount: 7,
      selected: false,
      assets: '19,480,489.24',
    },
    {
      id: 287,
      tpaID: '050386704',
      tpaName: 'COMPENSATION PLANNING INC',
      label: 'COMPENSATION PLANNING INC',
      value: 'COMPENSATION PLANNING INC',
      planCount: 9,
      selected: false,
      assets: '19,397,608.55',
    },
    {
      id: 288,
      tpaID: '571113865',
      tpaName: 'STRINGER & COMPANY, INC. PENSION SERVICES',
      label: 'STRINGER & COMPANY, INC. PENSION SERVICES',
      value: 'STRINGER & COMPANY, INC. PENSION SERVICES',
      planCount: 20,
      selected: false,
      assets: '19,385,294.40',
    },
    {
      id: 289,
      tpaID: '834124826',
      tpaName: 'CRI TPA SERVICES, LLC',
      label: 'CRI TPA SERVICES, LLC',
      value: 'CRI TPA SERVICES, LLC',
      planCount: 13,
      selected: false,
      assets: '19,271,362.88',
    },
    {
      id: 290,
      tpaID: '710948945',
      tpaName: 'LEGACY BENEFIT SERVICES LLC',
      label: 'LEGACY BENEFIT SERVICES LLC',
      value: 'LEGACY BENEFIT SERVICES LLC',
      planCount: 2,
      selected: false,
      assets: '19,228,964.76',
    },
    {
      id: 291,
      tpaID: '990242337',
      tpaName: 'SUEMORI & INOUYE INC',
      label: 'SUEMORI & INOUYE INC',
      value: 'SUEMORI & INOUYE INC',
      planCount: 3,
      selected: false,
      assets: '19,152,678.48',
    },
    {
      id: 292,
      tpaID: '474324398',
      tpaName: 'THE HILB GROUP OF NEW ENGLAND LLC',
      label: 'THE HILB GROUP OF NEW ENGLAND LLC',
      value: 'THE HILB GROUP OF NEW ENGLAND LLC',
      planCount: 12,
      selected: false,
      assets: '19,065,854.49',
    },
    {
      id: 293,
      tpaID: '721450587',
      tpaName: 'RETIREMENT STRATEGIES GROUP, LLC',
      label: 'RETIREMENT STRATEGIES GROUP, LLC',
      value: 'RETIREMENT STRATEGIES GROUP, LLC',
      planCount: 4,
      selected: false,
      assets: '18,897,279.80',
    },
    {
      id: 294,
      tpaID: '251867808',
      tpaName: 'LIFESTYLE RETIREMENT COMPANY',
      label: 'LIFESTYLE RETIREMENT COMPANY',
      value: 'LIFESTYLE RETIREMENT COMPANY',
      planCount: 4,
      selected: false,
      assets: '18,785,524.36',
    },
    {
      id: 295,
      tpaID: '271318562',
      tpaName: 'PENSION KINETICS, INC.',
      label: 'PENSION KINETICS, INC.',
      value: 'PENSION KINETICS, INC.',
      planCount: 6,
      selected: false,
      assets: '18,613,131.46',
    },
    {
      id: 296,
      tpaID: '591575461',
      tpaName: 'PLAN ADVISORS, INC.',
      label: 'PLAN ADVISORS, INC.',
      value: 'PLAN ADVISORS, INC.',
      planCount: 4,
      selected: false,
      assets: '18,583,612.77',
    },
    {
      id: 297,
      tpaID: '421468222',
      tpaName: 'THE FINWAY GROUP LLC',
      label: 'THE FINWAY GROUP LLC',
      value: 'THE FINWAY GROUP LLC',
      planCount: 7,
      selected: false,
      assets: '18,226,834.69',
    },
    {
      id: 298,
      tpaID: '870517946',
      tpaName: 'COOK MARTIN POULSON PC',
      label: 'COOK MARTIN POULSON PC',
      value: 'COOK MARTIN POULSON PC',
      planCount: 18,
      selected: false,
      assets: '18,014,324.45',
    },
    {
      id: 299,
      tpaID: '453480687',
      tpaName: 'EVERGREEN RETIREMENT PLAN CONSULTING, LLC',
      label: 'EVERGREEN RETIREMENT PLAN CONSULTING, LLC',
      value: 'EVERGREEN RETIREMENT PLAN CONSULTING, LLC',
      planCount: 24,
      selected: false,
      assets: '17,876,664.97',
    },
    {
      id: 300,
      tpaID: '631239856',
      tpaName: 'WARREN AVERETT BENEFIT CONSULTANTS LLC',
      label: 'WARREN AVERETT BENEFIT CONSULTANTS LLC',
      value: 'WARREN AVERETT BENEFIT CONSULTANTS LLC',
      planCount: 5,
      selected: false,
      assets: '17,832,290.08',
    },
    {
      id: 301,
      tpaID: '870552653',
      tpaName: 'PENSIONS PLUS INC',
      label: 'PENSIONS PLUS INC',
      value: 'PENSIONS PLUS INC',
      planCount: 10,
      selected: false,
      assets: '17,812,429.88',
    },
    {
      id: 302,
      tpaID: '430661705',
      tpaName: 'KRAFT, MILES & TATUM LLC',
      label: 'KRAFT, MILES & TATUM LLC',
      value: 'KRAFT, MILES & TATUM LLC',
      planCount: 4,
      selected: false,
      assets: '17,579,695.56',
    },
    {
      id: 303,
      tpaID: '232250214',
      tpaName: 'ASSOCIATED BENEFIT PLANNERS, LTD',
      label: 'ASSOCIATED BENEFIT PLANNERS, LTD',
      value: 'ASSOCIATED BENEFIT PLANNERS, LTD',
      planCount: 9,
      selected: false,
      assets: '17,457,607.27',
    },
    {
      id: 304,
      tpaID: '382928964',
      tpaName: 'THE W.L. BURMEISTER COMPANY',
      label: 'THE W.L. BURMEISTER COMPANY',
      value: 'THE W.L. BURMEISTER COMPANY',
      planCount: 3,
      selected: false,
      assets: '17,456,467.76',
    },
    {
      id: 305,
      tpaID: '270711617',
      tpaName: 'AZALEA ADMINISTRATION LLC',
      label: 'AZALEA ADMINISTRATION LLC',
      value: 'AZALEA ADMINISTRATION LLC',
      planCount: 17,
      selected: false,
      assets: '17,349,819.38',
    },
    {
      id: 306,
      tpaID: '650420375',
      tpaName: 'THE PENSION SOURCE',
      label: 'THE PENSION SOURCE',
      value: 'THE PENSION SOURCE',
      planCount: 12,
      selected: false,
      assets: '17,051,869.02',
    },
    {
      id: 307,
      tpaID: '061080876',
      tpaName: 'DEVLIN & HALE ASSOCIATES, INC.',
      label: 'DEVLIN & HALE ASSOCIATES, INC.',
      value: 'DEVLIN & HALE ASSOCIATES, INC.',
      planCount: 10,
      selected: false,
      assets: '16,962,482.39',
    },
    {
      id: 308,
      tpaID: '131787163',
      tpaName: 'FEDERATION PENSION BUREAU, INC.',
      label: 'FEDERATION PENSION BUREAU, INC.',
      value: 'FEDERATION PENSION BUREAU, INC.',
      planCount: 12,
      selected: false,
      assets: '16,797,227.22',
    },
    {
      id: 309,
      tpaID: '261233837',
      tpaName: 'NEW PINNACLE CONSULTING GROUP LLC',
      label: 'NEW PINNACLE CONSULTING GROUP LLC',
      value: 'NEW PINNACLE CONSULTING GROUP LLC',
      planCount: 3,
      selected: false,
      assets: '16,389,490.16',
    },
    {
      id: 310,
      tpaID: '770573145',
      tpaName: 'OSBORNE & ASSOCIATES INC',
      label: 'OSBORNE & ASSOCIATES INC',
      value: 'OSBORNE & ASSOCIATES INC',
      planCount: 11,
      selected: false,
      assets: '16,371,594.33',
    },
    {
      id: 311,
      tpaID: '823750393',
      tpaName: 'RETIREMENT PLAN PROFESSIONALS LLC',
      label: 'RETIREMENT PLAN PROFESSIONALS LLC',
      value: 'RETIREMENT PLAN PROFESSIONALS LLC',
      planCount: 3,
      selected: false,
      assets: '16,362,310.45',
    },
    {
      id: 312,
      tpaID: '201694816',
      tpaName: 'SHORE TOMPKINS ACTUARIAL RESOURCES LLC',
      label: 'SHORE TOMPKINS ACTUARIAL RESOURCES LLC',
      value: 'SHORE TOMPKINS ACTUARIAL RESOURCES LLC',
      planCount: 7,
      selected: false,
      assets: '16,283,243.68',
    },
    {
      id: 313,
      tpaID: '953705481',
      tpaName: 'BARBICH HOOPER KING DILL HOFFMAN ACCT CORP',
      label: 'BARBICH HOOPER KING DILL HOFFMAN ACCT CORP',
      value: 'BARBICH HOOPER KING DILL HOFFMAN ACCT CORP',
      planCount: 14,
      selected: false,
      assets: '16,072,938.58',
    },
    {
      id: 314,
      tpaID: '341853512',
      tpaName: 'FARMERS TRUST COMPANY',
      label: 'FARMERS TRUST COMPANY',
      value: 'FARMERS TRUST COMPANY',
      planCount: 12,
      selected: false,
      assets: '15,921,021.51',
    },
    {
      id: 315,
      tpaID: '800102330',
      tpaName: 'FLEX-PLAN RETIREMENT SERVICES INC',
      label: 'FLEX-PLAN RETIREMENT SERVICES INC',
      value: 'FLEX-PLAN RETIREMENT SERVICES INC',
      planCount: 5,
      selected: false,
      assets: '15,784,507.79',
    },
    {
      id: 316,
      tpaID: '680414789',
      tpaName: 'CALIFORNIA RETIREMENT PLANS',
      label: 'CALIFORNIA RETIREMENT PLANS',
      value: 'CALIFORNIA RETIREMENT PLANS',
      planCount: 1,
      selected: false,
      assets: '15,735,150.88',
    },
    {
      id: 317,
      tpaID: '231735188',
      tpaName: 'PENNSYLVANIA PENSION PLANNERS INC',
      label: 'PENNSYLVANIA PENSION PLANNERS INC',
      value: 'PENNSYLVANIA PENSION PLANNERS INC',
      planCount: 10,
      selected: false,
      assets: '15,646,866.04',
    },
    {
      id: 318,
      tpaID: '330905143',
      tpaName: 'NFP RETIREMENT INC.',
      label: 'NFP RETIREMENT INC.',
      value: 'NFP RETIREMENT INC.',
      planCount: 11,
      selected: false,
      assets: '15,545,625.42',
    },
    {
      id: 319,
      tpaID: '161533601',
      tpaName: 'P&A RETIREMENT PLAN SERVICES, INC.',
      label: 'P&A RETIREMENT PLAN SERVICES, INC.',
      value: 'P&A RETIREMENT PLAN SERVICES, INC.',
      planCount: 4,
      selected: false,
      assets: '15,488,459.95',
    },
    {
      id: 320,
      tpaID: '941634959',
      tpaName: 'PACIFIC RETIREMENT PLAN INC',
      label: 'PACIFIC RETIREMENT PLAN INC',
      value: 'PACIFIC RETIREMENT PLAN INC',
      planCount: 4,
      selected: false,
      assets: '15,439,667.12',
    },
    {
      id: 321,
      tpaID: '134266176',
      tpaName: 'EMPLOYEE BENEFIT SYSTEMS INC',
      label: 'EMPLOYEE BENEFIT SYSTEMS INC',
      value: 'EMPLOYEE BENEFIT SYSTEMS INC',
      planCount: 5,
      selected: false,
      assets: '15,419,747.30',
    },
    {
      id: 322,
      tpaID: '232121805',
      tpaName: "STEPHEN B FRANKEL & CO INC T/A FRANKEL LERNER & O'CONNOR",
      label: "STEPHEN B FRANKEL & CO INC T/A FRANKEL LERNER & O'CONNOR",
      value: "STEPHEN B FRANKEL & CO INC T/A FRANKEL LERNER & O'CONNOR",
      planCount: 4,
      selected: false,
      assets: '15,389,592.00',
    },
    {
      id: 323,
      tpaID: '112931438',
      tpaName: 'LONG ISLAND EMPLOYEE BENEFITS GROUP LTD',
      label: 'LONG ISLAND EMPLOYEE BENEFITS GROUP LTD',
      value: 'LONG ISLAND EMPLOYEE BENEFITS GROUP LTD',
      planCount: 12,
      selected: false,
      assets: '15,372,572.10',
    },
    {
      id: 324,
      tpaID: '311124734',
      tpaName: 'AL MINOR & ASSOCIATES INC',
      label: 'AL MINOR & ASSOCIATES INC',
      value: 'AL MINOR & ASSOCIATES INC',
      planCount: 5,
      selected: false,
      assets: '15,370,010.47',
    },
    {
      id: 325,
      tpaID: '363492086',
      tpaName: 'CORRELL CO',
      label: 'CORRELL CO',
      value: 'CORRELL CO',
      planCount: 9,
      selected: false,
      assets: '15,223,440.55',
    },
    {
      id: 326,
      tpaID: '202668095',
      tpaName: 'RETIREMENT SOLUTION GROUP LLC',
      label: 'RETIREMENT SOLUTION GROUP LLC',
      value: 'RETIREMENT SOLUTION GROUP LLC',
      planCount: 4,
      selected: false,
      assets: '15,221,010.41',
    },
    {
      id: 327,
      tpaID: '201973276',
      tpaName: 'SPECTRUM EMPLOYEE BENEFITS INC',
      label: 'SPECTRUM EMPLOYEE BENEFITS INC',
      value: 'SPECTRUM EMPLOYEE BENEFITS INC',
      planCount: 10,
      selected: false,
      assets: '15,178,870.65',
    },
    {
      id: 328,
      tpaID: '383659534',
      tpaName: 'ADVANCED BENEFITS CONSULTING',
      label: 'ADVANCED BENEFITS CONSULTING',
      value: 'ADVANCED BENEFITS CONSULTING',
      planCount: 5,
      selected: false,
      assets: '15,099,198.61',
    },
    {
      id: 329,
      tpaID: '650353338',
      tpaName: 'PROGRESSIVE PENSION ADMINISTRATORS INC',
      label: 'PROGRESSIVE PENSION ADMINISTRATORS INC',
      value: 'PROGRESSIVE PENSION ADMINISTRATORS INC',
      planCount: 2,
      selected: false,
      assets: '14,972,348.10',
    },
    {
      id: 330,
      tpaID: '043015875',
      tpaName: 'SENTINEL BENEFITS & FINANCIAL GROUP',
      label: 'SENTINEL BENEFITS & FINANCIAL GROUP',
      value: 'SENTINEL BENEFITS & FINANCIAL GROUP',
      planCount: 7,
      selected: false,
      assets: '14,958,232.84',
    },
    {
      id: 331,
      tpaID: '822413612',
      tpaName: 'INCENTIVE BENEFITS, INC',
      label: 'INCENTIVE BENEFITS, INC',
      value: 'INCENTIVE BENEFITS, INC',
      planCount: 12,
      selected: false,
      assets: '14,835,728.37',
    },
    {
      id: 332,
      tpaID: '263672516',
      tpaName: 'YANGS PENSION CONSULTING INC',
      label: 'YANGS PENSION CONSULTING INC',
      value: 'YANGS PENSION CONSULTING INC',
      planCount: 20,
      selected: false,
      assets: '14,821,173.90',
    },
    {
      id: 333,
      tpaID: '540504608',
      tpaName: 'BROWN, EDWARDS & COMPANY, LLP',
      label: 'BROWN, EDWARDS & COMPANY, LLP',
      value: 'BROWN, EDWARDS & COMPANY, LLP',
      planCount: 10,
      selected: false,
      assets: '14,657,119.43',
    },
    {
      id: 334,
      tpaID: '824136506',
      tpaName: 'PIONEER PENSION CONSULTING, LLC',
      label: 'PIONEER PENSION CONSULTING, LLC',
      value: 'PIONEER PENSION CONSULTING, LLC',
      planCount: 1,
      selected: false,
      assets: '14,616,343.45',
    },
    {
      id: 335,
      tpaID: '820497661',
      tpaName: 'IEC GROUP INC',
      label: 'IEC GROUP INC',
      value: 'IEC GROUP INC',
      planCount: 20,
      selected: false,
      assets: '14,607,272.77',
    },
    {
      id: 336,
      tpaID: '251754607',
      tpaName: 'KINOL SHARIE LEYH & ASSOCIATES',
      label: 'KINOL SHARIE LEYH & ASSOCIATES',
      value: 'KINOL SHARIE LEYH & ASSOCIATES',
      planCount: 4,
      selected: false,
      assets: '14,563,146.14',
    },
    {
      id: 337,
      tpaID: '363132823',
      tpaName: 'HOWARD SIMON & ASSOCIATES INC',
      label: 'HOWARD SIMON & ASSOCIATES INC',
      value: 'HOWARD SIMON & ASSOCIATES INC',
      planCount: 5,
      selected: false,
      assets: '14,261,198.77',
    },
    {
      id: 338,
      tpaID: '651279994',
      tpaName: 'SIEGEL ACTUARIAL CONSULTING INC',
      label: 'SIEGEL ACTUARIAL CONSULTING INC',
      value: 'SIEGEL ACTUARIAL CONSULTING INC',
      planCount: 23,
      selected: false,
      assets: '14,116,545.79',
    },
    {
      id: 339,
      tpaID: '480567703',
      tpaName: 'K COE ISOM LLP',
      label: 'K COE ISOM LLP',
      value: 'K COE ISOM LLP',
      planCount: 1,
      selected: false,
      assets: '14,096,365.56',
    },
    {
      id: 340,
      tpaID: '223765343',
      tpaName: 'LAR PENSIONS LLC',
      label: 'LAR PENSIONS LLC',
      value: 'LAR PENSIONS LLC',
      planCount: 7,
      selected: false,
      assets: '14,095,953.32',
    },
    {
      id: 341,
      tpaID: '522309851',
      tpaName: 'EAGLESTONE RETIREMENT SERVICES (MARTIN)',
      label: 'EAGLESTONE RETIREMENT SERVICES (MARTIN)',
      value: 'EAGLESTONE RETIREMENT SERVICES (MARTIN)',
      planCount: 8,
      selected: false,
      assets: '14,062,686.73',
    },
    {
      id: 342,
      tpaID: '232503024',
      tpaName: 'BEYER-BARBER CO',
      label: 'BEYER-BARBER CO',
      value: 'BEYER-BARBER CO',
      planCount: 1,
      selected: false,
      assets: '14,041,861.07',
    },
    {
      id: 343,
      tpaID: '135381590',
      tpaName: 'BDO USA, LLP',
      label: 'BDO USA, LLP',
      value: 'BDO USA, LLP',
      planCount: 8,
      selected: false,
      assets: '14,010,745.76',
    },
    {
      id: 344,
      tpaID: '650246402',
      tpaName: 'KENNETH F. HACKETT & ASSOC',
      label: 'KENNETH F. HACKETT & ASSOC',
      value: 'KENNETH F. HACKETT & ASSOC',
      planCount: 2,
      selected: false,
      assets: '13,850,763.53',
    },
    {
      id: 345,
      tpaID: '223772037',
      tpaName: 'THE RETIREMENT GROUP, LLC',
      label: 'THE RETIREMENT GROUP, LLC',
      value: 'THE RETIREMENT GROUP, LLC',
      planCount: 22,
      selected: false,
      assets: '13,845,424.08',
    },
    {
      id: 346,
      tpaID: '680603460',
      tpaName: '401K AMERICA INC.',
      label: '401K AMERICA INC.',
      value: '401K AMERICA INC.',
      planCount: 9,
      selected: false,
      assets: '13,623,369.68',
    },
    {
      id: 347,
      tpaID: '201196344',
      tpaName: 'GUIDANT FINANCIAL GROUP INC',
      label: 'GUIDANT FINANCIAL GROUP INC',
      value: 'GUIDANT FINANCIAL GROUP INC',
      planCount: 44,
      selected: false,
      assets: '13,618,400.10',
    },
    {
      id: 348,
      tpaID: '943369577',
      tpaName: 'VRS PENSION SERVICES, INC.',
      label: 'VRS PENSION SERVICES, INC.',
      value: 'VRS PENSION SERVICES, INC.',
      planCount: 1,
      selected: false,
      assets: '13,488,376.31',
    },
    {
      id: 349,
      tpaID: '208227133',
      tpaName: 'VALLEY NATIONAL ADMINSTRATIVE SERVICES, LLC',
      label: 'VALLEY NATIONAL ADMINSTRATIVE SERVICES, LLC',
      value: 'VALLEY NATIONAL ADMINSTRATIVE SERVICES, LLC',
      planCount: 1,
      selected: false,
      assets: '13,477,435.81',
    },
    {
      id: 350,
      tpaID: '201301962',
      tpaName: 'TPP CERTIFIED PUBLIC ACCOUNTANTS, LLC',
      label: 'TPP CERTIFIED PUBLIC ACCOUNTANTS, LLC',
      value: 'TPP CERTIFIED PUBLIC ACCOUNTANTS, LLC',
      planCount: 5,
      selected: false,
      assets: '13,386,451.31',
    },
    {
      id: 351,
      tpaID: '800138348',
      tpaName: 'CORPORATE FINANCIAL SERVICES, LLC',
      label: 'CORPORATE FINANCIAL SERVICES, LLC',
      value: 'CORPORATE FINANCIAL SERVICES, LLC',
      planCount: 4,
      selected: false,
      assets: '12,997,985.52',
    },
    {
      id: 352,
      tpaID: '200116061',
      tpaName: 'STAFFORDSHIRE BENEFIT CONSULTING, LLC',
      label: 'STAFFORDSHIRE BENEFIT CONSULTING, LLC',
      value: 'STAFFORDSHIRE BENEFIT CONSULTING, LLC',
      planCount: 3,
      selected: false,
      assets: '12,981,927.37',
    },
    {
      id: 353,
      tpaID: '521377484',
      tpaName: 'CREATIVE BENEFIT SERVICES INC',
      label: 'CREATIVE BENEFIT SERVICES INC',
      value: 'CREATIVE BENEFIT SERVICES INC',
      planCount: 10,
      selected: false,
      assets: '12,925,045.37',
    },
    {
      id: 354,
      tpaID: '410975573',
      tpaName: 'REDPATH AND COMPANY, LTD.',
      label: 'REDPATH AND COMPANY, LTD.',
      value: 'REDPATH AND COMPANY, LTD.',
      planCount: 3,
      selected: false,
      assets: '12,916,600.76',
    },
    {
      id: 355,
      tpaID: '953718031',
      tpaName: 'DISSINGER ASSOCIATES PLAN ADMINISTRATION & DESIGN INC',
      label: 'DISSINGER ASSOCIATES PLAN ADMINISTRATION & DESIGN INC',
      value: 'DISSINGER ASSOCIATES PLAN ADMINISTRATION & DESIGN INC',
      planCount: 5,
      selected: false,
      assets: '12,617,592.37',
    },
    {
      id: 356,
      tpaID: '202055473',
      tpaName: 'DELAWARE VALLEY RETIREMENT INC',
      label: 'DELAWARE VALLEY RETIREMENT INC',
      value: 'DELAWARE VALLEY RETIREMENT INC',
      planCount: 11,
      selected: false,
      assets: '12,438,872.05',
    },
    {
      id: 357,
      tpaID: '621417683',
      tpaName: 'ELLIS BENEFITS GROUP, INC',
      label: 'ELLIS BENEFITS GROUP, INC',
      value: 'ELLIS BENEFITS GROUP, INC',
      planCount: 2,
      selected: false,
      assets: '12,323,928.70',
    },
    {
      id: 358,
      tpaID: '742533381',
      tpaName: 'JAYNES, REITMEIER, BOYD & THERRELL P.C.',
      label: 'JAYNES, REITMEIER, BOYD & THERRELL P.C.',
      value: 'JAYNES, REITMEIER, BOYD & THERRELL P.C.',
      planCount: 6,
      selected: false,
      assets: '12,282,494.29',
    },
    {
      id: 359,
      tpaID: '651258348',
      tpaName: 'INTEGRA BENEFITS CONSULTING LLC',
      label: 'INTEGRA BENEFITS CONSULTING LLC',
      value: 'INTEGRA BENEFITS CONSULTING LLC',
      planCount: 5,
      selected: false,
      assets: '12,127,415.04',
    },
    {
      id: 360,
      tpaID: '630868034',
      tpaName: 'SMA SERVICES INC',
      label: 'SMA SERVICES INC',
      value: 'SMA SERVICES INC',
      planCount: 6,
      selected: false,
      assets: '12,045,439.49',
    },
    {
      id: 361,
      tpaID: '522061078',
      tpaName: 'HCI-EBS INC',
      label: 'HCI-EBS INC',
      value: 'HCI-EBS INC',
      planCount: 4,
      selected: false,
      assets: '12,011,652.22',
    },
    {
      id: 362,
      tpaID: '831239374',
      tpaName: 'PREMIER RETIREMENT PARTNERS LLC',
      label: 'PREMIER RETIREMENT PARTNERS LLC',
      value: 'PREMIER RETIREMENT PARTNERS LLC',
      planCount: 8,
      selected: false,
      assets: '12,001,868.53',
    },
    {
      id: 363,
      tpaID: '811963646',
      tpaName: 'ANEW 401K TPA LLC',
      label: 'ANEW 401K TPA LLC',
      value: 'ANEW 401K TPA LLC',
      planCount: 10,
      selected: false,
      assets: '11,947,840.95',
    },
    {
      id: 364,
      tpaID: '208792156',
      tpaName: 'MILLENNIUM PENSION SERVICES INC',
      label: 'MILLENNIUM PENSION SERVICES INC',
      value: 'MILLENNIUM PENSION SERVICES INC',
      planCount: 26,
      selected: false,
      assets: '11,651,939.88',
    },
    {
      id: 365,
      tpaID: '223816889',
      tpaName: 'HUNTINGTON FINANCIAL GROUP LLC',
      label: 'HUNTINGTON FINANCIAL GROUP LLC',
      value: 'HUNTINGTON FINANCIAL GROUP LLC',
      planCount: 5,
      selected: false,
      assets: '11,614,522.64',
    },
    {
      id: 366,
      tpaID: '352126602',
      tpaName: 'ONEAMERICA',
      label: 'ONEAMERICA',
      value: 'ONEAMERICA',
      planCount: 2,
      selected: false,
      assets: '11,599,293.38',
    },
    {
      id: 367,
      tpaID: '456064129',
      tpaName: 'MILLER & ASSOCIATES CPAS AND ADVISORS, LLC',
      label: 'MILLER & ASSOCIATES CPAS AND ADVISORS, LLC',
      value: 'MILLER & ASSOCIATES CPAS AND ADVISORS, LLC',
      planCount: 1,
      selected: false,
      assets: '11,544,373.95',
    },
    {
      id: 368,
      tpaID: '364561119',
      tpaName: 'INDEPENDENT ACTUARIES INC',
      label: 'INDEPENDENT ACTUARIES INC',
      value: 'INDEPENDENT ACTUARIES INC',
      planCount: 2,
      selected: false,
      assets: '11,474,694.46',
    },
    {
      id: 369,
      tpaID: '363905542',
      tpaName: 'DANA CONSULTING GROUP LTD',
      label: 'DANA CONSULTING GROUP LTD',
      value: 'DANA CONSULTING GROUP LTD',
      planCount: 4,
      selected: false,
      assets: '11,409,106.73',
    },
    {
      id: 370,
      tpaID: '382065641',
      tpaName: 'MIDWEST PENSION ACTUARIES, INC.',
      label: 'MIDWEST PENSION ACTUARIES, INC.',
      value: 'MIDWEST PENSION ACTUARIES, INC.',
      planCount: 6,
      selected: false,
      assets: '11,356,164.98',
    },
    {
      id: 371,
      tpaID: '352519056',
      tpaName: 'BENETRENDS, INC.',
      label: 'BENETRENDS, INC.',
      value: 'BENETRENDS, INC.',
      planCount: 29,
      selected: false,
      assets: '11,150,486.06',
    },
    {
      id: 372,
      tpaID: '330074418',
      tpaName: 'INLAND COUNTIES PENSION SERVICES INC',
      label: 'INLAND COUNTIES PENSION SERVICES INC',
      value: 'INLAND COUNTIES PENSION SERVICES INC',
      planCount: 6,
      selected: false,
      assets: '11,075,170.38',
    },
    {
      id: 373,
      tpaID: '363760178',
      tpaName: 'MIDWEST BENEFIT CONSULTANTS LTD',
      label: 'MIDWEST BENEFIT CONSULTANTS LTD',
      value: 'MIDWEST BENEFIT CONSULTANTS LTD',
      planCount: 1,
      selected: false,
      assets: '10,966,081.41',
    },
    {
      id: 374,
      tpaID: '742619440',
      tpaName: 'BREHM HAVEL & CO LLP',
      label: 'BREHM HAVEL & CO LLP',
      value: 'BREHM HAVEL & CO LLP',
      planCount: 5,
      selected: false,
      assets: '10,937,316.58',
    },
    {
      id: 375,
      tpaID: '205924713',
      tpaName: 'INNOVATIVE PENSION CONSULTING',
      label: 'INNOVATIVE PENSION CONSULTING',
      value: 'INNOVATIVE PENSION CONSULTING',
      planCount: 5,
      selected: false,
      assets: '10,904,791.50',
    },
    {
      id: 376,
      tpaID: '550578023',
      tpaName: 'BENEFIT PLANS SERVICES INC',
      label: 'BENEFIT PLANS SERVICES INC',
      value: 'BENEFIT PLANS SERVICES INC',
      planCount: 11,
      selected: false,
      assets: '10,854,178.75',
    },
    {
      id: 377,
      tpaID: '300132514',
      tpaName: 'BRIXEY & MEYER, INC.',
      label: 'BRIXEY & MEYER, INC.',
      value: 'BRIXEY & MEYER, INC.',
      planCount: 5,
      selected: false,
      assets: '10,848,737.35',
    },
    {
      id: 378,
      tpaID: '363168081',
      tpaName: 'SIKICH LLP',
      label: 'SIKICH LLP',
      value: 'SIKICH LLP',
      planCount: 5,
      selected: false,
      assets: '10,765,567.65',
    },
    {
      id: 379,
      tpaID: '231669823',
      tpaName: 'CONRAD M SIEGEL INC',
      label: 'CONRAD M SIEGEL INC',
      value: 'CONRAD M SIEGEL INC',
      planCount: 6,
      selected: false,
      assets: '10,617,271.33',
    },
    {
      id: 380,
      tpaID: '954697403',
      tpaName: 'BOYARSKY CONSULTING GROUP INC',
      label: 'BOYARSKY CONSULTING GROUP INC',
      value: 'BOYARSKY CONSULTING GROUP INC',
      planCount: 6,
      selected: false,
      assets: '10,580,205.07',
    },
    {
      id: 381,
      tpaID: '341487217',
      tpaName: 'OMEGA PENSIONS, INC.',
      label: 'OMEGA PENSIONS, INC.',
      value: 'OMEGA PENSIONS, INC.',
      planCount: 5,
      selected: false,
      assets: '10,543,455.91',
    },
    {
      id: 382,
      tpaID: '611959547',
      tpaName: 'DUNCAN FINANCIAL GROUP LLC',
      label: 'DUNCAN FINANCIAL GROUP LLC',
      value: 'DUNCAN FINANCIAL GROUP LLC',
      planCount: 12,
      selected: false,
      assets: '10,435,881.37',
    },
    {
      id: 383,
      tpaID: '451665651',
      tpaName: 'ADVANCED PLAN DESIGNS LLC',
      label: 'ADVANCED PLAN DESIGNS LLC',
      value: 'ADVANCED PLAN DESIGNS LLC',
      planCount: 16,
      selected: false,
      assets: '10,428,616.67',
    },
    {
      id: 384,
      tpaID: '465055797',
      tpaName: 'SETAWAY LLC',
      label: 'SETAWAY LLC',
      value: 'SETAWAY LLC',
      planCount: 9,
      selected: false,
      assets: '10,389,510.05',
    },
    {
      id: 385,
      tpaID: '541794470',
      tpaName: 'ATLANTIC PENSIONS, INC.',
      label: 'ATLANTIC PENSIONS, INC.',
      value: 'ATLANTIC PENSIONS, INC.',
      planCount: 1,
      selected: false,
      assets: '10,315,272.84',
    },
    {
      id: 386,
      tpaID: '260292438',
      tpaName: 'THE PENSION COMPANY LLC',
      label: 'THE PENSION COMPANY LLC',
      value: 'THE PENSION COMPANY LLC',
      planCount: 6,
      selected: false,
      assets: '10,285,401.99',
    },
    {
      id: 387,
      tpaID: '931098102',
      tpaName: 'SUMMIT BENEFIT & ACTUARIAL SERVICES',
      label: 'SUMMIT BENEFIT & ACTUARIAL SERVICES',
      value: 'SUMMIT BENEFIT & ACTUARIAL SERVICES',
      planCount: 2,
      selected: false,
      assets: '9,995,649.85',
    },
    {
      id: 388,
      tpaID: '042547708',
      tpaName: 'BOULAY DONNELLY & SUPOVITZ CONSULTING GROUP INC',
      label: 'BOULAY DONNELLY & SUPOVITZ CONSULTING GROUP INC',
      value: 'BOULAY DONNELLY & SUPOVITZ CONSULTING GROUP INC',
      planCount: 3,
      selected: false,
      assets: '9,930,661.68',
    },
    {
      id: 389,
      tpaID: '112515970',
      tpaName: 'CREATIVE PLAN DESIGNS LTD',
      label: 'CREATIVE PLAN DESIGNS LTD',
      value: 'CREATIVE PLAN DESIGNS LTD',
      planCount: 4,
      selected: false,
      assets: '9,832,998.71',
    },
    {
      id: 390,
      tpaID: '421482611',
      tpaName: 'PARADIGM BENEFITS LLC',
      label: 'PARADIGM BENEFITS LLC',
      value: 'PARADIGM BENEFITS LLC',
      planCount: 7,
      selected: false,
      assets: '9,780,663.76',
    },
    {
      id: 391,
      tpaID: '822854480',
      tpaName: 'BLUE HARBOR RETIREMENT PLAN SERVICES, LLC',
      label: 'BLUE HARBOR RETIREMENT PLAN SERVICES, LLC',
      value: 'BLUE HARBOR RETIREMENT PLAN SERVICES, LLC',
      planCount: 17,
      selected: false,
      assets: '9,616,262.32',
    },
    {
      id: 392,
      tpaID: '331018824',
      tpaName: 'OAK CREEK PARTNERS LLC',
      label: 'OAK CREEK PARTNERS LLC',
      value: 'OAK CREEK PARTNERS LLC',
      planCount: 1,
      selected: false,
      assets: '9,600,769.14',
    },
    {
      id: 393,
      tpaID: '870364490',
      tpaName: 'ALLIANCE BENEFIT GROUP - ROCKY MOUNTAIN',
      label: 'ALLIANCE BENEFIT GROUP - ROCKY MOUNTAIN',
      value: 'ALLIANCE BENEFIT GROUP - ROCKY MOUNTAIN',
      planCount: 6,
      selected: false,
      assets: '9,573,228.50',
    },
    {
      id: 394,
      tpaID: '611291181',
      tpaName: 'BENEFITS ADMINISTRATORS LLC',
      label: 'BENEFITS ADMINISTRATORS LLC',
      value: 'BENEFITS ADMINISTRATORS LLC',
      planCount: 6,
      selected: false,
      assets: '9,560,799.56',
    },
    {
      id: 395,
      tpaID: '330384246',
      tpaName: 'BENEFIT EQUITY INC',
      label: 'BENEFIT EQUITY INC',
      value: 'BENEFIT EQUITY INC',
      planCount: 13,
      selected: false,
      assets: '9,543,462.97',
    },
    {
      id: 396,
      tpaID: '910675641',
      tpaName: 'MILLIMAN INC',
      label: 'MILLIMAN INC',
      value: 'MILLIMAN INC',
      planCount: 1,
      selected: false,
      assets: '9,519,961.69',
    },
    {
      id: 397,
      tpaID: '208063889',
      tpaName: 'LAW OFFICES OF R DAVID DANZIGER PC',
      label: 'LAW OFFICES OF R DAVID DANZIGER PC',
      value: 'LAW OFFICES OF R DAVID DANZIGER PC',
      planCount: 2,
      selected: false,
      assets: '9,475,955.41',
    },
    {
      id: 398,
      tpaID: '133008320',
      tpaName: 'ADVANCED PENSION ACTUARIES INC',
      label: 'ADVANCED PENSION ACTUARIES INC',
      value: 'ADVANCED PENSION ACTUARIES INC',
      planCount: 4,
      selected: false,
      assets: '9,467,450.41',
    },
    {
      id: 399,
      tpaID: '954051480',
      tpaName: 'NATIONAL PENSION SERVICES CORPORATION',
      label: 'NATIONAL PENSION SERVICES CORPORATION',
      value: 'NATIONAL PENSION SERVICES CORPORATION',
      planCount: 5,
      selected: false,
      assets: '9,424,746.14',
    },
    {
      id: 400,
      tpaID: '203970947',
      tpaName: 'PINNACLE PLAN DESIGN LLC',
      label: 'PINNACLE PLAN DESIGN LLC',
      value: 'PINNACLE PLAN DESIGN LLC',
      planCount: 5,
      selected: false,
      assets: '9,381,727.90',
    },
    {
      id: 401,
      tpaID: '710816002',
      tpaName: 'PENSION PLAN ADMINISTRATION LLC',
      label: 'PENSION PLAN ADMINISTRATION LLC',
      value: 'PENSION PLAN ADMINISTRATION LLC',
      planCount: 6,
      selected: false,
      assets: '9,218,771.08',
    },
    {
      id: 402,
      tpaID: '480890241',
      tpaName: 'DEMARS PENSION CONSULTING SERVICES, INC',
      label: 'DEMARS PENSION CONSULTING SERVICES, INC',
      value: 'DEMARS PENSION CONSULTING SERVICES, INC',
      planCount: 5,
      selected: false,
      assets: '9,180,868.84',
    },
    {
      id: 403,
      tpaID: '310795487',
      tpaName: 'CLAYTON SCROGGINS ASSOCIATES INC',
      label: 'CLAYTON SCROGGINS ASSOCIATES INC',
      value: 'CLAYTON SCROGGINS ASSOCIATES INC',
      planCount: 3,
      selected: false,
      assets: '9,132,599.39',
    },
    {
      id: 404,
      tpaID: '731377309',
      tpaName: 'THOMAS E. CUMMINS, CONSULTING ACTUARY, INC.',
      label: 'THOMAS E. CUMMINS, CONSULTING ACTUARY, INC.',
      value: 'THOMAS E. CUMMINS, CONSULTING ACTUARY, INC.',
      planCount: 1,
      selected: false,
      assets: '9,106,769.37',
    },
    {
      id: 405,
      tpaID: '451200308',
      tpaName: 'LEADING RETIREMENT SOLUTIONS, LLC',
      label: 'LEADING RETIREMENT SOLUTIONS, LLC',
      value: 'LEADING RETIREMENT SOLUTIONS, LLC',
      planCount: 8,
      selected: false,
      assets: '9,053,640.56',
    },
    {
      id: 406,
      tpaID: '411933070',
      tpaName: 'CDS ADMINISTRATIVE SERVICES LLC',
      label: 'CDS ADMINISTRATIVE SERVICES LLC',
      value: 'CDS ADMINISTRATIVE SERVICES LLC',
      planCount: 5,
      selected: false,
      assets: '8,988,516.39',
    },
    {
      id: 407,
      tpaID: '112854627',
      tpaName: 'PENSION DESIGN SERVICES INC',
      label: 'PENSION DESIGN SERVICES INC',
      value: 'PENSION DESIGN SERVICES INC',
      planCount: 3,
      selected: false,
      assets: '8,974,893.28',
    },
    {
      id: 408,
      tpaID: '341815631',
      tpaName: 'CREATIVE BENEFIT STRATEGIES, INC.',
      label: 'CREATIVE BENEFIT STRATEGIES, INC.',
      value: 'CREATIVE BENEFIT STRATEGIES, INC.',
      planCount: 2,
      selected: false,
      assets: '8,973,866.70',
    },
    {
      id: 409,
      tpaID: '562263714',
      tpaName: 'MVP PLAN ADMINISTRATORS, INC.',
      label: 'MVP PLAN ADMINISTRATORS, INC.',
      value: 'MVP PLAN ADMINISTRATORS, INC.',
      planCount: 10,
      selected: false,
      assets: '8,935,802.11',
    },
    {
      id: 410,
      tpaID: '474270951',
      tpaName: 'KANE PENSION DESIGN AND ADMINISTRATION LLC',
      label: 'KANE PENSION DESIGN AND ADMINISTRATION LLC',
      value: 'KANE PENSION DESIGN AND ADMINISTRATION LLC',
      planCount: 15,
      selected: false,
      assets: '8,871,343.16',
    },
    {
      id: 411,
      tpaID: '463335003',
      tpaName: 'PENSION PROFIT SHARING SERVICES INC',
      label: 'PENSION PROFIT SHARING SERVICES INC',
      value: 'PENSION PROFIT SHARING SERVICES INC',
      planCount: 12,
      selected: false,
      assets: '8,861,546.33',
    },
    {
      id: 412,
      tpaID: '593634521',
      tpaName: 'PENSERVCO INC',
      label: 'PENSERVCO INC',
      value: 'PENSERVCO INC',
      planCount: 2,
      selected: false,
      assets: '8,820,863.64',
    },
    {
      id: 413,
      tpaID: '562310804',
      tpaName: 'PRESBERG PENSIONS, INC.',
      label: 'PRESBERG PENSIONS, INC.',
      value: 'PRESBERG PENSIONS, INC.',
      planCount: 4,
      selected: false,
      assets: '8,720,468.88',
    },
    {
      id: 414,
      tpaID: '461931817',
      tpaName: 'THE AIMPOINT GROUP LLC',
      label: 'THE AIMPOINT GROUP LLC',
      value: 'THE AIMPOINT GROUP LLC',
      planCount: 13,
      selected: false,
      assets: '8,616,273.20',
    },
    {
      id: 415,
      tpaID: '813429076',
      tpaName: 'RETIREWELL ADMINISTRATORS INC',
      label: 'RETIREWELL ADMINISTRATORS INC',
      value: 'RETIREWELL ADMINISTRATORS INC',
      planCount: 13,
      selected: false,
      assets: '8,573,336.31',
    },
    {
      id: 416,
      tpaID: '261766327',
      tpaName: 'OPEN ACQ LLC',
      label: 'OPEN ACQ LLC',
      value: 'OPEN ACQ LLC',
      planCount: 3,
      selected: false,
      assets: '8,570,238.91',
    },
    {
      id: 417,
      tpaID: '812104036',
      tpaName: 'ATLAS PENSION, INC.',
      label: 'ATLAS PENSION, INC.',
      value: 'ATLAS PENSION, INC.',
      planCount: 8,
      selected: false,
      assets: '8,564,891.70',
    },
    {
      id: 418,
      tpaID: '952694444',
      tpaName: 'CONSIDINE & CONSIDINE',
      label: 'CONSIDINE & CONSIDINE',
      value: 'CONSIDINE & CONSIDINE',
      planCount: 6,
      selected: false,
      assets: '8,543,554.21',
    },
    {
      id: 419,
      tpaID: '822808769',
      tpaName: 'UNITED PENSION DESIGNS, LLC',
      label: 'UNITED PENSION DESIGNS, LLC',
      value: 'UNITED PENSION DESIGNS, LLC',
      planCount: 4,
      selected: false,
      assets: '8,467,367.29',
    },
    {
      id: 420,
      tpaID: '861009405',
      tpaName: 'NORTON RETIREMENT SERVICES, INC.',
      label: 'NORTON RETIREMENT SERVICES, INC.',
      value: 'NORTON RETIREMENT SERVICES, INC.',
      planCount: 8,
      selected: false,
      assets: '8,458,362.75',
    },
    {
      id: 421,
      tpaID: '611440646',
      tpaName: 'MIDWEST GROUP BENEFITS INC',
      label: 'MIDWEST GROUP BENEFITS INC',
      value: 'MIDWEST GROUP BENEFITS INC',
      planCount: 6,
      selected: false,
      assets: '8,457,906.75',
    },
    {
      id: 422,
      tpaID: '822717929',
      tpaName: 'BENCHMARK RETIREMENT PLAN SERVICES, INC.',
      label: 'BENCHMARK RETIREMENT PLAN SERVICES, INC.',
      value: 'BENCHMARK RETIREMENT PLAN SERVICES, INC.',
      planCount: 5,
      selected: false,
      assets: '8,359,794.19',
    },
    {
      id: 423,
      tpaID: '201273889',
      tpaName: 'PLATINUM PENSION GROUP LLC',
      label: 'PLATINUM PENSION GROUP LLC',
      value: 'PLATINUM PENSION GROUP LLC',
      planCount: 2,
      selected: false,
      assets: '8,351,871.21',
    },
    {
      id: 424,
      tpaID: '820433443',
      tpaName: 'PINNACLE PENSION SERVICES',
      label: 'PINNACLE PENSION SERVICES',
      value: 'PINNACLE PENSION SERVICES',
      planCount: 6,
      selected: false,
      assets: '8,307,026.56',
    },
    {
      id: 425,
      tpaID: '273395775',
      tpaName: 'HARPER DANESH LLC',
      label: 'HARPER DANESH LLC',
      value: 'HARPER DANESH LLC',
      planCount: 1,
      selected: false,
      assets: '8,230,509.33',
    },
    {
      id: 426,
      tpaID: '720894768',
      tpaName: 'FLOWER & ASSOCIATES INC',
      label: 'FLOWER & ASSOCIATES INC',
      value: 'FLOWER & ASSOCIATES INC',
      planCount: 3,
      selected: false,
      assets: '8,010,122.45',
    },
    {
      id: 427,
      tpaID: '721396518',
      tpaName: 'INDEPENDENT PENSION SOLUTIONS LLC',
      label: 'INDEPENDENT PENSION SOLUTIONS LLC',
      value: 'INDEPENDENT PENSION SOLUTIONS LLC',
      planCount: 2,
      selected: false,
      assets: '8,005,927.50',
    },
    {
      id: 428,
      tpaID: '202371094',
      tpaName: 'PFP-NJ INC',
      label: 'PFP-NJ INC',
      value: 'PFP-NJ INC',
      planCount: 2,
      selected: false,
      assets: '7,997,856.47',
    },
    {
      id: 429,
      tpaID: '111986323',
      tpaName: 'MARCUM LLP',
      label: 'MARCUM LLP',
      value: 'MARCUM LLP',
      planCount: 3,
      selected: false,
      assets: '7,961,654.96',
    },
    {
      id: 430,
      tpaID: '680369583',
      tpaName: 'JORDAN & ASSOCIATES RETIREMENT SERVICES',
      label: 'JORDAN & ASSOCIATES RETIREMENT SERVICES',
      value: 'JORDAN & ASSOCIATES RETIREMENT SERVICES',
      planCount: 4,
      selected: false,
      assets: '7,946,036.57',
    },
    {
      id: 431,
      tpaID: '475015396',
      tpaName: 'FINANCIALFOCUS RETIREMENT PLAN SERVICES, LLC',
      label: 'FINANCIALFOCUS RETIREMENT PLAN SERVICES, LLC',
      value: 'FINANCIALFOCUS RETIREMENT PLAN SERVICES, LLC',
      planCount: 8,
      selected: false,
      assets: '7,913,909.18',
    },
    {
      id: 433,
      tpaID: '364136186',
      tpaName: 'PENSION PERFORMANCE INC',
      label: 'PENSION PERFORMANCE INC',
      value: 'PENSION PERFORMANCE INC',
      planCount: 2,
      selected: false,
      assets: '7,904,874.27',
    },
    {
      id: 434,
      tpaID: '161191551',
      tpaName: 'NORTHEAST BENEFIT SERVICES INC',
      label: 'NORTHEAST BENEFIT SERVICES INC',
      value: 'NORTHEAST BENEFIT SERVICES INC',
      planCount: 1,
      selected: false,
      assets: '7,889,149.49',
    },
    {
      id: 435,
      tpaID: '592166422',
      tpaName: 'PENSION INVESTORS CORPORATION OF ORLANDO INC',
      label: 'PENSION INVESTORS CORPORATION OF ORLANDO INC',
      value: 'PENSION INVESTORS CORPORATION OF ORLANDO INC',
      planCount: 6,
      selected: false,
      assets: '7,873,679.76',
    },
    {
      id: 436,
      tpaID: '461499818',
      tpaName: 'WILLIAMS BENEFIT CONSULTING, LLC',
      label: 'WILLIAMS BENEFIT CONSULTING, LLC',
      value: 'WILLIAMS BENEFIT CONSULTING, LLC',
      planCount: 3,
      selected: false,
      assets: '7,844,938.45',
    },
    {
      id: 437,
      tpaID: '650721164',
      tpaName: 'KB PENSION SERVICES INC',
      label: 'KB PENSION SERVICES INC',
      value: 'KB PENSION SERVICES INC',
      planCount: 6,
      selected: false,
      assets: '7,819,772.12',
    },
    {
      id: 438,
      tpaID: '800968774',
      tpaName: 'RETIREMENTPLANS.COM, LLC',
      label: 'RETIREMENTPLANS.COM, LLC',
      value: 'RETIREMENTPLANS.COM, LLC',
      planCount: 7,
      selected: false,
      assets: '7,657,630.55',
    },
    {
      id: 439,
      tpaID: '522290047',
      tpaName: 'KEBS, INC.',
      label: 'KEBS, INC.',
      value: 'KEBS, INC.',
      planCount: 5,
      selected: false,
      assets: '7,649,889.73',
    },
    {
      id: 440,
      tpaID: '450514557',
      tpaName: 'GOLDLEAF PARTNERS SERVICES INC',
      label: 'GOLDLEAF PARTNERS SERVICES INC',
      value: 'GOLDLEAF PARTNERS SERVICES INC',
      planCount: 4,
      selected: false,
      assets: '7,628,005.84',
    },
    {
      id: 441,
      tpaID: '710704639',
      tpaName: 'WERNTZ AND ASSOCIATES INC',
      label: 'WERNTZ AND ASSOCIATES INC',
      value: 'WERNTZ AND ASSOCIATES INC',
      planCount: 4,
      selected: false,
      assets: '7,608,446.83',
    },
    {
      id: 442,
      tpaID: '364280141',
      tpaName: 'QUALIFIED PENSION PROFESSIONALS INC',
      label: 'QUALIFIED PENSION PROFESSIONALS INC',
      value: 'QUALIFIED PENSION PROFESSIONALS INC',
      planCount: 4,
      selected: false,
      assets: '7,606,865.35',
    },
    {
      id: 443,
      tpaID: '860937294',
      tpaName: 'SUMMIT PENSION CONSULTANTS, LTD',
      label: 'SUMMIT PENSION CONSULTANTS, LTD',
      value: 'SUMMIT PENSION CONSULTANTS, LTD',
      planCount: 4,
      selected: false,
      assets: '7,580,006.86',
    },
    {
      id: 444,
      tpaID: '953501761',
      tpaName: 'PETER D AUSTIN & ASSOCIATES INC',
      label: 'PETER D AUSTIN & ASSOCIATES INC',
      value: 'PETER D AUSTIN & ASSOCIATES INC',
      planCount: 1,
      selected: false,
      assets: '7,563,993.94',
    },
    {
      id: 445,
      tpaID: '133343914',
      tpaName: 'PENSION PARAMETERS FINANCIAL SERVICES INC.',
      label: 'PENSION PARAMETERS FINANCIAL SERVICES INC.',
      value: 'PENSION PARAMETERS FINANCIAL SERVICES INC.',
      planCount: 3,
      selected: false,
      assets: '7,507,949.58',
    },
    {
      id: 446,
      tpaID: '854041304',
      tpaName: 'BARNES TPA & ASSOCIATES, LLC',
      label: 'BARNES TPA & ASSOCIATES, LLC',
      value: 'BARNES TPA & ASSOCIATES, LLC',
      planCount: 3,
      selected: false,
      assets: '7,453,162.65',
    },
    {
      id: 447,
      tpaID: '800688755',
      tpaName: 'THE BURKE GROUP LLC',
      label: 'THE BURKE GROUP LLC',
      value: 'THE BURKE GROUP LLC',
      planCount: 2,
      selected: false,
      assets: '7,444,888.44',
    },
    {
      id: 448,
      tpaID: '043458623',
      tpaName: 'INTEGRATED PENSION SERVICES, INC.',
      label: 'INTEGRATED PENSION SERVICES, INC.',
      value: 'INTEGRATED PENSION SERVICES, INC.',
      planCount: 6,
      selected: false,
      assets: '7,421,073.92',
    },
    {
      id: 449,
      tpaID: '460515009',
      tpaName: 'CSB ASSOCIATES INC',
      label: 'CSB ASSOCIATES INC',
      value: 'CSB ASSOCIATES INC',
      planCount: 2,
      selected: false,
      assets: '7,395,017.81',
    },
    {
      id: 450,
      tpaID: '431585882',
      tpaName: 'MASTER BENEFIT GROUP INC',
      label: 'MASTER BENEFIT GROUP INC',
      value: 'MASTER BENEFIT GROUP INC',
      planCount: 7,
      selected: false,
      assets: '7,370,038.48',
    },
    {
      id: 451,
      tpaID: '201416603',
      tpaName: 'BALDWIN CPAS, PLLC',
      label: 'BALDWIN CPAS, PLLC',
      value: 'BALDWIN CPAS, PLLC',
      planCount: 1,
      selected: false,
      assets: '7,328,669.01',
    },
    {
      id: 452,
      tpaID: '208305664',
      tpaName: 'DAVID G. LEONARD & ASSOCIATES, INC.',
      label: 'DAVID G. LEONARD & ASSOCIATES, INC.',
      value: 'DAVID G. LEONARD & ASSOCIATES, INC.',
      planCount: 2,
      selected: false,
      assets: '7,252,867.45',
    },
    {
      id: 453,
      tpaID: '472620634',
      tpaName: 'STELLER PENSION CONSULTANTS, INC.',
      label: 'STELLER PENSION CONSULTANTS, INC.',
      value: 'STELLER PENSION CONSULTANTS, INC.',
      planCount: 4,
      selected: false,
      assets: '7,248,715.28',
    },
    {
      id: 454,
      tpaID: '814757115',
      tpaName: 'MDG PROFESSIONAL GROUP, P.C.',
      label: 'MDG PROFESSIONAL GROUP, P.C.',
      value: 'MDG PROFESSIONAL GROUP, P.C.',
      planCount: 1,
      selected: false,
      assets: '7,239,906.86',
    },
    {
      id: 455,
      tpaID: '593458014',
      tpaName: 'RETIREMENT PLAN SPECIALISTS INC (FL)',
      label: 'RETIREMENT PLAN SPECIALISTS INC (FL)',
      value: 'RETIREMENT PLAN SPECIALISTS INC (FL)',
      planCount: 3,
      selected: false,
      assets: '7,223,549.41',
    },
    {
      id: 456,
      tpaID: '620951563',
      tpaName: 'FIRST MERCANTILE TRUST COMPANY',
      label: 'FIRST MERCANTILE TRUST COMPANY',
      value: 'FIRST MERCANTILE TRUST COMPANY',
      planCount: 5,
      selected: false,
      assets: '7,187,914.92',
    },
    {
      id: 457,
      tpaID: '930819646',
      tpaName: 'JONES & ROTH PC',
      label: 'JONES & ROTH PC',
      value: 'JONES & ROTH PC',
      planCount: 4,
      selected: false,
      assets: '7,175,117.12',
    },
    {
      id: 458,
      tpaID: '061297277',
      tpaName: 'MVA PENSION SERVICES INC',
      label: 'MVA PENSION SERVICES INC',
      value: 'MVA PENSION SERVICES INC',
      planCount: 3,
      selected: false,
      assets: '7,091,624.43',
    },
    {
      id: 459,
      tpaID: '042703421',
      tpaName: 'TYLER ASSOCIATES INC',
      label: 'TYLER ASSOCIATES INC',
      value: 'TYLER ASSOCIATES INC',
      planCount: 2,
      selected: false,
      assets: '7,080,036.58',
    },
    {
      id: 460,
      tpaID: '621281073',
      tpaName: 'TAYLOR/WEBSTER',
      label: 'TAYLOR/WEBSTER',
      value: 'TAYLOR/WEBSTER',
      planCount: 2,
      selected: false,
      assets: '7,061,971.44',
    },
    {
      id: 461,
      tpaID: '953440766',
      tpaName: 'DOUGLAS M FARR & COMPANY INC',
      label: 'DOUGLAS M FARR & COMPANY INC',
      value: 'DOUGLAS M FARR & COMPANY INC',
      planCount: 4,
      selected: false,
      assets: '7,034,942.02',
    },
    {
      id: 462,
      tpaID: '351346211',
      tpaName: 'HARDING SHYMANSKI & CO PSC',
      label: 'HARDING SHYMANSKI & CO PSC',
      value: 'HARDING SHYMANSKI & CO PSC',
      planCount: 2,
      selected: false,
      assets: '6,977,959.39',
    },
    {
      id: 463,
      tpaID: '364556773',
      tpaName: 'CREATIVE PENSION DESIGN INC',
      label: 'CREATIVE PENSION DESIGN INC',
      value: 'CREATIVE PENSION DESIGN INC',
      planCount: 3,
      selected: false,
      assets: '6,882,311.34',
    },
    {
      id: 464,
      tpaID: '134077182',
      tpaName: 'RPG CONSULTANTS',
      label: 'RPG CONSULTANTS',
      value: 'RPG CONSULTANTS',
      planCount: 3,
      selected: false,
      assets: '6,838,687.92',
    },
    {
      id: 465,
      tpaID: '452927368',
      tpaName: 'PELION ACTUARIAL SERVICES INC',
      label: 'PELION ACTUARIAL SERVICES INC',
      value: 'PELION ACTUARIAL SERVICES INC',
      planCount: 8,
      selected: false,
      assets: '6,815,582.89',
    },
    {
      id: 466,
      tpaID: '814903086',
      tpaName: 'HERITAGE PENSION ADVISORS, INC.',
      label: 'HERITAGE PENSION ADVISORS, INC.',
      value: 'HERITAGE PENSION ADVISORS, INC.',
      planCount: 1,
      selected: false,
      assets: '6,693,208.34',
    },
    {
      id: 467,
      tpaID: '270187600',
      tpaName: 'BENSYM, INC. OF NEVADA',
      label: 'BENSYM, INC. OF NEVADA',
      value: 'BENSYM, INC. OF NEVADA',
      planCount: 1,
      selected: false,
      assets: '6,673,130.30',
    },
    {
      id: 468,
      tpaID: '412064284',
      tpaName: "O'CONNELL PENSION CONSULTING INC",
      label: "O'CONNELL PENSION CONSULTING INC",
      value: "O'CONNELL PENSION CONSULTING INC",
      planCount: 3,
      selected: false,
      assets: '6,583,198.42',
    },
    {
      id: 469,
      tpaID: '593560915',
      tpaName: 'THE PENSION CENTER OF FLORIDA, INC.',
      label: 'THE PENSION CENTER OF FLORIDA, INC.',
      value: 'THE PENSION CENTER OF FLORIDA, INC.',
      planCount: 8,
      selected: false,
      assets: '6,535,621.40',
    },
    {
      id: 470,
      tpaID: '820560553',
      tpaName: 'ZABARSKY & ASSOCIATES, LLC',
      label: 'ZABARSKY & ASSOCIATES, LLC',
      value: 'ZABARSKY & ASSOCIATES, LLC',
      planCount: 3,
      selected: false,
      assets: '6,394,829.10',
    },
    {
      id: 471,
      tpaID: '751961778',
      tpaName: 'WAKE FINANCIAL GROUP INC',
      label: 'WAKE FINANCIAL GROUP INC',
      value: 'WAKE FINANCIAL GROUP INC',
      planCount: 5,
      selected: false,
      assets: '6,394,598.58',
    },
    {
      id: 472,
      tpaID: '042716074',
      tpaName: 'THE KENNETH D ANDERSON COMPANY INC',
      label: 'THE KENNETH D ANDERSON COMPANY INC',
      value: 'THE KENNETH D ANDERSON COMPANY INC',
      planCount: 5,
      selected: false,
      assets: '6,347,135.49',
    },
    {
      id: 473,
      tpaID: '455464993',
      tpaName: 'BARNARD & ASSOCIATES RETIREMENT PLAN SPECIALISTS L',
      label: 'BARNARD & ASSOCIATES RETIREMENT PLAN SPECIALISTS L',
      value: 'BARNARD & ASSOCIATES RETIREMENT PLAN SPECIALISTS L',
      planCount: 3,
      selected: false,
      assets: '6,280,837.40',
    },
    {
      id: 474,
      tpaID: '272594403',
      tpaName: 'CWM RETIREMENT PLAN SERVICES',
      label: 'CWM RETIREMENT PLAN SERVICES',
      value: 'CWM RETIREMENT PLAN SERVICES',
      planCount: 6,
      selected: false,
      assets: '6,260,304.23',
    },
    {
      id: 475,
      tpaID: '363801284',
      tpaName: 'GARY R. MANN & ASSOCIATES, INC.',
      label: 'GARY R. MANN & ASSOCIATES, INC.',
      value: 'GARY R. MANN & ASSOCIATES, INC.',
      planCount: 4,
      selected: false,
      assets: '6,257,438.39',
    },
    {
      id: 476,
      tpaID: '272431450',
      tpaName: 'REDWOOD PENSIONS LLC',
      label: 'REDWOOD PENSIONS LLC',
      value: 'REDWOOD PENSIONS LLC',
      planCount: 3,
      selected: false,
      assets: '6,230,585.72',
    },
    {
      id: 477,
      tpaID: '811963142',
      tpaName: 'QUALIFIED PENSION CONSULTANTS, INC.',
      label: 'QUALIFIED PENSION CONSULTANTS, INC.',
      value: 'QUALIFIED PENSION CONSULTANTS, INC.',
      planCount: 7,
      selected: false,
      assets: '6,209,361.78',
    },
    {
      id: 478,
      tpaID: '541607694',
      tpaName: 'PENSION DESIGN GROUP INC.',
      label: 'PENSION DESIGN GROUP INC.',
      value: 'PENSION DESIGN GROUP INC.',
      planCount: 2,
      selected: false,
      assets: '6,208,229.96',
    },
    {
      id: 479,
      tpaID: '233062020',
      tpaName: 'MILBERG CONSULTING LLC',
      label: 'MILBERG CONSULTING LLC',
      value: 'MILBERG CONSULTING LLC',
      planCount: 1,
      selected: false,
      assets: '6,193,954.94',
    },
    {
      id: 480,
      tpaID: '861022384',
      tpaName: 'ENTERPRISE PENSIONS INC',
      label: 'ENTERPRISE PENSIONS INC',
      value: 'ENTERPRISE PENSIONS INC',
      planCount: 3,
      selected: false,
      assets: '6,167,813.66',
    },
    {
      id: 481,
      tpaID: '251438810',
      tpaName: 'ACTUARIAL DATA INC',
      label: 'ACTUARIAL DATA INC',
      value: 'ACTUARIAL DATA INC',
      planCount: 4,
      selected: false,
      assets: '6,152,500.80',
    },
    {
      id: 482,
      tpaID: '954436446',
      tpaName: 'R-TECH CONSULTANTS INC',
      label: 'R-TECH CONSULTANTS INC',
      value: 'R-TECH CONSULTANTS INC',
      planCount: 5,
      selected: false,
      assets: '6,150,927.26',
    },
    {
      id: 483,
      tpaID: '341031518',
      tpaName: 'MOSKAL GROSS ORCHOSKY INC',
      label: 'MOSKAL GROSS ORCHOSKY INC',
      value: 'MOSKAL GROSS ORCHOSKY INC',
      planCount: 1,
      selected: false,
      assets: '6,084,633.28',
    },
    {
      id: 484,
      tpaID: '440160260',
      tpaName: 'BKD LLP',
      label: 'BKD LLP',
      value: 'BKD LLP',
      planCount: 3,
      selected: false,
      assets: '6,078,771.60',
    },
    {
      id: 485,
      tpaID: '311634880',
      tpaName: 'FOLEY BENEFITS GROUP, LLC',
      label: 'FOLEY BENEFITS GROUP, LLC',
      value: 'FOLEY BENEFITS GROUP, LLC',
      planCount: 7,
      selected: false,
      assets: '6,072,437.02',
    },
    {
      id: 486,
      tpaID: '141442607',
      tpaName: 'BST & CO. CPAS, LLP',
      label: 'BST & CO. CPAS, LLP',
      value: 'BST & CO. CPAS, LLP',
      planCount: 2,
      selected: false,
      assets: '6,021,246.00',
    },
    {
      id: 487,
      tpaID: '472913406',
      tpaName: 'ARROW PENSIONS, LLC',
      label: 'ARROW PENSIONS, LLC',
      value: 'ARROW PENSIONS, LLC',
      planCount: 8,
      selected: false,
      assets: '5,981,339.49',
    },
    {
      id: 488,
      tpaID: '260559925',
      tpaName: 'WRIGHT ADMINISTRATION LLC',
      label: 'WRIGHT ADMINISTRATION LLC',
      value: 'WRIGHT ADMINISTRATION LLC',
      planCount: 7,
      selected: false,
      assets: '5,808,977.56',
    },
    {
      id: 489,
      tpaID: '311677082',
      tpaName: 'POWERS BENEFITS CORP',
      label: 'POWERS BENEFITS CORP',
      value: 'POWERS BENEFITS CORP',
      planCount: 2,
      selected: false,
      assets: '5,799,907.68',
    },
    {
      id: 490,
      tpaID: '223762181',
      tpaName: 'HARTMAN CONSULTING LLC',
      label: 'HARTMAN CONSULTING LLC',
      value: 'HARTMAN CONSULTING LLC',
      planCount: 4,
      selected: false,
      assets: '5,756,049.66',
    },
    {
      id: 491,
      tpaID: '461036193',
      tpaName: 'FOCUS PENSION LLC',
      label: 'FOCUS PENSION LLC',
      value: 'FOCUS PENSION LLC',
      planCount: 6,
      selected: false,
      assets: '5,670,753.71',
    },
    {
      id: 492,
      tpaID: '330507584',
      tpaName: 'GARY BERMAN',
      label: 'GARY BERMAN',
      value: 'GARY BERMAN',
      planCount: 4,
      selected: false,
      assets: '5,664,546.36',
    },
    {
      id: 493,
      tpaID: '310800053',
      tpaName: 'CLARK, SCHAEFER, HACKETT & CO',
      label: 'CLARK, SCHAEFER, HACKETT & CO',
      value: 'CLARK, SCHAEFER, HACKETT & CO',
      planCount: 3,
      selected: false,
      assets: '5,623,929.08',
    },
    {
      id: 494,
      tpaID: '261447407',
      tpaName: 'RETIREMENT PLAN PARTNERS LLC',
      label: 'RETIREMENT PLAN PARTNERS LLC',
      value: 'RETIREMENT PLAN PARTNERS LLC',
      planCount: 11,
      selected: false,
      assets: '5,593,650.51',
    },
    {
      id: 495,
      tpaID: '464914104',
      tpaName: 'INTEGRATED RETIREMENT PLAN SOLUTIONS LLC',
      label: 'INTEGRATED RETIREMENT PLAN SOLUTIONS LLC',
      value: 'INTEGRATED RETIREMENT PLAN SOLUTIONS LLC',
      planCount: 3,
      selected: false,
      assets: '5,588,385.57',
    },
    {
      id: 496,
      tpaID: '770088483',
      tpaName: 'PENSION DESIGN, INC.',
      label: 'PENSION DESIGN, INC.',
      value: 'PENSION DESIGN, INC.',
      planCount: 7,
      selected: false,
      assets: '5,583,951.68',
    },
    {
      id: 497,
      tpaID: '581179545',
      tpaName: 'APEX PENSION STRATEGIES, INC.',
      label: 'APEX PENSION STRATEGIES, INC.',
      value: 'APEX PENSION STRATEGIES, INC.',
      planCount: 10,
      selected: false,
      assets: '5,535,201.35',
    },
    {
      id: 498,
      tpaID: '931934149',
      tpaName: 'WYNANT CONSULTING GROUP',
      label: 'WYNANT CONSULTING GROUP',
      value: 'WYNANT CONSULTING GROUP',
      planCount: 5,
      selected: false,
      assets: '5,485,176.78',
    },
    {
      id: 499,
      tpaID: '271175487',
      tpaName: 'OCTOBER THREE CONSULTING LLC',
      label: 'OCTOBER THREE CONSULTING LLC',
      value: 'OCTOBER THREE CONSULTING LLC',
      planCount: 2,
      selected: false,
      assets: '5,465,403.96',
    },
    {
      id: 500,
      tpaID: '710817652',
      tpaName: 'FROST PLLC',
      label: 'FROST PLLC',
      value: 'FROST PLLC',
      planCount: 1,
      selected: false,
      assets: '5,406,714.06',
    },
    {
      id: 501,
      tpaID: '383661233',
      tpaName: 'COASTAL PENSION CONSULTANTS, INC.',
      label: 'COASTAL PENSION CONSULTANTS, INC.',
      value: 'COASTAL PENSION CONSULTANTS, INC.',
      planCount: 1,
      selected: false,
      assets: '5,388,981.28',
    },
    {
      id: 502,
      tpaID: '470984091',
      tpaName: 'CREST RETIREMENT ADVISORS LLC',
      label: 'CREST RETIREMENT ADVISORS LLC',
      value: 'CREST RETIREMENT ADVISORS LLC',
      planCount: 6,
      selected: false,
      assets: '5,364,032.19',
    },
    {
      id: 503,
      tpaID: '431416753',
      tpaName: 'GATEWAY PENSION SERVICES LTD',
      label: 'GATEWAY PENSION SERVICES LTD',
      value: 'GATEWAY PENSION SERVICES LTD',
      planCount: 2,
      selected: false,
      assets: '5,301,183.28',
    },
    {
      id: 504,
      tpaID: '271639360',
      tpaName: 'PENSION TECHS LLC',
      label: 'PENSION TECHS LLC',
      value: 'PENSION TECHS LLC',
      planCount: 6,
      selected: false,
      assets: '5,265,903.52',
    },
    {
      id: 505,
      tpaID: '752256980',
      tpaName: 'MASON WARNER & COMPANY, PC',
      label: 'MASON WARNER & COMPANY, PC',
      value: 'MASON WARNER & COMPANY, PC',
      planCount: 1,
      selected: false,
      assets: '5,250,204.93',
    },
    {
      id: 506,
      tpaID: '550394215',
      tpaName: 'JACKSON KELLY PLLC',
      label: 'JACKSON KELLY PLLC',
      value: 'JACKSON KELLY PLLC',
      planCount: 1,
      selected: false,
      assets: '5,209,866.03',
    },
    {
      id: 507,
      tpaID: '270851983',
      tpaName: 'SPONSEL CPA GROUP LLC',
      label: 'SPONSEL CPA GROUP LLC',
      value: 'SPONSEL CPA GROUP LLC',
      planCount: 3,
      selected: false,
      assets: '5,144,965.94',
    },
    {
      id: 508,
      tpaID: '911999591',
      tpaName: 'BENEFIT ADMINISTRATION COMPANY LLC',
      label: 'BENEFIT ADMINISTRATION COMPANY LLC',
      value: 'BENEFIT ADMINISTRATION COMPANY LLC',
      planCount: 1,
      selected: false,
      assets: '5,109,113.36',
    },
    {
      id: 509,
      tpaID: '043760707',
      tpaName: 'SES ADVISORS, INC.',
      label: 'SES ADVISORS, INC.',
      value: 'SES ADVISORS, INC.',
      planCount: 1,
      selected: false,
      assets: '5,080,926.78',
    },
    {
      id: 510,
      tpaID: '560990374',
      tpaName: 'CORPORATE PLANS & SERVICES, INC.',
      label: 'CORPORATE PLANS & SERVICES, INC.',
      value: 'CORPORATE PLANS & SERVICES, INC.',
      planCount: 3,
      selected: false,
      assets: '5,075,167.49',
    },
    {
      id: 511,
      tpaID: '411958037',
      tpaName: 'KUTZKE RETIREMENT SERVICES, INC',
      label: 'KUTZKE RETIREMENT SERVICES, INC',
      value: 'KUTZKE RETIREMENT SERVICES, INC',
      planCount: 4,
      selected: false,
      assets: '5,014,767.46',
    },
    {
      id: 512,
      tpaID: '364452534',
      tpaName: 'APPLEBAUM HERZOG & ASSOCIATES PC',
      label: 'APPLEBAUM HERZOG & ASSOCIATES PC',
      value: 'APPLEBAUM HERZOG & ASSOCIATES PC',
      planCount: 1,
      selected: false,
      assets: '5,008,060.77',
    },
    {
      id: 513,
      tpaID: '954673312',
      tpaName: 'CMC RETIREMENT AND EMPLOYEE BENEFITS SPECIALISTS INC',
      label: 'CMC RETIREMENT AND EMPLOYEE BENEFITS SPECIALISTS INC',
      value: 'CMC RETIREMENT AND EMPLOYEE BENEFITS SPECIALISTS INC',
      planCount: 5,
      selected: false,
      assets: '4,943,607.57',
    },
    {
      id: 514,
      tpaID: '383839452',
      tpaName: 'BENEFITS 21 LLC',
      label: 'BENEFITS 21 LLC',
      value: 'BENEFITS 21 LLC',
      planCount: 5,
      selected: false,
      assets: '4,922,502.21',
    },
    {
      id: 515,
      tpaID: '720684309',
      tpaName: 'LEON E WERNTZ AND ASSOCIATES INC',
      label: 'LEON E WERNTZ AND ASSOCIATES INC',
      value: 'LEON E WERNTZ AND ASSOCIATES INC',
      planCount: 2,
      selected: false,
      assets: '4,902,672.31',
    },
    {
      id: 516,
      tpaID: '680641337',
      tpaName: 'VIOLA RETIREMENT PLAN SERVICES LLC',
      label: 'VIOLA RETIREMENT PLAN SERVICES LLC',
      value: 'VIOLA RETIREMENT PLAN SERVICES LLC',
      planCount: 2,
      selected: false,
      assets: '4,863,485.81',
    },
    {
      id: 517,
      tpaID: '043314028',
      tpaName: 'WHITNEY PENSION ASSOCIATES INC',
      label: 'WHITNEY PENSION ASSOCIATES INC',
      value: 'WHITNEY PENSION ASSOCIATES INC',
      planCount: 3,
      selected: false,
      assets: '4,808,661.23',
    },
    {
      id: 518,
      tpaID: '541149263',
      tpaName: 'YOUNT HYDE & BARBOUR PC',
      label: 'YOUNT HYDE & BARBOUR PC',
      value: 'YOUNT HYDE & BARBOUR PC',
      planCount: 2,
      selected: false,
      assets: '4,794,487.09',
    },
    {
      id: 519,
      tpaID: '770396341',
      tpaName: 'DAVEY INSURANCE MARKETING INC',
      label: 'DAVEY INSURANCE MARKETING INC',
      value: 'DAVEY INSURANCE MARKETING INC',
      planCount: 5,
      selected: false,
      assets: '4,698,350.74',
    },
    {
      id: 520,
      tpaID: '870380632',
      tpaName: 'PRECISION PLANNING',
      label: 'PRECISION PLANNING',
      value: 'PRECISION PLANNING',
      planCount: 5,
      selected: false,
      assets: '4,680,497.60',
    },
    {
      id: 521,
      tpaID: '310995736',
      tpaName: 'THE SIEKMANN COMPANY',
      label: 'THE SIEKMANN COMPANY',
      value: 'THE SIEKMANN COMPANY',
      planCount: 3,
      selected: false,
      assets: '4,664,832.94',
    },
    {
      id: 522,
      tpaID: '133752538',
      tpaName: 'GELMAN PENSION CONSULTING, INC.',
      label: 'GELMAN PENSION CONSULTING, INC.',
      value: 'GELMAN PENSION CONSULTING, INC.',
      planCount: 5,
      selected: false,
      assets: '4,598,593.83',
    },
    {
      id: 523,
      tpaID: '223440983',
      tpaName: 'BURY AND ASSOCIATES INC',
      label: 'BURY AND ASSOCIATES INC',
      value: 'BURY AND ASSOCIATES INC',
      planCount: 3,
      selected: false,
      assets: '4,583,082.23',
    },
    {
      id: 524,
      tpaID: '391370278',
      tpaName: 'ZETLEY, CARNEOL & STEIN, S.C.',
      label: 'ZETLEY, CARNEOL & STEIN, S.C.',
      value: 'ZETLEY, CARNEOL & STEIN, S.C.',
      planCount: 1,
      selected: false,
      assets: '4,577,895.25',
    },
    {
      id: 525,
      tpaID: '042596010',
      tpaName: 'FECTEAU BENEFITS GROUP, INC.',
      label: 'FECTEAU BENEFITS GROUP, INC.',
      value: 'FECTEAU BENEFITS GROUP, INC.',
      planCount: 2,
      selected: false,
      assets: '4,541,336.53',
    },
    {
      id: 526,
      tpaID: '453763537',
      tpaName: 'ACH RETIREMENT PLAN CONSULTANTS INC',
      label: 'ACH RETIREMENT PLAN CONSULTANTS INC',
      value: 'ACH RETIREMENT PLAN CONSULTANTS INC',
      planCount: 8,
      selected: false,
      assets: '4,531,072.90',
    },
    {
      id: 527,
      tpaID: '431540822',
      tpaName: 'EMPLOYEE BENEFITS CONSULTANTS INC',
      label: 'EMPLOYEE BENEFITS CONSULTANTS INC',
      value: 'EMPLOYEE BENEFITS CONSULTANTS INC',
      planCount: 5,
      selected: false,
      assets: '4,516,568.50',
    },
    {
      id: 528,
      tpaID: '481007096',
      tpaName: 'THE NOLAN COMPANY',
      label: 'THE NOLAN COMPANY',
      value: 'THE NOLAN COMPANY',
      planCount: 1,
      selected: false,
      assets: '4,501,179.01',
    },
    {
      id: 529,
      tpaID: '364291971',
      tpaName: 'GALLAGHER BENEFIT SERVICES',
      label: 'GALLAGHER BENEFIT SERVICES',
      value: 'GALLAGHER BENEFIT SERVICES',
      planCount: 3,
      selected: false,
      assets: '4,468,246.31',
    },
    {
      id: 530,
      tpaID: '113416243',
      tpaName: 'FM INTERNATIONAL SERVICES (NY), LTD.',
      label: 'FM INTERNATIONAL SERVICES (NY), LTD.',
      value: 'FM INTERNATIONAL SERVICES (NY), LTD.',
      planCount: 4,
      selected: false,
      assets: '4,416,222.67',
    },
    {
      id: 531,
      tpaID: '140696635',
      tpaName: 'GLENS FALLS NATIONAL BANK AND TRUST COMPANY',
      label: 'GLENS FALLS NATIONAL BANK AND TRUST COMPANY',
      value: 'GLENS FALLS NATIONAL BANK AND TRUST COMPANY',
      planCount: 1,
      selected: false,
      assets: '4,375,387.05',
    },
    {
      id: 532,
      tpaID: '043629856',
      tpaName: 'MLF CONSULTING GROUP INC',
      label: 'MLF CONSULTING GROUP INC',
      value: 'MLF CONSULTING GROUP INC',
      planCount: 1,
      selected: false,
      assets: '4,363,306.45',
    },
    {
      id: 533,
      tpaID: '841571661',
      tpaName: 'TPA SERVICES INC',
      label: 'TPA SERVICES INC',
      value: 'TPA SERVICES INC',
      planCount: 2,
      selected: false,
      assets: '4,353,218.00',
    },
    {
      id: 534,
      tpaID: '953843836',
      tpaName: 'BALTON & ASSOCIATES CORPORATION',
      label: 'BALTON & ASSOCIATES CORPORATION',
      value: 'BALTON & ASSOCIATES CORPORATION',
      planCount: 1,
      selected: false,
      assets: '4,320,357.89',
    },
    {
      id: 535,
      tpaID: '264767425',
      tpaName: 'CONCERT RETIREMENT PLAN CONSULTING INC',
      label: 'CONCERT RETIREMENT PLAN CONSULTING INC',
      value: 'CONCERT RETIREMENT PLAN CONSULTING INC',
      planCount: 1,
      selected: false,
      assets: '4,293,096.14',
    },
    {
      id: 536,
      tpaID: '901118690',
      tpaName: 'BENEFIT PROFESSIONALS, INC.',
      label: 'BENEFIT PROFESSIONALS, INC.',
      value: 'BENEFIT PROFESSIONALS, INC.',
      planCount: 6,
      selected: false,
      assets: '4,225,894.35',
    },
    {
      id: 537,
      tpaID: '431317863',
      tpaName: 'QUALIFIED BENEFITS CONSULTANTS, INC.',
      label: 'QUALIFIED BENEFITS CONSULTANTS, INC.',
      value: 'QUALIFIED BENEFITS CONSULTANTS, INC.',
      planCount: 3,
      selected: false,
      assets: '4,217,188.07',
    },
    {
      id: 538,
      tpaID: '204243624',
      tpaName: 'MCHENRY ADVISERS INC',
      label: 'MCHENRY ADVISERS INC',
      value: 'MCHENRY ADVISERS INC',
      planCount: 7,
      selected: false,
      assets: '4,205,613.83',
    },
    {
      id: 539,
      tpaID: '203855127',
      tpaName: 'PRECISION PLAN ADMINISTRATION, LLC',
      label: 'PRECISION PLAN ADMINISTRATION, LLC',
      value: 'PRECISION PLAN ADMINISTRATION, LLC',
      planCount: 3,
      selected: false,
      assets: '4,175,401.04',
    },
    {
      id: 540,
      tpaID: '331134875',
      tpaName: 'LANJ ASSOCIATES, LLC',
      label: 'LANJ ASSOCIATES, LLC',
      value: 'LANJ ASSOCIATES, LLC',
      planCount: 4,
      selected: false,
      assets: '4,169,128.30',
    },
    {
      id: 541,
      tpaID: '362663558',
      tpaName: 'PORTE BROWN LLC',
      label: 'PORTE BROWN LLC',
      value: 'PORTE BROWN LLC',
      planCount: 3,
      selected: false,
      assets: '4,164,147.53',
    },
    {
      id: 542,
      tpaID: '541437648',
      tpaName: 'ACTUARIAL CONSULTING GROUP',
      label: 'ACTUARIAL CONSULTING GROUP',
      value: 'ACTUARIAL CONSULTING GROUP',
      planCount: 1,
      selected: false,
      assets: '4,163,528.33',
    },
    {
      id: 543,
      tpaID: '351525132',
      tpaName: 'LTS PLAN ADMINSTRATION, INC.',
      label: 'LTS PLAN ADMINSTRATION, INC.',
      value: 'LTS PLAN ADMINSTRATION, INC.',
      planCount: 3,
      selected: false,
      assets: '4,133,003.72',
    },
    {
      id: 544,
      tpaID: '382154774',
      tpaName: 'PENSION PLAN SERVICES INC',
      label: 'PENSION PLAN SERVICES INC',
      value: 'PENSION PLAN SERVICES INC',
      planCount: 3,
      selected: false,
      assets: '4,127,669.39',
    },
    {
      id: 545,
      tpaID: '274305376',
      tpaName: 'THE VARGO COMPANY',
      label: 'THE VARGO COMPANY',
      value: 'THE VARGO COMPANY',
      planCount: 6,
      selected: false,
      assets: '4,124,062.17',
    },
    {
      id: 546,
      tpaID: '770544712',
      tpaName: 'GREGORY POWELL BURGE & CO INC',
      label: 'GREGORY POWELL BURGE & CO INC',
      value: 'GREGORY POWELL BURGE & CO INC',
      planCount: 2,
      selected: false,
      assets: '4,098,941.06',
    },
    {
      id: 547,
      tpaID: '680307062',
      tpaName: 'PENSION BENEFIT CONSULTANTS (CA)',
      label: 'PENSION BENEFIT CONSULTANTS (CA)',
      value: 'PENSION BENEFIT CONSULTANTS (CA)',
      planCount: 2,
      selected: false,
      assets: '4,079,035.74',
    },
    {
      id: 548,
      tpaID: '274433997',
      tpaName: '3G RETIREMENT SERVICES LLC',
      label: '3G RETIREMENT SERVICES LLC',
      value: '3G RETIREMENT SERVICES LLC',
      planCount: 3,
      selected: false,
      assets: '4,075,028.85',
    },
    {
      id: 549,
      tpaID: '260398381',
      tpaName: 'RETIREMENT BENEFITS DESIGNS LLC',
      label: 'RETIREMENT BENEFITS DESIGNS LLC',
      value: 'RETIREMENT BENEFITS DESIGNS LLC',
      planCount: 3,
      selected: false,
      assets: '4,063,659.37',
    },
    {
      id: 550,
      tpaID: '582498531',
      tpaName: 'PROFESSIONAL PENSION SERVICES, INC.',
      label: 'PROFESSIONAL PENSION SERVICES, INC.',
      value: 'PROFESSIONAL PENSION SERVICES, INC.',
      planCount: 3,
      selected: false,
      assets: '4,038,205.75',
    },
    {
      id: 551,
      tpaID: '680005849',
      tpaName: 'FLYNN, SHOJIANAGA & ASSOCIATES, INC',
      label: 'FLYNN, SHOJIANAGA & ASSOCIATES, INC',
      value: 'FLYNN, SHOJIANAGA & ASSOCIATES, INC',
      planCount: 4,
      selected: false,
      assets: '4,036,241.94',
    },
    {
      id: 552,
      tpaID: '943274051',
      tpaName: 'PEERY & ASSOCIATES INC',
      label: 'PEERY & ASSOCIATES INC',
      value: 'PEERY & ASSOCIATES INC',
      planCount: 3,
      selected: false,
      assets: '3,978,987.29',
    },
    {
      id: 553,
      tpaID: '548843325',
      tpaName: 'STANLEY PENSION SERVICES',
      label: 'STANLEY PENSION SERVICES',
      value: 'STANLEY PENSION SERVICES',
      planCount: 3,
      selected: false,
      assets: '3,978,175.35',
    },
    {
      id: 554,
      tpaID: '261482900',
      tpaName: 'GAMMON & DRUECK CPAS PLLC',
      label: 'GAMMON & DRUECK CPAS PLLC',
      value: 'GAMMON & DRUECK CPAS PLLC',
      planCount: 4,
      selected: false,
      assets: '3,968,860.06',
    },
    {
      id: 555,
      tpaID: '591655471',
      tpaName: 'INCERA AND ASSOCIATES',
      label: 'INCERA AND ASSOCIATES',
      value: 'INCERA AND ASSOCIATES',
      planCount: 5,
      selected: false,
      assets: '3,931,904.74',
    },
    {
      id: 556,
      tpaID: '223507738',
      tpaName: 'CORPORATE RETIREMENT SERVICES, INC.',
      label: 'CORPORATE RETIREMENT SERVICES, INC.',
      value: 'CORPORATE RETIREMENT SERVICES, INC.',
      planCount: 1,
      selected: false,
      assets: '3,898,158.39',
    },
    {
      id: 557,
      tpaID: '232179170',
      tpaName: 'TYCOR PLAN ADMINISTRATORS, INC.',
      label: 'TYCOR PLAN ADMINISTRATORS, INC.',
      value: 'TYCOR PLAN ADMINISTRATORS, INC.',
      planCount: 3,
      selected: false,
      assets: '3,895,208.68',
    },
    {
      id: 558,
      tpaID: '020600416',
      tpaName: 'LINCK LAW PLC',
      label: 'LINCK LAW PLC',
      value: 'LINCK LAW PLC',
      planCount: 2,
      selected: false,
      assets: '3,835,996.95',
    },
    {
      id: 559,
      tpaID: '351489521',
      tpaName: 'GREENWALT CPAS, INC.',
      label: 'GREENWALT CPAS, INC.',
      value: 'GREENWALT CPAS, INC.',
      planCount: 4,
      selected: false,
      assets: '3,834,477.95',
    },
    {
      id: 560,
      tpaID: '571042994',
      tpaName: 'K & N ASSOCIATES INC',
      label: 'K & N ASSOCIATES INC',
      value: 'K & N ASSOCIATES INC',
      planCount: 1,
      selected: false,
      assets: '3,821,454.74',
    },
    {
      id: 561,
      tpaID: '990262088',
      tpaName: 'PENSION SERVICES CORP (HI)',
      label: 'PENSION SERVICES CORP (HI)',
      value: 'PENSION SERVICES CORP (HI)',
      planCount: 4,
      selected: false,
      assets: '3,819,006.34',
    },
    {
      id: 562,
      tpaID: '462028188',
      tpaName: 'CAPITAL PENSION GROUP, LLC',
      label: 'CAPITAL PENSION GROUP, LLC',
      value: 'CAPITAL PENSION GROUP, LLC',
      planCount: 5,
      selected: false,
      assets: '3,739,545.07',
    },
    {
      id: 563,
      tpaID: '510439960',
      tpaName: 'BENEFIT SOLUTIONS INC (WV)',
      label: 'BENEFIT SOLUTIONS INC (WV)',
      value: 'BENEFIT SOLUTIONS INC (WV)',
      planCount: 3,
      selected: false,
      assets: '3,737,611.91',
    },
    {
      id: 564,
      tpaID: '205089998',
      tpaName: 'ARROWHEAD PENSIONS INC',
      label: 'ARROWHEAD PENSIONS INC',
      value: 'ARROWHEAD PENSIONS INC',
      planCount: 7,
      selected: false,
      assets: '3,736,328.84',
    },
    {
      id: 565,
      tpaID: '570825639',
      tpaName: 'SPECTRUM FINANCIAL SERVICES CORP.',
      label: 'SPECTRUM FINANCIAL SERVICES CORP.',
      value: 'SPECTRUM FINANCIAL SERVICES CORP.',
      planCount: 3,
      selected: false,
      assets: '3,723,084.11',
    },
    {
      id: 566,
      tpaID: '742845107',
      tpaName: 'MIDWEST PENSION ADMINISTRATORS, INC.',
      label: 'MIDWEST PENSION ADMINISTRATORS, INC.',
      value: 'MIDWEST PENSION ADMINISTRATORS, INC.',
      planCount: 1,
      selected: false,
      assets: '3,715,653.85',
    },
    {
      id: 567,
      tpaID: '911442042',
      tpaName: 'PARADIGM FINANCIAL CORP.',
      label: 'PARADIGM FINANCIAL CORP.',
      value: 'PARADIGM FINANCIAL CORP.',
      planCount: 1,
      selected: false,
      assets: '3,695,344.40',
    },
    {
      id: 568,
      tpaID: '042778166',
      tpaName: 'NORTHEAST PLANNING SERVICES, INC.',
      label: 'NORTHEAST PLANNING SERVICES, INC.',
      value: 'NORTHEAST PLANNING SERVICES, INC.',
      planCount: 4,
      selected: false,
      assets: '3,674,392.93',
    },
    {
      id: 569,
      tpaID: '953949084',
      tpaName: 'BLOCK CONSULTING ACTUARIES',
      label: 'BLOCK CONSULTING ACTUARIES',
      value: 'BLOCK CONSULTING ACTUARIES',
      planCount: 2,
      selected: false,
      assets: '3,673,406.27',
    },
    {
      id: 570,
      tpaID: '431771362',
      tpaName: 'QUALIFIED PENSION SERVICES, INC. (MO)',
      label: 'QUALIFIED PENSION SERVICES, INC. (MO)',
      value: 'QUALIFIED PENSION SERVICES, INC. (MO)',
      planCount: 4,
      selected: false,
      assets: '3,646,978.76',
    },
    {
      id: 571,
      tpaID: '352130755',
      tpaName: 'THE ROSE FINANCIAL GROUP, LLC',
      label: 'THE ROSE FINANCIAL GROUP, LLC',
      value: 'THE ROSE FINANCIAL GROUP, LLC',
      planCount: 4,
      selected: false,
      assets: '3,622,555.91',
    },
    {
      id: 572,
      tpaID: '263394679',
      tpaName: 'PENSION SOLUTIONS SERVICES',
      label: 'PENSION SOLUTIONS SERVICES',
      value: 'PENSION SOLUTIONS SERVICES',
      planCount: 1,
      selected: false,
      assets: '3,598,779.87',
    },
    {
      id: 573,
      tpaID: '453977740',
      tpaName: 'PENSION PROFESSIONALS LLC (MD)',
      label: 'PENSION PROFESSIONALS LLC (MD)',
      value: 'PENSION PROFESSIONALS LLC (MD)',
      planCount: 3,
      selected: false,
      assets: '3,561,406.77',
    },
    {
      id: 574,
      tpaID: '232624667',
      tpaName: 'ATR INC',
      label: 'ATR INC',
      value: 'ATR INC',
      planCount: 2,
      selected: false,
      assets: '3,547,589.64',
    },
    {
      id: 575,
      tpaID: '742052353',
      tpaName: 'SEIDEL SCHROEDER AND COMPANY',
      label: 'SEIDEL SCHROEDER AND COMPANY',
      value: 'SEIDEL SCHROEDER AND COMPANY',
      planCount: 1,
      selected: false,
      assets: '3,525,655.15',
    },
    {
      id: 576,
      tpaID: '205634540',
      tpaName: 'SLT PENSION CORPORATION',
      label: 'SLT PENSION CORPORATION',
      value: 'SLT PENSION CORPORATION',
      planCount: 1,
      selected: false,
      assets: '3,497,611.28',
    },
    {
      id: 577,
      tpaID: '561035259',
      tpaName: 'TRP SUMNER PLLC',
      label: 'TRP SUMNER PLLC',
      value: 'TRP SUMNER PLLC',
      planCount: 1,
      selected: false,
      assets: '3,471,343.19',
    },
    {
      id: 578,
      tpaID: '462772806',
      tpaName: 'STORICK GROUP',
      label: 'STORICK GROUP',
      value: 'STORICK GROUP',
      planCount: 31,
      selected: false,
      assets: '3,471,264.51',
    },
    {
      id: 579,
      tpaID: '830331229',
      tpaName: 'MCGEE HEARNE & PAIZ LLP',
      label: 'MCGEE HEARNE & PAIZ LLP',
      value: 'MCGEE HEARNE & PAIZ LLP',
      planCount: 1,
      selected: false,
      assets: '3,466,445.26',
    },
    {
      id: 580,
      tpaID: '061550023',
      tpaName: 'TIMOTHY J FEUSNER PENSION',
      label: 'TIMOTHY J FEUSNER PENSION',
      value: 'TIMOTHY J FEUSNER PENSION',
      planCount: 4,
      selected: false,
      assets: '3,447,205.55',
    },
    {
      id: 581,
      tpaID: '272998426',
      tpaName: 'FULL SPECTRUM RETIREMENT PLANS, LLC',
      label: 'FULL SPECTRUM RETIREMENT PLANS, LLC',
      value: 'FULL SPECTRUM RETIREMENT PLANS, LLC',
      planCount: 4,
      selected: false,
      assets: '3,439,466.23',
    },
    {
      id: 582,
      tpaID: '271837997',
      tpaName: 'KB ACTUARIAL INC',
      label: 'KB ACTUARIAL INC',
      value: 'KB ACTUARIAL INC',
      planCount: 4,
      selected: false,
      assets: '3,433,951.33',
    },
    {
      id: 583,
      tpaID: '931225747',
      tpaName: 'PAYPRO ADMINISTRATORS',
      label: 'PAYPRO ADMINISTRATORS',
      value: 'PAYPRO ADMINISTRATORS',
      planCount: 1,
      selected: false,
      assets: '3,409,209.75',
    },
    {
      id: 584,
      tpaID: '231571639',
      tpaName: 'GOOSENBERG-POLISHER INC',
      label: 'GOOSENBERG-POLISHER INC',
      value: 'GOOSENBERG-POLISHER INC',
      planCount: 4,
      selected: false,
      assets: '3,404,422.07',
    },
    {
      id: 585,
      tpaID: '042709439',
      tpaName: 'R J GOLD & COMPANY PC',
      label: 'R J GOLD & COMPANY PC',
      value: 'R J GOLD & COMPANY PC',
      planCount: 1,
      selected: false,
      assets: '3,371,856.02',
    },
    {
      id: 586,
      tpaID: '452575373',
      tpaName: 'TANDEM CONSULTING GROUP, LLC',
      label: 'TANDEM CONSULTING GROUP, LLC',
      value: 'TANDEM CONSULTING GROUP, LLC',
      planCount: 8,
      selected: false,
      assets: '3,348,827.15',
    },
    {
      id: 587,
      tpaID: '470800241',
      tpaName: 'KELLEY FINANCIAL SERVICES INC',
      label: 'KELLEY FINANCIAL SERVICES INC',
      value: 'KELLEY FINANCIAL SERVICES INC',
      planCount: 1,
      selected: false,
      assets: '3,313,662.28',
    },
    {
      id: 588,
      tpaID: '454231421',
      tpaName: 'T.J. PENSIONS INC',
      label: 'T.J. PENSIONS INC',
      value: 'T.J. PENSIONS INC',
      planCount: 2,
      selected: false,
      assets: '3,303,830.82',
    },
    {
      id: 589,
      tpaID: '371909306',
      tpaName: 'Retirement Service Group, Inc.',
      label: 'Retirement Service Group, Inc.',
      value: 'Retirement Service Group, Inc.',
      planCount: 7,
      selected: false,
      assets: '3,274,266.93',
    },
    {
      id: 590,
      tpaID: '834377773',
      tpaName: 'MICHAEL HAYA LAW LLC',
      label: 'MICHAEL HAYA LAW LLC',
      value: 'MICHAEL HAYA LAW LLC',
      planCount: 2,
      selected: false,
      assets: '3,264,951.59',
    },
    {
      id: 591,
      tpaID: '421612198',
      tpaName: 'RETIREMENT PLAN SPECIALISTS INC (WA)',
      label: 'RETIREMENT PLAN SPECIALISTS INC (WA)',
      value: 'RETIREMENT PLAN SPECIALISTS INC (WA)',
      planCount: 3,
      selected: false,
      assets: '3,251,434.76',
    },
    {
      id: 592,
      tpaID: '431109768',
      tpaName: 'KPM CPAS PC',
      label: 'KPM CPAS PC',
      value: 'KPM CPAS PC',
      planCount: 1,
      selected: false,
      assets: '3,250,369.26',
    },
    {
      id: 593,
      tpaID: '141905336',
      tpaName: 'RETIREMENT SOLUTIONS, LLC',
      label: 'RETIREMENT SOLUTIONS, LLC',
      value: 'RETIREMENT SOLUTIONS, LLC',
      planCount: 4,
      selected: false,
      assets: '3,224,396.71',
    },
    {
      id: 594,
      tpaID: '202053740',
      tpaName: 'PENSION PLANNERS, INC.',
      label: 'PENSION PLANNERS, INC.',
      value: 'PENSION PLANNERS, INC.',
      planCount: 4,
      selected: false,
      assets: '3,206,426.81',
    },
    {
      id: 595,
      tpaID: '450645799',
      tpaName: 'DCS RETIREMENT GROUP INC',
      label: 'DCS RETIREMENT GROUP INC',
      value: 'DCS RETIREMENT GROUP INC',
      planCount: 1,
      selected: false,
      assets: '3,205,528.18',
    },
    {
      id: 596,
      tpaID: '453777412',
      tpaName: 'VLR ADMINISTRATORS',
      label: 'VLR ADMINISTRATORS',
      value: 'VLR ADMINISTRATORS',
      planCount: 8,
      selected: false,
      assets: '3,196,604.78',
    },
    {
      id: 597,
      tpaID: '205941966',
      tpaName: "KELLER CPA'S, PLLC",
      label: "KELLER CPA'S, PLLC",
      value: "KELLER CPA'S, PLLC",
      planCount: 2,
      selected: false,
      assets: '3,160,816.25',
    },
    {
      id: 598,
      tpaID: '526149227',
      tpaName: 'DCP RETIREMENT SERVICES, LLC',
      label: 'DCP RETIREMENT SERVICES, LLC',
      value: 'DCP RETIREMENT SERVICES, LLC',
      planCount: 1,
      selected: false,
      assets: '3,158,739.11',
    },
    {
      id: 599,
      tpaID: '810348775',
      tpaName: 'JCCS BENEFIT CONSULTING GROUP',
      label: 'JCCS BENEFIT CONSULTING GROUP',
      value: 'JCCS BENEFIT CONSULTING GROUP',
      planCount: 3,
      selected: false,
      assets: '3,146,487.64',
    },
    {
      id: 600,
      tpaID: '223193872',
      tpaName: 'CREATIVE PENSION ADMINISTRATORS, INC.',
      label: 'CREATIVE PENSION ADMINISTRATORS, INC.',
      value: 'CREATIVE PENSION ADMINISTRATORS, INC.',
      planCount: 1,
      selected: false,
      assets: '3,144,345.25',
    },
    {
      id: 601,
      tpaID: '582427992',
      tpaName: 'SCHACHLE BENEFIT SERVICES INC.',
      label: 'SCHACHLE BENEFIT SERVICES INC.',
      value: 'SCHACHLE BENEFIT SERVICES INC.',
      planCount: 1,
      selected: false,
      assets: '3,140,837.18',
    },
    {
      id: 602,
      tpaID: '363524803',
      tpaName: 'CJBS, LLC',
      label: 'CJBS, LLC',
      value: 'CJBS, LLC',
      planCount: 1,
      selected: false,
      assets: '3,111,005.34',
    },
    {
      id: 603,
      tpaID: '352083429',
      tpaName: 'HAMIL, LEHMAN & ENGLAND, PC',
      label: 'HAMIL, LEHMAN & ENGLAND, PC',
      value: 'HAMIL, LEHMAN & ENGLAND, PC',
      planCount: 4,
      selected: false,
      assets: '3,065,578.77',
    },
    {
      id: 604,
      tpaID: '455527915',
      tpaName: 'CANTERBURY BENEFIT SOLUTIONS INC',
      label: 'CANTERBURY BENEFIT SOLUTIONS INC',
      value: 'CANTERBURY BENEFIT SOLUTIONS INC',
      planCount: 4,
      selected: false,
      assets: '3,047,231.48',
    },
    {
      id: 605,
      tpaID: '631133963',
      tpaName: 'HAYNES DOWNARD LLP',
      label: 'HAYNES DOWNARD LLP',
      value: 'HAYNES DOWNARD LLP',
      planCount: 1,
      selected: false,
      assets: '3,022,201.34',
    },
    {
      id: 606,
      tpaID: '770292157',
      tpaName: 'ACCRUED BENEFIT ADMINISTRATORS, INC',
      label: 'ACCRUED BENEFIT ADMINISTRATORS, INC',
      value: 'ACCRUED BENEFIT ADMINISTRATORS, INC',
      planCount: 2,
      selected: false,
      assets: '2,968,539.67',
    },
    {
      id: 607,
      tpaID: '202036151',
      tpaName: 'RETIREMENT PLAN SOLUTIONS (MI)',
      label: 'RETIREMENT PLAN SOLUTIONS (MI)',
      value: 'RETIREMENT PLAN SOLUTIONS (MI)',
      planCount: 1,
      selected: false,
      assets: '2,946,312.66',
    },
    {
      id: 608,
      tpaID: '942191284',
      tpaName: 'MOORE GRIDER & COMPANY CPAS',
      label: 'MOORE GRIDER & COMPANY CPAS',
      value: 'MOORE GRIDER & COMPANY CPAS',
      planCount: 2,
      selected: false,
      assets: '2,933,570.76',
    },
    {
      id: 609,
      tpaID: '461527517',
      tpaName: 'CREATIVE EMPLOYEE BENEFIT SERVICES, LLC',
      label: 'CREATIVE EMPLOYEE BENEFIT SERVICES, LLC',
      value: 'CREATIVE EMPLOYEE BENEFIT SERVICES, LLC',
      planCount: 2,
      selected: false,
      assets: '2,898,814.89',
    },
    {
      id: 610,
      tpaID: '205321813',
      tpaName: 'UNITED 401K PLANS INC',
      label: 'UNITED 401K PLANS INC',
      value: 'UNITED 401K PLANS INC',
      planCount: 2,
      selected: false,
      assets: '2,889,874.01',
    },
    {
      id: 611,
      tpaID: '370818432',
      tpaName: 'KEMPER CPA GROUP LLP',
      label: 'KEMPER CPA GROUP LLP',
      value: 'KEMPER CPA GROUP LLP',
      planCount: 2,
      selected: false,
      assets: '2,885,446.90',
    },
    {
      id: 612,
      tpaID: '452000158',
      tpaName: 'SIGNATURE RETIREMENT PLAN SERVICES, LLC',
      label: 'SIGNATURE RETIREMENT PLAN SERVICES, LLC',
      value: 'SIGNATURE RETIREMENT PLAN SERVICES, LLC',
      planCount: 3,
      selected: false,
      assets: '2,879,714.37',
    },
    {
      id: 613,
      tpaID: '842599315',
      tpaName: 'LEGACY PENSIONEERS, LLC',
      label: 'LEGACY PENSIONEERS, LLC',
      value: 'LEGACY PENSIONEERS, LLC',
      planCount: 4,
      selected: false,
      assets: '2,875,373.23',
    },
    {
      id: 614,
      tpaID: '231706388',
      tpaName: 'R. P. MILLS ASSOCIATES, INC.',
      label: 'R. P. MILLS ASSOCIATES, INC.',
      value: 'R. P. MILLS ASSOCIATES, INC.',
      planCount: 1,
      selected: false,
      assets: '2,856,805.13',
    },
    {
      id: 615,
      tpaID: '382696931',
      tpaName: 'PATHWAY INVESTMENT COMPANY',
      label: 'PATHWAY INVESTMENT COMPANY',
      value: 'PATHWAY INVESTMENT COMPANY',
      planCount: 1,
      selected: false,
      assets: '2,839,482.54',
    },
    {
      id: 616,
      tpaID: '262258924',
      tpaName: 'COMPUTERIZED PENSION ADMINISTRATION',
      label: 'COMPUTERIZED PENSION ADMINISTRATION',
      value: 'COMPUTERIZED PENSION ADMINISTRATION',
      planCount: 6,
      selected: false,
      assets: '2,832,687.28',
    },
    {
      id: 617,
      tpaID: '453783933',
      tpaName: 'STONES RIVER CONSULTING, INC.',
      label: 'STONES RIVER CONSULTING, INC.',
      value: 'STONES RIVER CONSULTING, INC.',
      planCount: 9,
      selected: false,
      assets: '2,821,236.67',
    },
    {
      id: 618,
      tpaID: '631019234',
      tpaName: 'BYRD, SMALLEY, EVANS & ADAMS',
      label: 'BYRD, SMALLEY, EVANS & ADAMS',
      value: 'BYRD, SMALLEY, EVANS & ADAMS',
      planCount: 1,
      selected: false,
      assets: '2,802,346.22',
    },
    {
      id: 619,
      tpaID: '061036759',
      tpaName: 'KISSEL KNEALE & TOBIN INC',
      label: 'KISSEL KNEALE & TOBIN INC',
      value: 'KISSEL KNEALE & TOBIN INC',
      planCount: 3,
      selected: false,
      assets: '2,786,890.33',
    },
    {
      id: 620,
      tpaID: '430906447',
      tpaName: 'PROFESSIONAL CONSULTING SERVICES INC',
      label: 'PROFESSIONAL CONSULTING SERVICES INC',
      value: 'PROFESSIONAL CONSULTING SERVICES INC',
      planCount: 2,
      selected: false,
      assets: '2,784,509.73',
    },
    {
      id: 621,
      tpaID: '611211399',
      tpaName: 'MCGREGOR & ASSOCIATES INC',
      label: 'MCGREGOR & ASSOCIATES INC',
      value: 'MCGREGOR & ASSOCIATES INC',
      planCount: 3,
      selected: false,
      assets: '2,783,274.37',
    },
    {
      id: 622,
      tpaID: '350921680',
      tpaName: 'CROWE HORWATH LLP',
      label: 'CROWE HORWATH LLP',
      value: 'CROWE HORWATH LLP',
      planCount: 1,
      selected: false,
      assets: '2,754,006.29',
    },
    {
      id: 623,
      tpaID: '752305655',
      tpaName: 'R BARRY JOHNSON & COMPANY PC',
      label: 'R BARRY JOHNSON & COMPANY PC',
      value: 'R BARRY JOHNSON & COMPANY PC',
      planCount: 4,
      selected: false,
      assets: '2,750,573.45',
    },
    {
      id: 624,
      tpaID: '208887754',
      tpaName: 'PINNACLE MANAGEMENT CONSULTING PLC',
      label: 'PINNACLE MANAGEMENT CONSULTING PLC',
      value: 'PINNACLE MANAGEMENT CONSULTING PLC',
      planCount: 1,
      selected: false,
      assets: '2,688,520.34',
    },
    {
      id: 625,
      tpaID: '223859477',
      tpaName: 'MT HOOD PENSION SERVICE LLC',
      label: 'MT HOOD PENSION SERVICE LLC',
      value: 'MT HOOD PENSION SERVICE LLC',
      planCount: 5,
      selected: false,
      assets: '2,681,328.51',
    },
    {
      id: 626,
      tpaID: '274945548',
      tpaName: 'THE RETIREMENT CONSULTANTS, LLC',
      label: 'THE RETIREMENT CONSULTANTS, LLC',
      value: 'THE RETIREMENT CONSULTANTS, LLC',
      planCount: 2,
      selected: false,
      assets: '2,675,443.63',
    },
    {
      id: 627,
      tpaID: '640916458',
      tpaName: 'FAUST & ASSOCIATES CPAS PA',
      label: 'FAUST & ASSOCIATES CPAS PA',
      value: 'FAUST & ASSOCIATES CPAS PA',
      planCount: 1,
      selected: false,
      assets: '2,667,148.94',
    },
    {
      id: 628,
      tpaID: '825042619',
      tpaName: 'RPCG, LLC',
      label: 'RPCG, LLC',
      value: 'RPCG, LLC',
      planCount: 4,
      selected: false,
      assets: '2,613,651.12',
    },
    {
      id: 629,
      tpaID: '330807052',
      tpaName: 'RODNEY R WATKINS CPA APC',
      label: 'RODNEY R WATKINS CPA APC',
      value: 'RODNEY R WATKINS CPA APC',
      planCount: 1,
      selected: false,
      assets: '2,568,314.58',
    },
    {
      id: 630,
      tpaID: '208154051',
      tpaName: 'RETIREMENT SOLUTIONS ADVISORS LLC',
      label: 'RETIREMENT SOLUTIONS ADVISORS LLC',
      value: 'RETIREMENT SOLUTIONS ADVISORS LLC',
      planCount: 4,
      selected: false,
      assets: '2,553,609.91',
    },
    {
      id: 631,
      tpaID: '952624148',
      tpaName: 'GOLDBERG, SWEDELSON & ASSOCIATES INC INSURANCE COMPANY',
      label: 'GOLDBERG, SWEDELSON & ASSOCIATES INC INSURANCE COMPANY',
      value: 'GOLDBERG, SWEDELSON & ASSOCIATES INC INSURANCE COMPANY',
      planCount: 4,
      selected: false,
      assets: '2,541,443.68',
    },
    {
      id: 632,
      tpaID: '131980835',
      tpaName: 'LAIKEN ASSOCIATES INC',
      label: 'LAIKEN ASSOCIATES INC',
      value: 'LAIKEN ASSOCIATES INC',
      planCount: 1,
      selected: false,
      assets: '2,516,916.75',
    },
    {
      id: 633,
      tpaID: '840957308',
      tpaName: 'ERICKSON BROWN & KLOSTER PC',
      label: 'ERICKSON BROWN & KLOSTER PC',
      value: 'ERICKSON BROWN & KLOSTER PC',
      planCount: 2,
      selected: false,
      assets: '2,505,501.38',
    },
    {
      id: 634,
      tpaID: '364560201',
      tpaName: 'ODYSSEY ADVISORS INC.',
      label: 'ODYSSEY ADVISORS INC.',
      value: 'ODYSSEY ADVISORS INC.',
      planCount: 3,
      selected: false,
      assets: '2,484,225.55',
    },
    {
      id: 635,
      tpaID: '475640422',
      tpaName: 'CENTERPOINTE PENSION ADMINISTRATORS INC',
      label: 'CENTERPOINTE PENSION ADMINISTRATORS INC',
      value: 'CENTERPOINTE PENSION ADMINISTRATORS INC',
      planCount: 3,
      selected: false,
      assets: '2,447,681.12',
    },
    {
      id: 636,
      tpaID: '743189371',
      tpaName: 'CORPORATE RETIREMENT SOLUTIONS, LLC',
      label: 'CORPORATE RETIREMENT SOLUTIONS, LLC',
      value: 'CORPORATE RETIREMENT SOLUTIONS, LLC',
      planCount: 1,
      selected: false,
      assets: '2,417,125.00',
    },
    {
      id: 637,
      tpaID: '261448788',
      tpaName: 'BEN-X LLC',
      label: 'BEN-X LLC',
      value: 'BEN-X LLC',
      planCount: 2,
      selected: false,
      assets: '2,396,488.91',
    },
    {
      id: 638,
      tpaID: '464270069',
      tpaName: 'PBC ADVISORS, LLC',
      label: 'PBC ADVISORS, LLC',
      value: 'PBC ADVISORS, LLC',
      planCount: 1,
      selected: false,
      assets: '2,383,770.72',
    },
    {
      id: 639,
      tpaID: '263310639',
      tpaName: 'ADMIN PARTNERS LLC',
      label: 'ADMIN PARTNERS LLC',
      value: 'ADMIN PARTNERS LLC',
      planCount: 2,
      selected: false,
      assets: '2,355,078.86',
    },
    {
      id: 640,
      tpaID: '770228429',
      tpaName: 'JONIGIAN & FOX, INC.',
      label: 'JONIGIAN & FOX, INC.',
      value: 'JONIGIAN & FOX, INC.',
      planCount: 2,
      selected: false,
      assets: '2,353,188.31',
    },
    {
      id: 641,
      tpaID: '341849064',
      tpaName: 'WEIDRICK LIVESAY & COMPANY',
      label: 'WEIDRICK LIVESAY & COMPANY',
      value: 'WEIDRICK LIVESAY & COMPANY',
      planCount: 2,
      selected: false,
      assets: '2,351,368.05',
    },
    {
      id: 642,
      tpaID: '221762935',
      tpaName: 'DATA LIFE ASSOCIATES, INC',
      label: 'DATA LIFE ASSOCIATES, INC',
      value: 'DATA LIFE ASSOCIATES, INC',
      planCount: 2,
      selected: false,
      assets: '2,306,858.37',
    },
    {
      id: 643,
      tpaID: '203890408',
      tpaName: 'AMELING & ASSOCIATES',
      label: 'AMELING & ASSOCIATES',
      value: 'AMELING & ASSOCIATES',
      planCount: 1,
      selected: false,
      assets: '2,301,507.25',
    },
    {
      id: 644,
      tpaID: '020794802',
      tpaName: 'STEIDLE PENSION SOLUTIONS LLC',
      label: 'STEIDLE PENSION SOLUTIONS LLC',
      value: 'STEIDLE PENSION SOLUTIONS LLC',
      planCount: 2,
      selected: false,
      assets: '2,269,359.33',
    },
    {
      id: 645,
      tpaID: '561955281',
      tpaName: 'DAPHNE W. URQUHART, CPA, PA',
      label: 'DAPHNE W. URQUHART, CPA, PA',
      value: 'DAPHNE W. URQUHART, CPA, PA',
      planCount: 3,
      selected: false,
      assets: '2,260,486.11',
    },
    {
      id: 646,
      tpaID: '464099918',
      tpaName: 'MILLENIUM PENSION SOLUTIONS, LLC.',
      label: 'MILLENIUM PENSION SOLUTIONS, LLC.',
      value: 'MILLENIUM PENSION SOLUTIONS, LLC.',
      planCount: 2,
      selected: false,
      assets: '2,198,953.29',
    },
    {
      id: 647,
      tpaID: '481211462',
      tpaName: 'HEARTLAND CONSULTING GROUP, INC',
      label: 'HEARTLAND CONSULTING GROUP, INC',
      value: 'HEARTLAND CONSULTING GROUP, INC',
      planCount: 2,
      selected: false,
      assets: '2,190,272.24',
    },
    {
      id: 648,
      tpaID: '274831094',
      tpaName: 'CAROL DELK PENSION SERVICES LLC',
      label: 'CAROL DELK PENSION SERVICES LLC',
      value: 'CAROL DELK PENSION SERVICES LLC',
      planCount: 2,
      selected: false,
      assets: '2,135,681.58',
    },
    {
      id: 649,
      tpaID: '954255557',
      tpaName: 'THE KAGAN COMPANY',
      label: 'THE KAGAN COMPANY',
      value: 'THE KAGAN COMPANY',
      planCount: 5,
      selected: false,
      assets: '2,126,426.64',
    },
    {
      id: 650,
      tpaID: '813622920',
      tpaName: 'BLUE SKY 401(K) SPECIALISTS, INC.',
      label: 'BLUE SKY 401(K) SPECIALISTS, INC.',
      value: 'BLUE SKY 401(K) SPECIALISTS, INC.',
      planCount: 1,
      selected: false,
      assets: '2,109,600.15',
    },
    {
      id: 651,
      tpaID: '061594840',
      tpaName: 'PENSION BENEFIT CONSULTANTS INC (CT)',
      label: 'PENSION BENEFIT CONSULTANTS INC (CT)',
      value: 'PENSION BENEFIT CONSULTANTS INC (CT)',
      planCount: 1,
      selected: false,
      assets: '2,084,919.68',
    },
    {
      id: 652,
      tpaID: '264419530',
      tpaName: 'SAGE PENSION RESOURCES',
      label: 'SAGE PENSION RESOURCES',
      value: 'SAGE PENSION RESOURCES',
      planCount: 1,
      selected: false,
      assets: '2,084,548.79',
    },
    {
      id: 653,
      tpaID: '264274775',
      tpaName: 'PENSION PLAN CONSULTANTS LLC',
      label: 'PENSION PLAN CONSULTANTS LLC',
      value: 'PENSION PLAN CONSULTANTS LLC',
      planCount: 1,
      selected: false,
      assets: '2,082,105.84',
    },
    {
      id: 654,
      tpaID: '352142418',
      tpaName: 'BROYLES & COMPANY CPAS LLC',
      label: 'BROYLES & COMPANY CPAS LLC',
      value: 'BROYLES & COMPANY CPAS LLC',
      planCount: 1,
      selected: false,
      assets: '2,058,432.26',
    },
    {
      id: 655,
      tpaID: '861297868',
      tpaName: 'ALTIGRO RETIREMENT SERVICES, LLC',
      label: 'ALTIGRO RETIREMENT SERVICES, LLC',
      value: 'ALTIGRO RETIREMENT SERVICES, LLC',
      planCount: 9,
      selected: false,
      assets: '2,050,609.52',
    },
    {
      id: 656,
      tpaID: '752150561',
      tpaName: 'PENSION CONCEPTS AND ADMINISTRATION, INC.',
      label: 'PENSION CONCEPTS AND ADMINISTRATION, INC.',
      value: 'PENSION CONCEPTS AND ADMINISTRATION, INC.',
      planCount: 4,
      selected: false,
      assets: '2,020,643.61',
    },
    {
      id: 657,
      tpaID: '113034763',
      tpaName: 'ARNOLD WARSHAVCHIK',
      label: 'ARNOLD WARSHAVCHIK',
      value: 'ARNOLD WARSHAVCHIK',
      planCount: 3,
      selected: false,
      assets: '2,017,934.19',
    },
    {
      id: 658,
      tpaID: '842047149',
      tpaName: 'CHESTNUT 401(K) ADMINISTRATORS, LLC',
      label: 'CHESTNUT 401(K) ADMINISTRATORS, LLC',
      value: 'CHESTNUT 401(K) ADMINISTRATORS, LLC',
      planCount: 2,
      selected: false,
      assets: '2,012,336.87',
    },
    {
      id: 659,
      tpaID: '251877227',
      tpaName: 'LEAP & ASSOCIATES, PC',
      label: 'LEAP & ASSOCIATES, PC',
      value: 'LEAP & ASSOCIATES, PC',
      planCount: 3,
      selected: false,
      assets: '2,009,479.56',
    },
    {
      id: 660,
      tpaID: '560587953',
      tpaName: 'GILLIAM COBLE & MOSER LLP',
      label: 'GILLIAM COBLE & MOSER LLP',
      value: 'GILLIAM COBLE & MOSER LLP',
      planCount: 2,
      selected: false,
      assets: '2,009,291.09',
    },
    {
      id: 661,
      tpaID: '562382360',
      tpaName: 'JR PENSION SERVICES INC.',
      label: 'JR PENSION SERVICES INC.',
      value: 'JR PENSION SERVICES INC.',
      planCount: 6,
      selected: false,
      assets: '1,990,313.28',
    },
    {
      id: 662,
      tpaID: '060991349',
      tpaName: 'HERITAGE BENEFIT CONSULTANTS, INC.',
      label: 'HERITAGE BENEFIT CONSULTANTS, INC.',
      value: 'HERITAGE BENEFIT CONSULTANTS, INC.',
      planCount: 1,
      selected: false,
      assets: '1,985,328.97',
    },
    {
      id: 663,
      tpaID: '942320862',
      tpaName: 'PRIMARK BENEFITS',
      label: 'PRIMARK BENEFITS',
      value: 'PRIMARK BENEFITS',
      planCount: 1,
      selected: false,
      assets: '1,971,125.98',
    },
    {
      id: 664,
      tpaID: '134096443',
      tpaName: 'FEDERATED FUNERAL DIRECTORS OF AMERICA',
      label: 'FEDERATED FUNERAL DIRECTORS OF AMERICA',
      value: 'FEDERATED FUNERAL DIRECTORS OF AMERICA',
      planCount: 3,
      selected: false,
      assets: '1,948,289.11',
    },
    {
      id: 665,
      tpaID: '141764716',
      tpaName: 'SPECTRUM PENSION AND COMPENSATION INC',
      label: 'SPECTRUM PENSION AND COMPENSATION INC',
      value: 'SPECTRUM PENSION AND COMPENSATION INC',
      planCount: 1,
      selected: false,
      assets: '1,943,469.32',
    },
    {
      id: 666,
      tpaID: '860646843',
      tpaName: 'BOYCE & ASSOCIATES INC',
      label: 'BOYCE & ASSOCIATES INC',
      value: 'BOYCE & ASSOCIATES INC',
      planCount: 6,
      selected: false,
      assets: '1,929,164.31',
    },
    {
      id: 667,
      tpaID: '311385465',
      tpaName: 'FUTURES PLANNING GROUP INC',
      label: 'FUTURES PLANNING GROUP INC',
      value: 'FUTURES PLANNING GROUP INC',
      planCount: 3,
      selected: false,
      assets: '1,924,477.54',
    },
    {
      id: 668,
      tpaID: '760188119',
      tpaName: 'COMPENSATION STRATEGIES GROUP',
      label: 'COMPENSATION STRATEGIES GROUP',
      value: 'COMPENSATION STRATEGIES GROUP',
      planCount: 4,
      selected: false,
      assets: '1,921,138.65',
    },
    {
      id: 669,
      tpaID: '421040629',
      tpaName: 'STAN HANSEN CPA MTAX',
      label: 'STAN HANSEN CPA MTAX',
      value: 'STAN HANSEN CPA MTAX',
      planCount: 1,
      selected: false,
      assets: '1,920,733.63',
    },
    {
      id: 670,
      tpaID: '860437461',
      tpaName: 'M. PAUL TURNER & CO., INC.',
      label: 'M. PAUL TURNER & CO., INC.',
      value: 'M. PAUL TURNER & CO., INC.',
      planCount: 3,
      selected: false,
      assets: '1,898,729.80',
    },
    {
      id: 671,
      tpaID: '820467399',
      tpaName: 'RUDD & COMPANY, PLLC',
      label: 'RUDD & COMPANY, PLLC',
      value: 'RUDD & COMPANY, PLLC',
      planCount: 4,
      selected: false,
      assets: '1,898,107.88',
    },
    {
      id: 672,
      tpaID: '471442479',
      tpaName: 'ACE PENSION SOLUTIONS LLC',
      label: 'ACE PENSION SOLUTIONS LLC',
      value: 'ACE PENSION SOLUTIONS LLC',
      planCount: 1,
      selected: false,
      assets: '1,895,055.73',
    },
    {
      id: 673,
      tpaID: '020366808',
      tpaName: 'STEPHEN ELDRIDGE & COMPANY INC',
      label: 'STEPHEN ELDRIDGE & COMPANY INC',
      value: 'STEPHEN ELDRIDGE & COMPANY INC',
      planCount: 1,
      selected: false,
      assets: '1,887,674.45',
    },
    {
      id: 674,
      tpaID: '300125854',
      tpaName: 'JV ASSOCIATES LTD',
      label: 'JV ASSOCIATES LTD',
      value: 'JV ASSOCIATES LTD',
      planCount: 1,
      selected: false,
      assets: '1,886,808.76',
    },
    {
      id: 675,
      tpaID: '721021504',
      tpaName: 'YOUNG & BELL, ACCPA',
      label: 'YOUNG & BELL, ACCPA',
      value: 'YOUNG & BELL, ACCPA',
      planCount: 5,
      selected: false,
      assets: '1,885,809.22',
    },
    {
      id: 676,
      tpaID: '720538016',
      tpaName: 'BROUSSARD POCHE LLP',
      label: 'BROUSSARD POCHE LLP',
      value: 'BROUSSARD POCHE LLP',
      planCount: 1,
      selected: false,
      assets: '1,880,447.12',
    },
    {
      id: 677,
      tpaID: '010690018',
      tpaName: 'PLAN ADMINISTRATION & CONSULTING, LLC',
      label: 'PLAN ADMINISTRATION & CONSULTING, LLC',
      value: 'PLAN ADMINISTRATION & CONSULTING, LLC',
      planCount: 1,
      selected: false,
      assets: '1,877,544.27',
    },
    {
      id: 678,
      tpaID: '202085970',
      tpaName: 'THAD E HUGHES CPA LLC',
      label: 'THAD E HUGHES CPA LLC',
      value: 'THAD E HUGHES CPA LLC',
      planCount: 5,
      selected: false,
      assets: '1,875,052.65',
    },
    {
      id: 679,
      tpaID: '880364219',
      tpaName: 'EKS FINANCIAL SERVICES, INC.',
      label: 'EKS FINANCIAL SERVICES, INC.',
      value: 'EKS FINANCIAL SERVICES, INC.',
      planCount: 1,
      selected: false,
      assets: '1,827,729.95',
    },
    {
      id: 680,
      tpaID: '481211365',
      tpaName: 'PROFESSIONAL PENSION SERVICES INC (KS)',
      label: 'PROFESSIONAL PENSION SERVICES INC (KS)',
      value: 'PROFESSIONAL PENSION SERVICES INC (KS)',
      planCount: 1,
      selected: false,
      assets: '1,822,510.51',
    },
    {
      id: 681,
      tpaID: '350672425',
      tpaName: 'HUB INTERNATIONAL MIDWEST LIMITED',
      label: 'HUB INTERNATIONAL MIDWEST LIMITED',
      value: 'HUB INTERNATIONAL MIDWEST LIMITED',
      planCount: 2,
      selected: false,
      assets: '1,812,056.37',
    },
    {
      id: 682,
      tpaID: '630510739',
      tpaName: 'WEAR HOWELL STRICKLAND QUINN & LAW LLC',
      label: 'WEAR HOWELL STRICKLAND QUINN & LAW LLC',
      value: 'WEAR HOWELL STRICKLAND QUINN & LAW LLC',
      planCount: 2,
      selected: false,
      assets: '1,791,966.58',
    },
    {
      id: 683,
      tpaID: '204013184',
      tpaName: 'SIMS & SIMS TPA SERVICE LLC',
      label: 'SIMS & SIMS TPA SERVICE LLC',
      value: 'SIMS & SIMS TPA SERVICE LLC',
      planCount: 1,
      selected: false,
      assets: '1,777,578.94',
    },
    {
      id: 684,
      tpaID: '112472285',
      tpaName: 'WILLIAM S JACOBS & ASSOCIATES',
      label: 'WILLIAM S JACOBS & ASSOCIATES',
      value: 'WILLIAM S JACOBS & ASSOCIATES',
      planCount: 2,
      selected: false,
      assets: '1,750,713.33',
    },
    {
      id: 685,
      tpaID: '454211533',
      tpaName: 'SPIRA BENEFITS, LLC',
      label: 'SPIRA BENEFITS, LLC',
      value: 'SPIRA BENEFITS, LLC',
      planCount: 2,
      selected: false,
      assets: '1,736,939.62',
    },
    {
      id: 686,
      tpaID: '810805522',
      tpaName: 'CERBERUS RETIREMENT, INC.',
      label: 'CERBERUS RETIREMENT, INC.',
      value: 'CERBERUS RETIREMENT, INC.',
      planCount: 5,
      selected: false,
      assets: '1,733,093.41',
    },
    {
      id: 687,
      tpaID: '680527623',
      tpaName: 'PENSIONS WEST',
      label: 'PENSIONS WEST',
      value: 'PENSIONS WEST',
      planCount: 3,
      selected: false,
      assets: '1,730,772.83',
    },
    {
      id: 688,
      tpaID: '942720886',
      tpaName: 'PENSIONALYSIS INC',
      label: 'PENSIONALYSIS INC',
      value: 'PENSIONALYSIS INC',
      planCount: 1,
      selected: false,
      assets: '1,713,767.04',
    },
    {
      id: 689,
      tpaID: '813186048',
      tpaName: 'BENEFIT SOLUTIONS, ETC. LIMITED (OH)',
      label: 'BENEFIT SOLUTIONS, ETC. LIMITED (OH)',
      value: 'BENEFIT SOLUTIONS, ETC. LIMITED (OH)',
      planCount: 3,
      selected: false,
      assets: '1,689,806.86',
    },
    {
      id: 690,
      tpaID: '363750335',
      tpaName: 'NORTHWEST BENEFIT CONSULTANTS, INC.',
      label: 'NORTHWEST BENEFIT CONSULTANTS, INC.',
      value: 'NORTHWEST BENEFIT CONSULTANTS, INC.',
      planCount: 4,
      selected: false,
      assets: '1,682,500.69',
    },
    {
      id: 691,
      tpaID: '861354423',
      tpaName: 'CASCADE 401(K)CONSULTANTS, LLC',
      label: 'CASCADE 401(K)CONSULTANTS, LLC',
      value: 'CASCADE 401(K)CONSULTANTS, LLC',
      planCount: 1,
      selected: false,
      assets: '1,661,924.38',
    },
    {
      id: 692,
      tpaID: '202927339',
      tpaName: 'G.J. LELAND & ASSOCIATES',
      label: 'G.J. LELAND & ASSOCIATES',
      value: 'G.J. LELAND & ASSOCIATES',
      planCount: 1,
      selected: false,
      assets: '1,638,150.70',
    },
    {
      id: 693,
      tpaID: '264814822',
      tpaName: 'ORP LLC DBA BENEFIT SOLUTIONS',
      label: 'ORP LLC DBA BENEFIT SOLUTIONS',
      value: 'ORP LLC DBA BENEFIT SOLUTIONS',
      planCount: 2,
      selected: false,
      assets: '1,611,375.87',
    },
    {
      id: 694,
      tpaID: '731553481',
      tpaName: 'WEIKEL JOHNSON PARRIS & ROUSE PLLP',
      label: 'WEIKEL JOHNSON PARRIS & ROUSE PLLP',
      value: 'WEIKEL JOHNSON PARRIS & ROUSE PLLP',
      planCount: 2,
      selected: false,
      assets: '1,603,519.79',
    },
    {
      id: 695,
      tpaID: '911125800',
      tpaName: 'SHANNON & ASSOCIATES, LLP',
      label: 'SHANNON & ASSOCIATES, LLP',
      value: 'SHANNON & ASSOCIATES, LLP',
      planCount: 4,
      selected: false,
      assets: '1,595,104.96',
    },
    {
      id: 696,
      tpaID: '954868697',
      tpaName: 'NATIONAL PENSION CONSULTANTS INC',
      label: 'NATIONAL PENSION CONSULTANTS INC',
      value: 'NATIONAL PENSION CONSULTANTS INC',
      planCount: 4,
      selected: false,
      assets: '1,592,352.68',
    },
    {
      id: 697,
      tpaID: '223477324',
      tpaName: 'KARDAN ACTUARIAL SERVICES LLC',
      label: 'KARDAN ACTUARIAL SERVICES LLC',
      value: 'KARDAN ACTUARIAL SERVICES LLC',
      planCount: 1,
      selected: false,
      assets: '1,578,317.60',
    },
    {
      id: 698,
      tpaID: '030499638',
      tpaName: 'THE MAYER BENEFITS ADVISORY LLC',
      label: 'THE MAYER BENEFITS ADVISORY LLC',
      value: 'THE MAYER BENEFITS ADVISORY LLC',
      planCount: 2,
      selected: false,
      assets: '1,549,540.05',
    },
    {
      id: 699,
      tpaID: '261141852',
      tpaName: 'THE RAYMOND COMPANY PENSION SERVICES, LLC',
      label: 'THE RAYMOND COMPANY PENSION SERVICES, LLC',
      value: 'THE RAYMOND COMPANY PENSION SERVICES, LLC',
      planCount: 5,
      selected: false,
      assets: '1,545,433.02',
    },
    {
      id: 700,
      tpaID: '450250958',
      tpaName: 'EIDE BAILLY LLP',
      label: 'EIDE BAILLY LLP',
      value: 'EIDE BAILLY LLP',
      planCount: 3,
      selected: false,
      assets: '1,541,399.52',
    },
    {
      id: 701,
      tpaID: '271144993',
      tpaName: 'SOUTHEASTERN PENSION COMPANY',
      label: 'SOUTHEASTERN PENSION COMPANY',
      value: 'SOUTHEASTERN PENSION COMPANY',
      planCount: 2,
      selected: false,
      assets: '1,532,291.08',
    },
    {
      id: 702,
      tpaID: '931262852',
      tpaName: 'NORTHWEST BUSINESS MANAGEMENT',
      label: 'NORTHWEST BUSINESS MANAGEMENT',
      value: 'NORTHWEST BUSINESS MANAGEMENT',
      planCount: 3,
      selected: false,
      assets: '1,496,896.16',
    },
    {
      id: 703,
      tpaID: '471674808',
      tpaName: 'LIFE, INC. RETIREMENT SERVICES',
      label: 'LIFE, INC. RETIREMENT SERVICES',
      value: 'LIFE, INC. RETIREMENT SERVICES',
      planCount: 2,
      selected: false,
      assets: '1,496,291.92',
    },
    {
      id: 704,
      tpaID: '631086621',
      tpaName: 'MURFEE MEADOWS INC',
      label: 'MURFEE MEADOWS INC',
      value: 'MURFEE MEADOWS INC',
      planCount: 4,
      selected: false,
      assets: '1,473,305.76',
    },
    {
      id: 705,
      tpaID: '113079484',
      tpaName: 'PROFESSIONAL EMPLOYEE BENEFIT CONSULTANTS INC',
      label: 'PROFESSIONAL EMPLOYEE BENEFIT CONSULTANTS INC',
      value: 'PROFESSIONAL EMPLOYEE BENEFIT CONSULTANTS INC',
      planCount: 1,
      selected: false,
      assets: '1,434,347.31',
    },
    {
      id: 706,
      tpaID: '850350687',
      tpaName: 'RETIREMENT CONSULTANTS LTD',
      label: 'RETIREMENT CONSULTANTS LTD',
      value: 'RETIREMENT CONSULTANTS LTD',
      planCount: 1,
      selected: false,
      assets: '1,416,327.67',
    },
    {
      id: 707,
      tpaID: '710631123',
      tpaName: 'OSBORN, CARREIRO & ASSOCIATES INC',
      label: 'OSBORN, CARREIRO & ASSOCIATES INC',
      value: 'OSBORN, CARREIRO & ASSOCIATES INC',
      planCount: 1,
      selected: false,
      assets: '1,401,079.80',
    },
    {
      id: 708,
      tpaID: '112809283',
      tpaName: 'INTEGRATED PENSION DESIGN, INC.',
      label: 'INTEGRATED PENSION DESIGN, INC.',
      value: 'INTEGRATED PENSION DESIGN, INC.',
      planCount: 1,
      selected: false,
      assets: '1,389,298.18',
    },
    {
      id: 709,
      tpaID: '953661896',
      tpaName: 'PMZ PENSION SERVICES',
      label: 'PMZ PENSION SERVICES',
      value: 'PMZ PENSION SERVICES',
      planCount: 4,
      selected: false,
      assets: '1,375,566.85',
    },
    {
      id: 710,
      tpaID: '208236226',
      tpaName: 'LONE STAR ENDEAVORS, LLC',
      label: 'LONE STAR ENDEAVORS, LLC',
      value: 'LONE STAR ENDEAVORS, LLC',
      planCount: 2,
      selected: false,
      assets: '1,367,651.74',
    },
    {
      id: 711,
      tpaID: '200128147',
      tpaName: 'FGMK FINANCIAL SERVICES LLC',
      label: 'FGMK FINANCIAL SERVICES LLC',
      value: 'FGMK FINANCIAL SERVICES LLC',
      planCount: 1,
      selected: false,
      assets: '1,321,934.10',
    },
    {
      id: 712,
      tpaID: '461639923',
      tpaName: 'WITMAN PENSION CONSULTING LLC',
      label: 'WITMAN PENSION CONSULTING LLC',
      value: 'WITMAN PENSION CONSULTING LLC',
      planCount: 2,
      selected: false,
      assets: '1,313,755.34',
    },
    {
      id: 713,
      tpaID: '341345571',
      tpaName: 'INDEPENDENT BENEFIT SERVICE',
      label: 'INDEPENDENT BENEFIT SERVICE',
      value: 'INDEPENDENT BENEFIT SERVICE',
      planCount: 1,
      selected: false,
      assets: '1,306,796.49',
    },
    {
      id: 714,
      tpaID: '273058529',
      tpaName: 'CASH BALANCE ACTUARIES, LLC',
      label: 'CASH BALANCE ACTUARIES, LLC',
      value: 'CASH BALANCE ACTUARIES, LLC',
      planCount: 2,
      selected: false,
      assets: '1,289,544.35',
    },
    {
      id: 715,
      tpaID: '202089130',
      tpaName: 'APPLIED PENSION SERVICES LLC',
      label: 'APPLIED PENSION SERVICES LLC',
      value: 'APPLIED PENSION SERVICES LLC',
      planCount: 3,
      selected: false,
      assets: '1,256,468.54',
    },
    {
      id: 716,
      tpaID: '141777319',
      tpaName: 'SMC BENEFITS ADMINISTRATION GROUP, INC.',
      label: 'SMC BENEFITS ADMINISTRATION GROUP, INC.',
      value: 'SMC BENEFITS ADMINISTRATION GROUP, INC.',
      planCount: 1,
      selected: false,
      assets: '1,250,832.69',
    },
    {
      id: 717,
      tpaID: '200500360',
      tpaName: 'VALLEY PENSION SERVICES',
      label: 'VALLEY PENSION SERVICES',
      value: 'VALLEY PENSION SERVICES',
      planCount: 1,
      selected: false,
      assets: '1,243,089.92',
    },
    {
      id: 718,
      tpaID: '141798160',
      tpaName: 'ASTERINO CPA PC & CO',
      label: 'ASTERINO CPA PC & CO',
      value: 'ASTERINO CPA PC & CO',
      planCount: 1,
      selected: false,
      assets: '1,235,630.09',
    },
    {
      id: 719,
      tpaID: '042676828',
      tpaName: 'QUALIFIED PENSION SERVICES, INC. (ME)',
      label: 'QUALIFIED PENSION SERVICES, INC. (ME)',
      value: 'QUALIFIED PENSION SERVICES, INC. (ME)',
      planCount: 2,
      selected: false,
      assets: '1,230,415.08',
    },
    {
      id: 720,
      tpaID: '474435064',
      tpaName: 'TWENTYTHIRTY PARTNERS',
      label: 'TWENTYTHIRTY PARTNERS',
      value: 'TWENTYTHIRTY PARTNERS',
      planCount: 3,
      selected: false,
      assets: '1,230,269.66',
    },
    {
      id: 721,
      tpaID: '201776739',
      tpaName: 'JPMS COX, PLLC',
      label: 'JPMS COX, PLLC',
      value: 'JPMS COX, PLLC',
      planCount: 1,
      selected: false,
      assets: '1,221,480.38',
    },
    {
      id: 722,
      tpaID: '900815510',
      tpaName: 'RETIREMENT PLAN FIDUCIARIES',
      label: 'RETIREMENT PLAN FIDUCIARIES',
      value: 'RETIREMENT PLAN FIDUCIARIES',
      planCount: 3,
      selected: false,
      assets: '1,218,638.70',
    },
    {
      id: 723,
      tpaID: '208263081',
      tpaName: 'PROFESSIONAL PENSION SERVICES INC (CA)',
      label: 'PROFESSIONAL PENSION SERVICES INC (CA)',
      value: 'PROFESSIONAL PENSION SERVICES INC (CA)',
      planCount: 2,
      selected: false,
      assets: '1,194,572.85',
    },
    {
      id: 724,
      tpaID: '263148951',
      tpaName: 'POWERS STROMBERG PENSION CONSULTING, INC.',
      label: 'POWERS STROMBERG PENSION CONSULTING, INC.',
      value: 'POWERS STROMBERG PENSION CONSULTING, INC.',
      planCount: 1,
      selected: false,
      assets: '1,190,695.45',
    },
    {
      id: 725,
      tpaID: '270086582',
      tpaName: 'COMPLETE BENEFIT SOLUTIONS',
      label: 'COMPLETE BENEFIT SOLUTIONS',
      value: 'COMPLETE BENEFIT SOLUTIONS',
      planCount: 2,
      selected: false,
      assets: '1,190,411.63',
    },
    {
      id: 726,
      tpaID: '201235712',
      tpaName: 'CJK BENEFIT GROUP, LLC',
      label: 'CJK BENEFIT GROUP, LLC',
      value: 'CJK BENEFIT GROUP, LLC',
      planCount: 1,
      selected: false,
      assets: '1,187,290.68',
    },
    {
      id: 727,
      tpaID: '741130599',
      tpaName: 'PATTILLO, BROWN & HILL, LLP',
      label: 'PATTILLO, BROWN & HILL, LLP',
      value: 'PATTILLO, BROWN & HILL, LLP',
      planCount: 4,
      selected: false,
      assets: '1,181,794.11',
    },
    {
      id: 728,
      tpaID: '112728120',
      tpaName: 'THE PENSION DEPARTMENT, INC.',
      label: 'THE PENSION DEPARTMENT, INC.',
      value: 'THE PENSION DEPARTMENT, INC.',
      planCount: 2,
      selected: false,
      assets: '1,181,771.03',
    },
    {
      id: 729,
      tpaID: '341824981',
      tpaName: 'FRANCIS P. GALLAGHER & ASSOCIATES, INC.',
      label: 'FRANCIS P. GALLAGHER & ASSOCIATES, INC.',
      value: 'FRANCIS P. GALLAGHER & ASSOCIATES, INC.',
      planCount: 1,
      selected: false,
      assets: '1,171,041.62',
    },
    {
      id: 730,
      tpaID: '731229879',
      tpaName: 'LOYD PENSION SERVICES, INC.',
      label: 'LOYD PENSION SERVICES, INC.',
      value: 'LOYD PENSION SERVICES, INC.',
      planCount: 1,
      selected: false,
      assets: '1,169,957.66',
    },
    {
      id: 731,
      tpaID: '201722754',
      tpaName: 'BENEFIT SOLUTIONS OF ARKANSAS, LLC',
      label: 'BENEFIT SOLUTIONS OF ARKANSAS, LLC',
      value: 'BENEFIT SOLUTIONS OF ARKANSAS, LLC',
      planCount: 1,
      selected: false,
      assets: '1,156,329.69',
    },
    {
      id: 732,
      tpaID: '330509582',
      tpaName: 'RITA KALRA & ASSOCIATES, INC',
      label: 'RITA KALRA & ASSOCIATES, INC',
      value: 'RITA KALRA & ASSOCIATES, INC',
      planCount: 6,
      selected: false,
      assets: '1,149,842.97',
    },
    {
      id: 733,
      tpaID: '680168178',
      tpaName: 'NLH & COMPANY EMPLOYEE BENEFIT CONSULTANTS, INC.',
      label: 'NLH & COMPANY EMPLOYEE BENEFIT CONSULTANTS, INC.',
      value: 'NLH & COMPANY EMPLOYEE BENEFIT CONSULTANTS, INC.',
      planCount: 1,
      selected: false,
      assets: '1,140,801.07',
    },
    {
      id: 734,
      tpaID: '453680212',
      tpaName: 'JOHN HANNAH CORPORATION',
      label: 'JOHN HANNAH CORPORATION',
      value: 'JOHN HANNAH CORPORATION',
      planCount: 2,
      selected: false,
      assets: '1,131,079.19',
    },
    {
      id: 735,
      tpaID: '273970979',
      tpaName: 'PENSION PROFESSIONALS, LLC (HI)',
      label: 'PENSION PROFESSIONALS, LLC (HI)',
      value: 'PENSION PROFESSIONALS, LLC (HI)',
      planCount: 3,
      selected: false,
      assets: '1,130,362.25',
    },
    {
      id: 736,
      tpaID: '341739646',
      tpaName: 'OHIO PRO PLAN INC',
      label: 'OHIO PRO PLAN INC',
      value: 'OHIO PRO PLAN INC',
      planCount: 1,
      selected: false,
      assets: '1,126,275.37',
    },
    {
      id: 737,
      tpaID: '731521434',
      tpaName: 'PENSION SOLUTIONS INC',
      label: 'PENSION SOLUTIONS INC',
      value: 'PENSION SOLUTIONS INC',
      planCount: 2,
      selected: false,
      assets: '1,122,991.98',
    },
    {
      id: 738,
      tpaID: '271659117',
      tpaName: 'AEGIS PENSION SERVICES, INC.',
      label: 'AEGIS PENSION SERVICES, INC.',
      value: 'AEGIS PENSION SERVICES, INC.',
      planCount: 1,
      selected: false,
      assets: '1,116,443.76',
    },
    {
      id: 739,
      tpaID: '825254524',
      tpaName: 'SABER PENSION & ACTUARIAL SERVICES, LLC',
      label: 'SABER PENSION & ACTUARIAL SERVICES, LLC',
      value: 'SABER PENSION & ACTUARIAL SERVICES, LLC',
      planCount: 2,
      selected: false,
      assets: '1,114,549.59',
    },
    {
      id: 740,
      tpaID: '061357287',
      tpaName: 'CREATIVE PENSION DESIGN & ADMINISTRATION INC',
      label: 'CREATIVE PENSION DESIGN & ADMINISTRATION INC',
      value: 'CREATIVE PENSION DESIGN & ADMINISTRATION INC',
      planCount: 1,
      selected: false,
      assets: '1,114,326.64',
    },
    {
      id: 741,
      tpaID: '203940726',
      tpaName: 'HENDERSON RETIREMENT SERVICES, INC.',
      label: 'HENDERSON RETIREMENT SERVICES, INC.',
      value: 'HENDERSON RETIREMENT SERVICES, INC.',
      planCount: 2,
      selected: false,
      assets: '1,076,327.33',
    },
    {
      id: 742,
      tpaID: '582464392',
      tpaName: 'WRIGHT RETIREMENT SERVICES, LLC',
      label: 'WRIGHT RETIREMENT SERVICES, LLC',
      value: 'WRIGHT RETIREMENT SERVICES, LLC',
      planCount: 2,
      selected: false,
      assets: '1,069,083.69',
    },
    {
      id: 743,
      tpaID: '311585572',
      tpaName: 'DYNAMIC PENSION SERVICES INC',
      label: 'DYNAMIC PENSION SERVICES INC',
      value: 'DYNAMIC PENSION SERVICES INC',
      planCount: 1,
      selected: false,
      assets: '1,054,850.21',
    },
    {
      id: 744,
      tpaID: '900525804',
      tpaName: 'SAVILLE DODGEN & COMPANY PLLC',
      label: 'SAVILLE DODGEN & COMPANY PLLC',
      value: 'SAVILLE DODGEN & COMPANY PLLC',
      planCount: 2,
      selected: false,
      assets: '1,051,297.76',
    },
    {
      id: 745,
      tpaID: '205843936',
      tpaName: 'POWERS FINANCIAL GROUP, LLC',
      label: 'POWERS FINANCIAL GROUP, LLC',
      value: 'POWERS FINANCIAL GROUP, LLC',
      planCount: 2,
      selected: false,
      assets: '1,046,870.97',
    },
    {
      id: 746,
      tpaID: '591558855',
      tpaName: 'PENSION INVESTORS CORPORATION',
      label: 'PENSION INVESTORS CORPORATION',
      value: 'PENSION INVESTORS CORPORATION',
      planCount: 1,
      selected: false,
      assets: '1,043,067.15',
    },
    {
      id: 747,
      tpaID: '363503735',
      tpaName: 'PANTHER PENSIONS',
      label: 'PANTHER PENSIONS',
      value: 'PANTHER PENSIONS',
      planCount: 1,
      selected: false,
      assets: '1,035,493.99',
    },
    {
      id: 748,
      tpaID: '263781194',
      tpaName: 'PLANPERFECT INC',
      label: 'PLANPERFECT INC',
      value: 'PLANPERFECT INC',
      planCount: 3,
      selected: false,
      assets: '1,006,889.31',
    },
    {
      id: 749,
      tpaID: '043838205',
      tpaName: 'SIGNATURE PENSION CONSULTING SERVICES, LLC',
      label: 'SIGNATURE PENSION CONSULTING SERVICES, LLC',
      value: 'SIGNATURE PENSION CONSULTING SERVICES, LLC',
      planCount: 1,
      selected: false,
      assets: '1,000,085.94',
    },
    {
      id: 750,
      tpaID: '113619496',
      tpaName: 'TURTURRO PENSION CONSULTING, INC',
      label: 'TURTURRO PENSION CONSULTING, INC',
      value: 'TURTURRO PENSION CONSULTING, INC',
      planCount: 4,
      selected: false,
      assets: '993,860.47',
    },
    {
      id: 751,
      tpaID: '431954512',
      tpaName: 'ABACUS RETIREMENT SOLUTIONS LLC',
      label: 'ABACUS RETIREMENT SOLUTIONS LLC',
      value: 'ABACUS RETIREMENT SOLUTIONS LLC',
      planCount: 3,
      selected: false,
      assets: '988,400.66',
    },
    {
      id: 752,
      tpaID: '050558318',
      tpaName: 'SPECTRA ASSOCIATES INC',
      label: 'SPECTRA ASSOCIATES INC',
      value: 'SPECTRA ASSOCIATES INC',
      planCount: 1,
      selected: false,
      assets: '977,327.15',
    },
    {
      id: 753,
      tpaID: '202378124',
      tpaName: 'PARAGON TPA GROUP INC',
      label: 'PARAGON TPA GROUP INC',
      value: 'PARAGON TPA GROUP INC',
      planCount: 4,
      selected: false,
      assets: '973,964.17',
    },
    {
      id: 754,
      tpaID: '812539355',
      tpaName: 'R OLDS INC.',
      label: 'R OLDS INC.',
      value: 'R OLDS INC.',
      planCount: 1,
      selected: false,
      assets: '970,356.12',
    },
    {
      id: 755,
      tpaID: '113600477',
      tpaName: 'WACHSTOCK PENSION LAW, P.C.',
      label: 'WACHSTOCK PENSION LAW, P.C.',
      value: 'WACHSTOCK PENSION LAW, P.C.',
      planCount: 2,
      selected: false,
      assets: '951,692.07',
    },
    {
      id: 756,
      tpaID: '721108038',
      tpaName: 'ARS RETIREMENT CORPORATION',
      label: 'ARS RETIREMENT CORPORATION',
      value: 'ARS RETIREMENT CORPORATION',
      planCount: 1,
      selected: false,
      assets: '944,492.67',
    },
    {
      id: 757,
      tpaID: '112817258',
      tpaName: 'FELLER INCORPORATED',
      label: 'FELLER INCORPORATED',
      value: 'FELLER INCORPORATED',
      planCount: 1,
      selected: false,
      assets: '941,792.28',
    },
    {
      id: 758,
      tpaID: '474690856',
      tpaName: 'ABOVE & BEYOND RETIREMENT, LLC',
      label: 'ABOVE & BEYOND RETIREMENT, LLC',
      value: 'ABOVE & BEYOND RETIREMENT, LLC',
      planCount: 2,
      selected: false,
      assets: '929,352.65',
    },
    {
      id: 759,
      tpaID: '056561366',
      tpaName: 'ELITE PENSION CONSULTANTS',
      label: 'ELITE PENSION CONSULTANTS',
      value: 'ELITE PENSION CONSULTANTS',
      planCount: 1,
      selected: false,
      assets: '906,560.28',
    },
    {
      id: 760,
      tpaID: '112859146',
      tpaName: 'ROBIN S WEINGAST AND ASSOCIATES INC',
      label: 'ROBIN S WEINGAST AND ASSOCIATES INC',
      value: 'ROBIN S WEINGAST AND ASSOCIATES INC',
      planCount: 3,
      selected: false,
      assets: '906,285.06',
    },
    {
      id: 761,
      tpaID: '813053978',
      tpaName: 'INTEGRITY PLANS, LLC',
      label: 'INTEGRITY PLANS, LLC',
      value: 'INTEGRITY PLANS, LLC',
      planCount: 1,
      selected: false,
      assets: '902,723.05',
    },
    {
      id: 762,
      tpaID: '630936180',
      tpaName: 'CADE & ASSOCIATES, P.C.',
      label: 'CADE & ASSOCIATES, P.C.',
      value: 'CADE & ASSOCIATES, P.C.',
      planCount: 1,
      selected: false,
      assets: '894,185.26',
    },
    {
      id: 763,
      tpaID: '134123391',
      tpaName: 'WAGNER PENSION SERVICES LLC',
      label: 'WAGNER PENSION SERVICES LLC',
      value: 'WAGNER PENSION SERVICES LLC',
      planCount: 1,
      selected: false,
      assets: '892,512.49',
    },
    {
      id: 764,
      tpaID: '132832286',
      tpaName: 'RETIREMENT PROGRAMMING LTD.',
      label: 'RETIREMENT PROGRAMMING LTD.',
      value: 'RETIREMENT PROGRAMMING LTD.',
      planCount: 1,
      selected: false,
      assets: '856,682.98',
    },
    {
      id: 765,
      tpaID: '541521351',
      tpaName: 'ACTUARIAL BENEFITS & DESIGN COMPANY',
      label: 'ACTUARIAL BENEFITS & DESIGN COMPANY',
      value: 'ACTUARIAL BENEFITS & DESIGN COMPANY',
      planCount: 2,
      selected: false,
      assets: '849,338.50',
    },
    {
      id: 766,
      tpaID: '363111655',
      tpaName: 'PENSION ADMINISTRATORS, INC. (IL)',
      label: 'PENSION ADMINISTRATORS, INC. (IL)',
      value: 'PENSION ADMINISTRATORS, INC. (IL)',
      planCount: 2,
      selected: false,
      assets: '841,000.34',
    },
    {
      id: 767,
      tpaID: '550828085',
      tpaName: 'JCB PENSION COMPANY, INC.',
      label: 'JCB PENSION COMPANY, INC.',
      value: 'JCB PENSION COMPANY, INC.',
      planCount: 2,
      selected: false,
      assets: '837,048.79',
    },
    {
      id: 768,
      tpaID: '383712991',
      tpaName: 'THE RETIREMENT PLAN COMPANY',
      label: 'THE RETIREMENT PLAN COMPANY',
      value: 'THE RETIREMENT PLAN COMPANY',
      planCount: 4,
      selected: false,
      assets: '831,804.06',
    },
    {
      id: 769,
      tpaID: '133622058',
      tpaName: 'RETIREMENT PLAN REVIEW INC',
      label: 'RETIREMENT PLAN REVIEW INC',
      value: 'RETIREMENT PLAN REVIEW INC',
      planCount: 1,
      selected: false,
      assets: '830,534.15',
    },
    {
      id: 770,
      tpaID: '200897973',
      tpaName: 'TPA ADMIN INC',
      label: 'TPA ADMIN INC',
      value: 'TPA ADMIN INC',
      planCount: 2,
      selected: false,
      assets: '800,513.02',
    },
    {
      id: 771,
      tpaID: '061227799',
      tpaName: 'GREER BENEFIT CONSULTANTS, INC.',
      label: 'GREER BENEFIT CONSULTANTS, INC.',
      value: 'GREER BENEFIT CONSULTANTS, INC.',
      planCount: 1,
      selected: false,
      assets: '781,230.23',
    },
    {
      id: 772,
      tpaID: '841158337',
      tpaName: 'LT PLAN SERVICES, INC.',
      label: 'LT PLAN SERVICES, INC.',
      value: 'LT PLAN SERVICES, INC.',
      planCount: 2,
      selected: false,
      assets: '775,703.82',
    },
    {
      id: 773,
      tpaID: '204194681',
      tpaName: 'FP KESSLER JR & ASSOCIATES TPA LLC',
      label: 'FP KESSLER JR & ASSOCIATES TPA LLC',
      value: 'FP KESSLER JR & ASSOCIATES TPA LLC',
      planCount: 1,
      selected: false,
      assets: '773,662.42',
    },
    {
      id: 774,
      tpaID: '382707979',
      tpaName: 'RMC Group as First Actuarial Corp',
      label: 'RMC Group as First Actuarial Corp',
      value: 'RMC Group as First Actuarial Corp',
      planCount: 3,
      selected: false,
      assets: '773,531.17',
    },
    {
      id: 775,
      tpaID: '274383169',
      tpaName: 'POINTE CONSULTANTS, LLC',
      label: 'POINTE CONSULTANTS, LLC',
      value: 'POINTE CONSULTANTS, LLC',
      planCount: 1,
      selected: false,
      assets: '762,406.74',
    },
    {
      id: 776,
      tpaID: '942646743',
      tpaName: 'RETIREMENT ADMINISTRATION, INC.',
      label: 'RETIREMENT ADMINISTRATION, INC.',
      value: 'RETIREMENT ADMINISTRATION, INC.',
      planCount: 3,
      selected: false,
      assets: '753,161.62',
    },
    {
      id: 777,
      tpaID: '271581748',
      tpaName: 'CROWN BENEFITS INC',
      label: 'CROWN BENEFITS INC',
      value: 'CROWN BENEFITS INC',
      planCount: 1,
      selected: false,
      assets: '751,251.21',
    },
    {
      id: 778,
      tpaID: '112882237',
      tpaName: 'ACCRUED BENEFITS PLANNING LTD',
      label: 'ACCRUED BENEFITS PLANNING LTD',
      value: 'ACCRUED BENEFITS PLANNING LTD',
      planCount: 1,
      selected: false,
      assets: '734,255.13',
    },
    {
      id: 779,
      tpaID: '454549512',
      tpaName: 'PENSION STRATEGIES CORP',
      label: 'PENSION STRATEGIES CORP',
      value: 'PENSION STRATEGIES CORP',
      planCount: 1,
      selected: false,
      assets: '727,381.49',
    },
    {
      id: 780,
      tpaID: '814249523',
      tpaName: 'PENSIONS INC',
      label: 'PENSIONS INC',
      value: 'PENSIONS INC',
      planCount: 1,
      selected: false,
      assets: '724,645.41',
    },
    {
      id: 781,
      tpaID: '870475726',
      tpaName: 'WASATCH EMPLOYEE BENEFIT SERVICES',
      label: 'WASATCH EMPLOYEE BENEFIT SERVICES',
      value: 'WASATCH EMPLOYEE BENEFIT SERVICES',
      planCount: 2,
      selected: false,
      assets: '716,937.50',
    },
    {
      id: 782,
      tpaID: '593332202',
      tpaName: 'CLEMONS & PIERCE, INC',
      label: 'CLEMONS & PIERCE, INC',
      value: 'CLEMONS & PIERCE, INC',
      planCount: 1,
      selected: false,
      assets: '716,375.67',
    },
    {
      id: 783,
      tpaID: '900288844',
      tpaName: 'SUNBURST PENSION SERVICES, LLC',
      label: 'SUNBURST PENSION SERVICES, LLC',
      value: 'SUNBURST PENSION SERVICES, LLC',
      planCount: 2,
      selected: false,
      assets: '714,180.31',
    },
    {
      id: 784,
      tpaID: '453053267',
      tpaName: 'SINGLETON, KELLNER, BOLDING, AVANT & ASSOCIATES LLC',
      label: 'SINGLETON, KELLNER, BOLDING, AVANT & ASSOCIATES LLC',
      value: 'SINGLETON, KELLNER, BOLDING, AVANT & ASSOCIATES LLC',
      planCount: 2,
      selected: false,
      assets: '698,297.57',
    },
    {
      id: 785,
      tpaID: '813232331',
      tpaName: 'KRANTZ & COMPANY CPA, LLC',
      label: 'KRANTZ & COMPANY CPA, LLC',
      value: 'KRANTZ & COMPANY CPA, LLC',
      planCount: 1,
      selected: false,
      assets: '671,227.54',
    },
    {
      id: 786,
      tpaID: '954100265',
      tpaName: 'COMPENSATION CONSULTANTS, INC.',
      label: 'COMPENSATION CONSULTANTS, INC.',
      value: 'COMPENSATION CONSULTANTS, INC.',
      planCount: 2,
      selected: false,
      assets: '669,217.44',
    },
    {
      id: 787,
      tpaID: '753226803',
      tpaName: 'PRIORITY PENSION SERVICES, INC',
      label: 'PRIORITY PENSION SERVICES, INC',
      value: 'PRIORITY PENSION SERVICES, INC',
      planCount: 4,
      selected: false,
      assets: '668,287.55',
    },
    {
      id: 788,
      tpaID: '223940860',
      tpaName: 'PENSION SERVICE COMPANY',
      label: 'PENSION SERVICE COMPANY',
      value: 'PENSION SERVICE COMPANY',
      planCount: 2,
      selected: false,
      assets: '668,208.24',
    },
    {
      id: 789,
      tpaID: '042798172',
      tpaName: 'M & M PLANS, INC.',
      label: 'M & M PLANS, INC.',
      value: 'M & M PLANS, INC.',
      planCount: 1,
      selected: false,
      assets: '667,257.40',
    },
    {
      id: 790,
      tpaID: '341722481',
      tpaName: 'FLEXIBLE BENEFITS SYSTEMS INC',
      label: 'FLEXIBLE BENEFITS SYSTEMS INC',
      value: 'FLEXIBLE BENEFITS SYSTEMS INC',
      planCount: 1,
      selected: false,
      assets: '667,082.39',
    },
    {
      id: 791,
      tpaID: '870453369',
      tpaName: 'HUNTINGTON & ASSOCIATES, CPA, PC',
      label: 'HUNTINGTON & ASSOCIATES, CPA, PC',
      value: 'HUNTINGTON & ASSOCIATES, CPA, PC',
      planCount: 2,
      selected: false,
      assets: '631,923.54',
    },
    {
      id: 792,
      tpaID: '205192368',
      tpaName: 'COMPASS RETIREMENT PLAN SPECIALISTS LLC',
      label: 'COMPASS RETIREMENT PLAN SPECIALISTS LLC',
      value: 'COMPASS RETIREMENT PLAN SPECIALISTS LLC',
      planCount: 2,
      selected: false,
      assets: '629,950.84',
    },
    {
      id: 793,
      tpaID: '823275238',
      tpaName: 'EZTPA, LLC',
      label: 'EZTPA, LLC',
      value: 'EZTPA, LLC',
      planCount: 3,
      selected: false,
      assets: '625,444.32',
    },
    {
      id: 794,
      tpaID: '161229660',
      tpaName: 'DONOHUE FEIMAN RETIREMENT PLAN SERVICES INC',
      label: 'DONOHUE FEIMAN RETIREMENT PLAN SERVICES INC',
      value: 'DONOHUE FEIMAN RETIREMENT PLAN SERVICES INC',
      planCount: 4,
      selected: false,
      assets: '624,248.91',
    },
    {
      id: 795,
      tpaID: '043513306',
      tpaName: 'RIVER AND MERCANTILE',
      label: 'RIVER AND MERCANTILE',
      value: 'RIVER AND MERCANTILE',
      planCount: 1,
      selected: false,
      assets: '619,959.61',
    },
    {
      id: 796,
      tpaID: '990252022',
      tpaName: 'CHOY & COMPANY INC',
      label: 'CHOY & COMPANY INC',
      value: 'CHOY & COMPANY INC',
      planCount: 1,
      selected: false,
      assets: '604,155.29',
    },
    {
      id: 797,
      tpaID: '223954919',
      tpaName: 'CORPORATE BENEFIT SYSTEMS, INC',
      label: 'CORPORATE BENEFIT SYSTEMS, INC',
      value: 'CORPORATE BENEFIT SYSTEMS, INC',
      planCount: 2,
      selected: false,
      assets: '602,305.06',
    },
    {
      id: 798,
      tpaID: '202997520',
      tpaName: 'BSG BENEFITS, INC.',
      label: 'BSG BENEFITS, INC.',
      value: 'BSG BENEFITS, INC.',
      planCount: 2,
      selected: false,
      assets: '599,545.03',
    },
    {
      id: 799,
      tpaID: '742743978',
      tpaName: 'BENEFIT SYSTEMS INC',
      label: 'BENEFIT SYSTEMS INC',
      value: 'BENEFIT SYSTEMS INC',
      planCount: 3,
      selected: false,
      assets: '593,331.83',
    },
    {
      id: 800,
      tpaID: '900334271',
      tpaName: 'DF PENSIONS INC',
      label: 'DF PENSIONS INC',
      value: 'DF PENSIONS INC',
      planCount: 4,
      selected: false,
      assets: '580,432.44',
    },
    {
      id: 801,
      tpaID: '161364782',
      tpaName: 'RETIREMENT ESSENTIALS INC',
      label: 'RETIREMENT ESSENTIALS INC',
      value: 'RETIREMENT ESSENTIALS INC',
      planCount: 1,
      selected: false,
      assets: '566,949.51',
    },
    {
      id: 802,
      tpaID: '364122320',
      tpaName: 'BCL FINANCIAL MANAGEMENT CONSULTANTS INC',
      label: 'BCL FINANCIAL MANAGEMENT CONSULTANTS INC',
      value: 'BCL FINANCIAL MANAGEMENT CONSULTANTS INC',
      planCount: 1,
      selected: false,
      assets: '560,154.86',
    },
    {
      id: 803,
      tpaID: '010723685',
      tpaName: 'DERMODY BURKE & BROWN CPAS LLC',
      label: 'DERMODY BURKE & BROWN CPAS LLC',
      value: 'DERMODY BURKE & BROWN CPAS LLC',
      planCount: 2,
      selected: false,
      assets: '552,265.47',
    },
    {
      id: 804,
      tpaID: '200754801',
      tpaName: 'JACOB, HAXTON & BOORD, LLC',
      label: 'JACOB, HAXTON & BOORD, LLC',
      value: 'JACOB, HAXTON & BOORD, LLC',
      planCount: 2,
      selected: false,
      assets: '545,072.51',
    },
    {
      id: 805,
      tpaID: '271691989',
      tpaName: 'WEBER FINANCIAL SERVICES INC',
      label: 'WEBER FINANCIAL SERVICES INC',
      value: 'WEBER FINANCIAL SERVICES INC',
      planCount: 1,
      selected: false,
      assets: '544,708.47',
    },
    {
      id: 806,
      tpaID: '411826648',
      tpaName: 'KLINGER AND ASSOCIATES INC',
      label: 'KLINGER AND ASSOCIATES INC',
      value: 'KLINGER AND ASSOCIATES INC',
      planCount: 1,
      selected: false,
      assets: '515,234.89',
    },
    {
      id: 807,
      tpaID: '920179841',
      tpaName: 'ALEXANDRU CALIN',
      label: 'ALEXANDRU CALIN',
      value: 'ALEXANDRU CALIN',
      planCount: 2,
      selected: false,
      assets: '509,351.16',
    },
    {
      id: 808,
      tpaID: '232561975',
      tpaName: 'GF PENSION CORP',
      label: 'GF PENSION CORP',
      value: 'GF PENSION CORP',
      planCount: 1,
      selected: false,
      assets: '506,363.00',
    },
    {
      id: 809,
      tpaID: '760478563',
      tpaName: 'RTU & ASSOCIATES, INC.',
      label: 'RTU & ASSOCIATES, INC.',
      value: 'RTU & ASSOCIATES, INC.',
      planCount: 1,
      selected: false,
      assets: '505,276.90',
    },
    {
      id: 810,
      tpaID: '270562632',
      tpaName: 'MOWER AND ASSOCIATES, INC.',
      label: 'MOWER AND ASSOCIATES, INC.',
      value: 'MOWER AND ASSOCIATES, INC.',
      planCount: 2,
      selected: false,
      assets: '500,056.10',
    },
    {
      id: 811,
      tpaID: '760544224',
      tpaName: 'HOLZKNECHT UMALI, INC.',
      label: 'HOLZKNECHT UMALI, INC.',
      value: 'HOLZKNECHT UMALI, INC.',
      planCount: 1,
      selected: false,
      assets: '497,247.07',
    },
    {
      id: 812,
      tpaID: '262824865',
      tpaName: 'WESPAC PLAN SERVICES LLC',
      label: 'WESPAC PLAN SERVICES LLC',
      value: 'WESPAC PLAN SERVICES LLC',
      planCount: 1,
      selected: false,
      assets: '473,208.91',
    },
    {
      id: 813,
      tpaID: '251590560',
      tpaName: 'JOHN S AGATSTON ACTUARIAL SERVICES',
      label: 'JOHN S AGATSTON ACTUARIAL SERVICES',
      value: 'JOHN S AGATSTON ACTUARIAL SERVICES',
      planCount: 1,
      selected: false,
      assets: '466,672.21',
    },
    {
      id: 814,
      tpaID: '411680240',
      tpaName: 'SCHECHTER DOKKEN KANTER ANDREWS SELCER LTD',
      label: 'SCHECHTER DOKKEN KANTER ANDREWS SELCER LTD',
      value: 'SCHECHTER DOKKEN KANTER ANDREWS SELCER LTD',
      planCount: 1,
      selected: false,
      assets: '456,551.11',
    },
    {
      id: 815,
      tpaID: '465575448',
      tpaName: 'FIDUS ACTUARIAL SOLUTIONS LLC',
      label: 'FIDUS ACTUARIAL SOLUTIONS LLC',
      value: 'FIDUS ACTUARIAL SOLUTIONS LLC',
      planCount: 1,
      selected: false,
      assets: '454,808.71',
    },
    {
      id: 816,
      tpaID: '200514835',
      tpaName: 'TLC PENSION CONSULTING, INC.',
      label: 'TLC PENSION CONSULTING, INC.',
      value: 'TLC PENSION CONSULTING, INC.',
      planCount: 1,
      selected: false,
      assets: '448,899.91',
    },
    {
      id: 817,
      tpaID: '812115704',
      tpaName: 'SUPER CHIEF PENSION SERVICES, LLC',
      label: 'SUPER CHIEF PENSION SERVICES, LLC',
      value: 'SUPER CHIEF PENSION SERVICES, LLC',
      planCount: 4,
      selected: false,
      assets: '440,311.79',
    },
    {
      id: 818,
      tpaID: '710253637',
      tpaName: 'FRIDAY ELDREDGE & CLARK LLP',
      label: 'FRIDAY ELDREDGE & CLARK LLP',
      value: 'FRIDAY ELDREDGE & CLARK LLP',
      planCount: 1,
      selected: false,
      assets: '437,521.72',
    },
    {
      id: 819,
      tpaID: '431126847',
      tpaName: 'WILLIAMS-KEEPERS LLC',
      label: 'WILLIAMS-KEEPERS LLC',
      value: 'WILLIAMS-KEEPERS LLC',
      planCount: 1,
      selected: false,
      assets: '434,013.19',
    },
    {
      id: 820,
      tpaID: '113592473',
      tpaName: 'KLERER FINANCIAL SERVICES INC',
      label: 'KLERER FINANCIAL SERVICES INC',
      value: 'KLERER FINANCIAL SERVICES INC',
      planCount: 1,
      selected: false,
      assets: '432,233.19',
    },
    {
      id: 821,
      tpaID: '443342609',
      tpaName: 'AUSTIN CAPITAL RETIREMENT PLAN SERVICES LLC',
      label: 'AUSTIN CAPITAL RETIREMENT PLAN SERVICES LLC',
      value: 'AUSTIN CAPITAL RETIREMENT PLAN SERVICES LLC',
      planCount: 1,
      selected: false,
      assets: '423,527.38',
    },
    {
      id: 822,
      tpaID: '341846540',
      tpaName: 'CERTIFIED PENSION SERVICES',
      label: 'CERTIFIED PENSION SERVICES',
      value: 'CERTIFIED PENSION SERVICES',
      planCount: 1,
      selected: false,
      assets: '422,086.02',
    },
    {
      id: 823,
      tpaID: '330509446',
      tpaName: 'STEPHEN DEMAINE CPA',
      label: 'STEPHEN DEMAINE CPA',
      value: 'STEPHEN DEMAINE CPA',
      planCount: 1,
      selected: false,
      assets: '419,429.16',
    },
    {
      id: 824,
      tpaID: '200094527',
      tpaName: 'MAHAN & ASSOCIATES LLC',
      label: 'MAHAN & ASSOCIATES LLC',
      value: 'MAHAN & ASSOCIATES LLC',
      planCount: 2,
      selected: false,
      assets: '416,375.77',
    },
    {
      id: 825,
      tpaID: '811142798',
      tpaName: 'EDWARDS PENSION SERVICES, INC',
      label: 'EDWARDS PENSION SERVICES, INC',
      value: 'EDWARDS PENSION SERVICES, INC',
      planCount: 2,
      selected: false,
      assets: '404,827.76',
    },
    {
      id: 826,
      tpaID: '610481842',
      tpaName: 'WILLIAMS, WILLIAMS & LENTZ, LLP',
      label: 'WILLIAMS, WILLIAMS & LENTZ, LLP',
      value: 'WILLIAMS, WILLIAMS & LENTZ, LLP',
      planCount: 1,
      selected: false,
      assets: '404,373.03',
    },
    {
      id: 827,
      tpaID: '770204740',
      tpaName: 'LIDEN NESTLE SOLED & ASSOCIATES INC',
      label: 'LIDEN NESTLE SOLED & ASSOCIATES INC',
      value: 'LIDEN NESTLE SOLED & ASSOCIATES INC',
      planCount: 1,
      selected: false,
      assets: '399,514.32',
    },
    {
      id: 828,
      tpaID: '202447236',
      tpaName: 'BUSINESS PENSION GROUP',
      label: 'BUSINESS PENSION GROUP',
      value: 'BUSINESS PENSION GROUP',
      planCount: 3,
      selected: false,
      assets: '397,809.15',
    },
    {
      id: 829,
      tpaID: '953671020',
      tpaName: 'SECURED RETIREMENT ADMINISTRATORS, INC.',
      label: 'SECURED RETIREMENT ADMINISTRATORS, INC.',
      value: 'SECURED RETIREMENT ADMINISTRATORS, INC.',
      planCount: 2,
      selected: false,
      assets: '393,183.73',
    },
    {
      id: 830,
      tpaID: '931034768',
      tpaName: 'VELA & MEHRINGER INC',
      label: 'VELA & MEHRINGER INC',
      value: 'VELA & MEHRINGER INC',
      planCount: 2,
      selected: false,
      assets: '381,345.07',
    },
    {
      id: 831,
      tpaID: '621838285',
      tpaName: 'BENEFIT RESOURCES, INC. (TN)',
      label: 'BENEFIT RESOURCES, INC. (TN)',
      value: 'BENEFIT RESOURCES, INC. (TN)',
      planCount: 1,
      selected: false,
      assets: '377,489.87',
    },
    {
      id: 832,
      tpaID: '630926271',
      tpaName: 'BENETECH ADMINISTRATORS INC',
      label: 'BENETECH ADMINISTRATORS INC',
      value: 'BENETECH ADMINISTRATORS INC',
      planCount: 2,
      selected: false,
      assets: '374,022.95',
    },
    {
      id: 833,
      tpaID: '042879032',
      tpaName: 'JOHN T TOOMEY ASSOCIATES INC',
      label: 'JOHN T TOOMEY ASSOCIATES INC',
      value: 'JOHN T TOOMEY ASSOCIATES INC',
      planCount: 1,
      selected: false,
      assets: '364,666.09',
    },
    {
      id: 834,
      tpaID: '042629080',
      tpaName: 'CARAS AND SHULMAN PC',
      label: 'CARAS AND SHULMAN PC',
      value: 'CARAS AND SHULMAN PC',
      planCount: 1,
      selected: false,
      assets: '362,704.04',
    },
    {
      id: 835,
      tpaID: '273111834',
      tpaName: 'ASSURANCE RETIREMENT GROUP, LLC',
      label: 'ASSURANCE RETIREMENT GROUP, LLC',
      value: 'ASSURANCE RETIREMENT GROUP, LLC',
      planCount: 1,
      selected: false,
      assets: '355,748.01',
    },
    {
      id: 836,
      tpaID: '830254900',
      tpaName: 'FAGNANT LEWIS & BRINDA PC',
      label: 'FAGNANT LEWIS & BRINDA PC',
      value: 'FAGNANT LEWIS & BRINDA PC',
      planCount: 1,
      selected: false,
      assets: '343,505.41',
    },
    {
      id: 837,
      tpaID: '202679145',
      tpaName: 'DANIEL R. SAUNDERS ASSOCIATES, PC',
      label: 'DANIEL R. SAUNDERS ASSOCIATES, PC',
      value: 'DANIEL R. SAUNDERS ASSOCIATES, PC',
      planCount: 1,
      selected: false,
      assets: '340,966.40',
    },
    {
      id: 838,
      tpaID: '611364409',
      tpaName: 'MITCHELL & ASSOCIATES, PLLC',
      label: 'MITCHELL & ASSOCIATES, PLLC',
      value: 'MITCHELL & ASSOCIATES, PLLC',
      planCount: 2,
      selected: false,
      assets: '335,670.96',
    },
    {
      id: 839,
      tpaID: '420114010',
      tpaName: 'AMERICAN TRUST & SAVINGS BANK',
      label: 'AMERICAN TRUST & SAVINGS BANK',
      value: 'AMERICAN TRUST & SAVINGS BANK',
      planCount: 1,
      selected: false,
      assets: '316,279.22',
    },
    {
      id: 840,
      tpaID: '204028162',
      tpaName: 'TOTAL RETIREMENT SOLUTIONS INC',
      label: 'TOTAL RETIREMENT SOLUTIONS INC',
      value: 'TOTAL RETIREMENT SOLUTIONS INC',
      planCount: 1,
      selected: false,
      assets: '310,681.39',
    },
    {
      id: 841,
      tpaID: '721536696',
      tpaName: 'PENSION LABS INC',
      label: 'PENSION LABS INC',
      value: 'PENSION LABS INC',
      planCount: 1,
      selected: false,
      assets: '306,824.69',
    },
    {
      id: 842,
      tpaID: '480922953',
      tpaName: 'KEATING & ASSOCIATES INC',
      label: 'KEATING & ASSOCIATES INC',
      value: 'KEATING & ASSOCIATES INC',
      planCount: 2,
      selected: false,
      assets: '302,726.57',
    },
    {
      id: 843,
      tpaID: '631033572',
      tpaName: 'MELVIN, BIBB, SEGARS & ASSOCIATES, PC',
      label: 'MELVIN, BIBB, SEGARS & ASSOCIATES, PC',
      value: 'MELVIN, BIBB, SEGARS & ASSOCIATES, PC',
      planCount: 1,
      selected: false,
      assets: '284,955.36',
    },
    {
      id: 844,
      tpaID: '134074620',
      tpaName: 'STEPHEN P. TAFT',
      label: 'STEPHEN P. TAFT',
      value: 'STEPHEN P. TAFT',
      planCount: 1,
      selected: false,
      assets: '278,387.23',
    },
    {
      id: 845,
      tpaID: '751721253',
      tpaName: 'CARLEY & MCCAW, INC.',
      label: 'CARLEY & MCCAW, INC.',
      value: 'CARLEY & MCCAW, INC.',
      planCount: 1,
      selected: false,
      assets: '278,086.60',
    },
    {
      id: 846,
      tpaID: '391537831',
      tpaName: 'SPURLOCK RUNYAN MILLER & ASSOCIATES LLP',
      label: 'SPURLOCK RUNYAN MILLER & ASSOCIATES LLP',
      value: 'SPURLOCK RUNYAN MILLER & ASSOCIATES LLP',
      planCount: 1,
      selected: false,
      assets: '276,643.35',
    },
    {
      id: 847,
      tpaID: '330942438',
      tpaName: 'MG MILLER ENTERPRISES INC',
      label: 'MG MILLER ENTERPRISES INC',
      value: 'MG MILLER ENTERPRISES INC',
      planCount: 1,
      selected: false,
      assets: '272,298.88',
    },
    {
      id: 848,
      tpaID: '364028918',
      tpaName: 'TWG BENEFITS, INC.',
      label: 'TWG BENEFITS, INC.',
      value: 'TWG BENEFITS, INC.',
      planCount: 4,
      selected: false,
      assets: '261,500.38',
    },
    {
      id: 849,
      tpaID: '232439467',
      tpaName: 'MARKLEY ACTUARIAL SERVICES INC',
      label: 'MARKLEY ACTUARIAL SERVICES INC',
      value: 'MARKLEY ACTUARIAL SERVICES INC',
      planCount: 1,
      selected: false,
      assets: '261,292.00',
    },
    {
      id: 850,
      tpaID: '452737996',
      tpaName: 'TRU-RETIREMENT INC',
      label: 'TRU-RETIREMENT INC',
      value: 'TRU-RETIREMENT INC',
      planCount: 1,
      selected: false,
      assets: '253,763.14',
    },
    {
      id: 851,
      tpaID: '364326029',
      tpaName: 'PENSION ADVISORY GROUP LTD',
      label: 'PENSION ADVISORY GROUP LTD',
      value: 'PENSION ADVISORY GROUP LTD',
      planCount: 1,
      selected: false,
      assets: '244,172.42',
    },
    {
      id: 852,
      tpaID: '222602083',
      tpaName: 'E H THOMSON AND CO INC',
      label: 'E H THOMSON AND CO INC',
      value: 'E H THOMSON AND CO INC',
      planCount: 2,
      selected: false,
      assets: '218,033.87',
    },
    {
      id: 853,
      tpaID: '262183269',
      tpaName: 'PINPOINT FINANCIAL LLC',
      label: 'PINPOINT FINANCIAL LLC',
      value: 'PINPOINT FINANCIAL LLC',
      planCount: 2,
      selected: false,
      assets: '206,795.33',
    },
    {
      id: 854,
      tpaID: '844140298',
      tpaName: 'LIU ACTUARIAL CONSULTING SERVICES, INC.',
      label: 'LIU ACTUARIAL CONSULTING SERVICES, INC.',
      value: 'LIU ACTUARIAL CONSULTING SERVICES, INC.',
      planCount: 1,
      selected: false,
      assets: '202,564.89',
    },
    {
      id: 855,
      tpaID: '910835225',
      tpaName: 'PENSION SERVICES CORPORATION (CA)',
      label: 'PENSION SERVICES CORPORATION (CA)',
      value: 'PENSION SERVICES CORPORATION (CA)',
      planCount: 1,
      selected: false,
      assets: '192,074.03',
    },
    {
      id: 856,
      tpaID: '475507944',
      tpaName: 'PENSION PLAN DESIGNS INC',
      label: 'PENSION PLAN DESIGNS INC',
      value: 'PENSION PLAN DESIGNS INC',
      planCount: 1,
      selected: false,
      assets: '181,032.02',
    },
    {
      id: 857,
      tpaID: '901007360',
      tpaName: 'NATIONAL PENSION PARTNERS INSURANCE AND FINANCIAL',
      label: 'NATIONAL PENSION PARTNERS INSURANCE AND FINANCIAL',
      value: 'NATIONAL PENSION PARTNERS INSURANCE AND FINANCIAL',
      planCount: 1,
      selected: false,
      assets: '175,747.51',
    },
    {
      id: 858,
      tpaID: '760354750',
      tpaName: 'THE ALLOCATION COMPANY',
      label: 'THE ALLOCATION COMPANY',
      value: 'THE ALLOCATION COMPANY',
      planCount: 1,
      selected: false,
      assets: '174,707.98',
    },
    {
      id: 859,
      tpaID: '710525335',
      tpaName: 'BROWN ROGERS & COMPANY PA',
      label: 'BROWN ROGERS & COMPANY PA',
      value: 'BROWN ROGERS & COMPANY PA',
      planCount: 1,
      selected: false,
      assets: '158,261.75',
    },
    {
      id: 860,
      tpaID: '452505297',
      tpaName: 'CONSIDERED OPINION INC',
      label: 'CONSIDERED OPINION INC',
      value: 'CONSIDERED OPINION INC',
      planCount: 1,
      selected: false,
      assets: '150,546.23',
    },
    {
      id: 861,
      tpaID: '451969246',
      tpaName: 'DC CONSULTANTS, LLC',
      label: 'DC CONSULTANTS, LLC',
      value: 'DC CONSULTANTS, LLC',
      planCount: 2,
      selected: false,
      assets: '148,799.88',
    },
    {
      id: 862,
      tpaID: '270761910',
      tpaName: 'CORE BENEFIT CONSULTANTS, INC.',
      label: 'CORE BENEFIT CONSULTANTS, INC.',
      value: 'CORE BENEFIT CONSULTANTS, INC.',
      planCount: 1,
      selected: false,
      assets: '148,195.75',
    },
    {
      id: 863,
      tpaID: '366079566',
      tpaName: 'REED-RAMSEY, INC',
      label: 'REED-RAMSEY, INC',
      value: 'REED-RAMSEY, INC',
      planCount: 1,
      selected: false,
      assets: '147,948.84',
    },
    {
      id: 864,
      tpaID: '274042748',
      tpaName: 'ACCOUNTING & TAX EDGE LLC',
      label: 'ACCOUNTING & TAX EDGE LLC',
      value: 'ACCOUNTING & TAX EDGE LLC',
      planCount: 1,
      selected: false,
      assets: '145,668.86',
    },
    {
      id: 865,
      tpaID: '912050054',
      tpaName: 'BREAK THRU BENEFITS LLC',
      label: 'BREAK THRU BENEFITS LLC',
      value: 'BREAK THRU BENEFITS LLC',
      planCount: 2,
      selected: false,
      assets: '133,530.01',
    },
    {
      id: 866,
      tpaID: '371331544',
      tpaName: 'QUORUM CONSULTING GROUP',
      label: 'QUORUM CONSULTING GROUP',
      value: 'QUORUM CONSULTING GROUP',
      planCount: 1,
      selected: false,
      assets: '130,937.07',
    },
    {
      id: 867,
      tpaID: '382834216',
      tpaName: 'WEBER & MONY PC',
      label: 'WEBER & MONY PC',
      value: 'WEBER & MONY PC',
      planCount: 1,
      selected: false,
      assets: '128,213.25',
    },
    {
      id: 868,
      tpaID: '382563599',
      tpaName: 'H & S COMPANIES PC',
      label: 'H & S COMPANIES PC',
      value: 'H & S COMPANIES PC',
      planCount: 1,
      selected: false,
      assets: '121,971.97',
    },
    {
      id: 869,
      tpaID: '530226443',
      tpaName: 'QUALIFIED RETIREMENT PLANS',
      label: 'QUALIFIED RETIREMENT PLANS',
      value: 'QUALIFIED RETIREMENT PLANS',
      planCount: 1,
      selected: false,
      assets: '118,056.07',
    },
    {
      id: 870,
      tpaID: '953731313',
      tpaName: 'RAYMOND REEVES AND STOUT LLP',
      label: 'RAYMOND REEVES AND STOUT LLP',
      value: 'RAYMOND REEVES AND STOUT LLP',
      planCount: 1,
      selected: false,
      assets: '116,565.40',
    },
    {
      id: 871,
      tpaID: '824211528',
      tpaName: 'BIG SKY RETIREMENT INC.',
      label: 'BIG SKY RETIREMENT INC.',
      value: 'BIG SKY RETIREMENT INC.',
      planCount: 1,
      selected: false,
      assets: '116,372.95',
    },
    {
      id: 872,
      tpaID: '061430628',
      tpaName: 'HILDE MINKEL & ASSOCIATES',
      label: 'HILDE MINKEL & ASSOCIATES',
      value: 'HILDE MINKEL & ASSOCIATES',
      planCount: 1,
      selected: false,
      assets: '114,154.25',
    },
    {
      id: 873,
      tpaID: '208442259',
      tpaName: 'GURNEE ACCOUNTING SERVICES INC',
      label: 'GURNEE ACCOUNTING SERVICES INC',
      value: 'GURNEE ACCOUNTING SERVICES INC',
      planCount: 1,
      selected: false,
      assets: '113,085.93',
    },
    {
      id: 874,
      tpaID: '113193094',
      tpaName: 'FOREST HILLS PENSION SERVICES',
      label: 'FOREST HILLS PENSION SERVICES',
      value: 'FOREST HILLS PENSION SERVICES',
      planCount: 1,
      selected: false,
      assets: '105,365.90',
    },
    {
      id: 875,
      tpaID: '341373917',
      tpaName: 'HILEMAN ASSOCIATES',
      label: 'HILEMAN ASSOCIATES',
      value: 'HILEMAN ASSOCIATES',
      planCount: 1,
      selected: false,
      assets: '101,984.96',
    },
    {
      id: 876,
      tpaID: '203296649',
      tpaName: 'DAVID R. DORFMAN & ASSOCIATES, LLC',
      label: 'DAVID R. DORFMAN & ASSOCIATES, LLC',
      value: 'DAVID R. DORFMAN & ASSOCIATES, LLC',
      planCount: 1,
      selected: false,
      assets: '91,679.12',
    },
    {
      id: 877,
      tpaID: '201785583',
      tpaName: 'SOUND BENEFITS CONSULTING',
      label: 'SOUND BENEFITS CONSULTING',
      value: 'SOUND BENEFITS CONSULTING',
      planCount: 1,
      selected: false,
      assets: '88,835.26',
    },
    {
      id: 878,
      tpaID: '350457540',
      tpaName: 'THE LAFAYETTE LIFE INSURANCE COMPANY',
      label: 'THE LAFAYETTE LIFE INSURANCE COMPANY',
      value: 'THE LAFAYETTE LIFE INSURANCE COMPANY',
      planCount: 2,
      selected: false,
      assets: '87,950.86',
    },
    {
      id: 879,
      tpaID: '454417591',
      tpaName: 'ETA CONSULTING, LLC',
      label: 'ETA CONSULTING, LLC',
      value: 'ETA CONSULTING, LLC',
      planCount: 3,
      selected: false,
      assets: '83,861.74',
    },
    {
      id: 880,
      tpaID: '931303841',
      tpaName: 'SPECTRUM CPA GROUP LLP',
      label: 'SPECTRUM CPA GROUP LLP',
      value: 'SPECTRUM CPA GROUP LLP',
      planCount: 2,
      selected: false,
      assets: '78,552.98',
    },
    {
      id: 881,
      tpaID: '341945206',
      tpaName: 'SKODA MINOTTI',
      label: 'SKODA MINOTTI',
      value: 'SKODA MINOTTI',
      planCount: 1,
      selected: false,
      assets: '56,056.83',
    },
    {
      id: 882,
      tpaID: '844677005',
      tpaName: 'FRONT 9 ADMINISTRATION',
      label: 'FRONT 9 ADMINISTRATION',
      value: 'FRONT 9 ADMINISTRATION',
      planCount: 1,
      selected: false,
      assets: '54,043.19',
    },
    {
      id: 883,
      tpaID: '383669330',
      tpaName: 'COLEMAN AND ASSOCIATES INC',
      label: 'COLEMAN AND ASSOCIATES INC',
      value: 'COLEMAN AND ASSOCIATES INC',
      planCount: 1,
      selected: false,
      assets: '53,615.79',
    },
    {
      id: 884,
      tpaID: '593186310',
      tpaName: 'THOMAS HOWELL FERGUSON PA',
      label: 'THOMAS HOWELL FERGUSON PA',
      value: 'THOMAS HOWELL FERGUSON PA',
      planCount: 2,
      selected: false,
      assets: '51,040.60',
    },
    {
      id: 885,
      tpaID: '870325228',
      tpaName: 'HAYNIE & COMPANY',
      label: 'HAYNIE & COMPANY',
      value: 'HAYNIE & COMPANY',
      planCount: 1,
      selected: false,
      assets: '47,524.39',
    },
    {
      id: 886,
      tpaID: '133264290',
      tpaName: 'PENSION & PROFIT SHARING PLANNING CO., INC.',
      label: 'PENSION & PROFIT SHARING PLANNING CO., INC.',
      value: 'PENSION & PROFIT SHARING PLANNING CO., INC.',
      planCount: 1,
      selected: false,
      assets: '43,524.48',
    },
    {
      id: 887,
      tpaID: '954265683',
      tpaName: 'GUARANTEED PENSION SERVICE',
      label: 'GUARANTEED PENSION SERVICE',
      value: 'GUARANTEED PENSION SERVICE',
      planCount: 1,
      selected: false,
      assets: '38,782.62',
    },
    {
      id: 888,
      tpaID: '271656243',
      tpaName: 'IRA FINANCIAL GROUP LLC',
      label: 'IRA FINANCIAL GROUP LLC',
      value: 'IRA FINANCIAL GROUP LLC',
      planCount: 1,
      selected: false,
      assets: '37,792.95',
    },
    {
      id: 889,
      tpaID: '362943085',
      tpaName: 'BHASKER S KENKARE, CPA',
      label: 'BHASKER S KENKARE, CPA',
      value: 'BHASKER S KENKARE, CPA',
      planCount: 1,
      selected: false,
      assets: '33,068.45',
    },
    {
      id: 890,
      tpaID: '822751328',
      tpaName: 'AXIM MANAGED RETIREMENT SOLUTIONS',
      label: 'AXIM MANAGED RETIREMENT SOLUTIONS',
      value: 'AXIM MANAGED RETIREMENT SOLUTIONS',
      planCount: 1,
      selected: false,
      assets: '18,688.52',
    },
    {
      id: 891,
      tpaID: '521268363',
      tpaName: 'DRAPER & MCGINLEY, P.A.',
      label: 'DRAPER & MCGINLEY, P.A.',
      value: 'DRAPER & MCGINLEY, P.A.',
      planCount: 1,
      selected: false,
      assets: 270.95,
    },
    {
      id: 892,
      tpaID: '820341397',
      tpaName: 'APA Benefits, Inc.',
      label: 'APA Benefits, Inc.',
      value: 'APA Benefits, Inc.',
      planCount: 1,
      selected: false,
      assets: '',
    },
    {
      id: 893,
      tpaID: '851049623',
      tpaName: 'SOUND PENSION ADVISORS, LLC',
      label: 'SOUND PENSION ADVISORS, LLC',
      value: 'SOUND PENSION ADVISORS, LLC',
      planCount: 1,
      selected: false,
      assets: '',
    },
    {
      id: 894,
      tpaID: '873632446',
      tpaName: 'COMMONWEALTH TPA SOLUTIONS LLC',
      label: 'COMMONWEALTH TPA SOLUTIONS LLC',
      value: 'COMMONWEALTH TPA SOLUTIONS LLC',
      planCount: 1,
      selected: false,
      assets: '',
    },
    {
      id: 895,
      tpaID: '232932984',
      tpaName: 'BAKER TILLY VANTAGEN, LLC',
      label: 'BAKER TILLY VANTAGEN, LLC',
      value: 'BAKER TILLY VANTAGEN, LLC',
      planCount: 1,
      selected: false,
      assets: '',
    },
    {
      id: 895,
      tpaID: '870357392',
      tpaName: 'DAVIS & BOTT CERTIFIED PUBLIC ACCOUNTANTS',
      label: 'DAVIS & BOTT CERTIFIED PUBLIC ACCOUNTANTS',
      value: 'DAVIS & BOTT CERTIFIED PUBLIC ACCOUNTANTS',
      planCount: 1,
      selected: false,
      assets: '',
    },
    {
      id: 896,
      tpaID: '52-2290047',
      tpaName: '401KINABOX',
      label: '401KINABOX',
      value: '401KINABOX',
      planCount: 1,
      selected: false,
      assets: '',
    },
    {
      id: 897,
      tpaID: '34-1853512',
      tpaName: 'NATIONAL ASSOCIATES, INC.',
      label: 'NATIONAL ASSOCIATES, INC.',
      value: 'NATIONAL ASSOCIATES, INC.',
      planCount: 1,
      selected: false,
      assets: '',
    },
    {
      id: 898,
      tpaID: '74-2533381',
      tpaName: 'RESOURCE BENEFITS ADMINISTRATORS, INC.',
      label: 'RESOURCE BENEFITS ADMINISTRATORS, INC.',
      value: 'RESOURCE BENEFITS ADMINISTRATORS, INC.',
      planCount: 1,
      selected: false,
      assets: '',
    },
    {
      id: 899,
      tpaID: '382781642',
      tpaName: 'MICHIGAN PENSION GROUP, INC.',
      label: 'MICHIGAN PENSION GROUP, INC.',
      value: 'MICHIGAN PENSION GROUP, INC.',
      planCount: 1,
      selected: false,
      assets: '',
    },
    {
      id: 900,
      tpaID: '854166502',
      tpaName: 'MOMENTA, INC.',
      label: 'MOMENTA, INC.',
      value: 'MOMENTA, INC.',
      planCount: 1,
      selected: false,
      assets: '',
    },
    {
      id: 901,
      tpaID: 'W85U2862G',
      tpaName: 'TRIDENT RETIREMENT SERVICES, LLC',
      label: 'TRIDENT RETIREMENT SERVICES, LLC',
      value: 'TRIDENT RETIREMENT SERVICES, LLC',
      planCount: 1,
      selected: false,
      assets: '',
    },
    {
      id: 902,
      tpaID: '990493155',
      tpaName: 'ERA ADMIN',
      label: 'ERA ADMIN',
      value: 'ERA ADMIN',
      planCount: 1,
      selected: false,
      assets: '',
    },
    {
      id: 903,
      tpaID: '621417683',
      tpaName: 'ELLIS AND WARD CONSULTING GROUP, INC.',
      label: 'ELLIS AND WARD CONSULTING GROUP, INC.',
      value: 'ELLIS AND WARD CONSULTING GROUP, INC.',
      planCount: 1,
      selected: false,
      assets: '',
    },
    {
      id: 999,
      tpaID: '',
      label: "My firm isn't listed",
      value: 'myFirmIsntListed',
      selected: false,
    },
  ],
};
